var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/llm/ErrorAnalyzerAst.ts
import { Ast, Input, Node, Output, State, IS_MULTI } from "@sker/workflow";
function _ts_decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate, "_ts_decorate");
function _ts_metadata(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata, "_ts_metadata");
var ErrorAnalyzerAst = class extends Ast {
  static {
    __name(this, "ErrorAnalyzerAst");
  }
  steps = [];
  temperature = 0.3;
  model = "deepseek-ai/DeepSeek-V3.2";
  recap = ``;
  blame = ``;
  improvement = ``;
  type = "ErrorAnalyzerAst";
};
_ts_decorate([
  Input({
    title: "\u6B65\u9AA4\u65E5\u5FD7",
    type: "textarea",
    mode: IS_MULTI,
    defaultValue: []
  }),
  _ts_metadata("design:type", Array)
], ErrorAnalyzerAst.prototype, "steps", void 0);
_ts_decorate([
  State({
    title: "\u6E29\u5EA6"
  }),
  _ts_metadata("design:type", Number)
], ErrorAnalyzerAst.prototype, "temperature", void 0);
_ts_decorate([
  State({
    title: "\u6A21\u578B"
  }),
  _ts_metadata("design:type", String)
], ErrorAnalyzerAst.prototype, "model", void 0);
_ts_decorate([
  Output({
    title: "\u603B\u7ED3",
    defaultValue: ""
  })
], ErrorAnalyzerAst.prototype, "recap", void 0);
_ts_decorate([
  Output({
    title: "\u9519\u8BEF\u5B9A\u4F4D",
    defaultValue: ""
  })
], ErrorAnalyzerAst.prototype, "blame", void 0);
_ts_decorate([
  Output({
    title: "\u6539\u8FDB\u5EFA\u8BAE",
    defaultValue: ""
  })
], ErrorAnalyzerAst.prototype, "improvement", void 0);
ErrorAnalyzerAst = _ts_decorate([
  Node({
    title: "\u9519\u8BEF\u5206\u6790\u5668",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 2,
    retryDelay: 1e3,
    retryBackoff: 1.5
  })
], ErrorAnalyzerAst);

// src/llm/GroupChatLoopAst.ts
import { Ast as Ast2, Input as Input2, IS_MULTI as IS_MULTI2, IS_BUFFER, Node as Node2, Output as Output2 } from "@sker/workflow";
function _ts_decorate2(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate2, "_ts_decorate");
function _ts_metadata2(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata2, "_ts_metadata");
var GroupChatLoopAst = class extends Ast2 {
  static {
    __name(this, "GroupChatLoopAst");
  }
  // === 输入配置 ===
  initialTopic = "\u8BA8\u8BBA\u4EBA\u5DE5\u667A\u80FD\u7684\u672A\u6765\u53D1\u5C55";
  newMessages = [];
  maxRounds = 10;
  // === 运行时状态 ===
  chatHistory = [];
  historyText = "";
  currentRound = 0;
  type = `GroupChatLoopAst`;
};
_ts_decorate2([
  Input2({
    title: "\u521D\u59CB\u8BDD\u9898",
    defaultValue: "\u8BA8\u8BBA\u4EBA\u5DE5\u667A\u80FD\u7684\u672A\u6765\u53D1\u5C55"
  }),
  _ts_metadata2("design:type", String)
], GroupChatLoopAst.prototype, "initialTopic", void 0);
_ts_decorate2([
  Input2({
    mode: IS_BUFFER | IS_MULTI2,
    title: "\u65B0\u6D88\u606F",
    defaultValue: []
  }),
  _ts_metadata2("design:type", Array)
], GroupChatLoopAst.prototype, "newMessages", void 0);
_ts_decorate2([
  Input2({
    title: "\u6700\u5927\u8F6E\u6570",
    defaultValue: 10
  }),
  _ts_metadata2("design:type", Number)
], GroupChatLoopAst.prototype, "maxRounds", void 0);
_ts_decorate2([
  Output2({
    title: "\u5BF9\u8BDD\u5386\u53F2\uFF08\u6570\u7EC4\uFF09",
    defaultValue: []
  }),
  _ts_metadata2("design:type", Array)
], GroupChatLoopAst.prototype, "chatHistory", void 0);
_ts_decorate2([
  Output2({
    title: "\u5BF9\u8BDD\u5386\u53F2\uFF08\u6587\u672C\uFF09",
    defaultValue: ""
  })
], GroupChatLoopAst.prototype, "historyText", void 0);
_ts_decorate2([
  Output2({
    title: "\u5F53\u524D\u8F6E\u6B21",
    defaultValue: 0
  })
], GroupChatLoopAst.prototype, "currentRound", void 0);
GroupChatLoopAst = _ts_decorate2([
  Node2({
    type: "llm",
    title: "\u5FAA\u73AF\u7FA4\u804A"
  })
], GroupChatLoopAst);

// src/llm/LlmTextAgentAst.ts
import { Ast as Ast3, Input as Input3, IS_MULTI as IS_MULTI3, Node as Node3, Output as Output3 } from "@sker/workflow";
function _ts_decorate3(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate3, "_ts_decorate");
function _ts_metadata3(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata3, "_ts_metadata");
var LlmTextAgentAst = class extends Ast3 {
  static {
    __name(this, "LlmTextAgentAst");
  }
  system = [];
  prompt = [];
  temperature = 0.5;
  model = `deepseek-ai/DeepSeek-V3.2`;
  text = ``;
  username = ``;
  profile = ``;
  type = `LlmTextAgentAst`;
};
_ts_decorate3([
  Input3({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD",
    type: "textarea",
    mode: IS_MULTI3,
    defaultValue: []
  }),
  _ts_metadata3("design:type", Array)
], LlmTextAgentAst.prototype, "system", void 0);
_ts_decorate3([
  Input3({
    title: "\u7528\u6237\u63D0\u793A\u8BCD",
    type: "textarea",
    mode: IS_MULTI3,
    defaultValue: []
  }),
  _ts_metadata3("design:type", Array)
], LlmTextAgentAst.prototype, "prompt", void 0);
_ts_decorate3([
  Input3({
    title: "\u6E29\u5EA6",
    defaultValue: 0.5
  }),
  _ts_metadata3("design:type", Number)
], LlmTextAgentAst.prototype, "temperature", void 0);
_ts_decorate3([
  Input3({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata3("design:type", String)
], LlmTextAgentAst.prototype, "model", void 0);
_ts_decorate3([
  Output3({
    title: "\u8F93\u51FA",
    defaultValue: ""
  })
], LlmTextAgentAst.prototype, "text", void 0);
_ts_decorate3([
  Output3({
    title: "\u8282\u70B9\u540D",
    defaultValue: ""
  })
], LlmTextAgentAst.prototype, "username", void 0);
_ts_decorate3([
  Output3({
    title: "\u8282\u70B9\u4ECB\u7ECD",
    defaultValue: ""
  })
], LlmTextAgentAst.prototype, "profile", void 0);
LlmTextAgentAst = _ts_decorate3([
  Node3({
    title: "\u6587\u5B57\u5927\u6A21\u578B",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 5,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], LlmTextAgentAst);

// src/llm/CodeGeneratorAst.ts
import { Ast as Ast4, Input as Input4, IS_MULTI as IS_MULTI4, Node as Node4, Output as Output4, State as State2 } from "@sker/workflow";
function _ts_decorate4(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate4, "_ts_decorate");
function _ts_metadata4(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata4, "_ts_metadata");
var CodeGeneratorAst = class extends Ast4 {
  static {
    __name(this, "CodeGeneratorAst");
  }
  tasks = [];
  techStack = "";
  context = [];
  existingCode = [];
  temperature = 0.2;
  model = "deepseek-ai/DeepSeek-V3.2";
  currentTaskIndex = 0;
  generatedCode = "";
  filePath = "";
  operation = "create";
  isComplete = false;
  type = "CodeGeneratorAst";
};
_ts_decorate4([
  Input4({
    title: "\u4EFB\u52A1\u63CF\u8FF0",
    type: "textarea",
    mode: IS_MULTI4,
    defaultValue: []
  }),
  _ts_metadata4("design:type", Array)
], CodeGeneratorAst.prototype, "tasks", void 0);
_ts_decorate4([
  Input4({
    title: "\u6280\u672F\u6808",
    type: "text",
    defaultValue: ""
  }),
  _ts_metadata4("design:type", String)
], CodeGeneratorAst.prototype, "techStack", void 0);
_ts_decorate4([
  Input4({
    title: "\u9879\u76EE\u4E0A\u4E0B\u6587",
    type: "textarea",
    mode: IS_MULTI4,
    defaultValue: []
  }),
  _ts_metadata4("design:type", Array)
], CodeGeneratorAst.prototype, "context", void 0);
_ts_decorate4([
  Input4({
    title: "\u73B0\u6709\u4EE3\u7801",
    type: "textarea",
    mode: IS_MULTI4,
    defaultValue: []
  }),
  _ts_metadata4("design:type", Array)
], CodeGeneratorAst.prototype, "existingCode", void 0);
_ts_decorate4([
  Input4({
    title: "\u6E29\u5EA6",
    defaultValue: 0.2
  }),
  _ts_metadata4("design:type", Number)
], CodeGeneratorAst.prototype, "temperature", void 0);
_ts_decorate4([
  Input4({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata4("design:type", String)
], CodeGeneratorAst.prototype, "model", void 0);
_ts_decorate4([
  State2({
    title: "\u5F53\u524D\u4EFB\u52A1\u7D22\u5F15"
  }),
  _ts_metadata4("design:type", Number)
], CodeGeneratorAst.prototype, "currentTaskIndex", void 0);
_ts_decorate4([
  Output4({
    title: "\u751F\u6210\u7684\u4EE3\u7801",
    defaultValue: ""
  }),
  _ts_metadata4("design:type", String)
], CodeGeneratorAst.prototype, "generatedCode", void 0);
_ts_decorate4([
  Output4({
    title: "\u6587\u4EF6\u8DEF\u5F84",
    defaultValue: ""
  }),
  _ts_metadata4("design:type", String)
], CodeGeneratorAst.prototype, "filePath", void 0);
_ts_decorate4([
  Output4({
    title: "\u64CD\u4F5C\u7C7B\u578B",
    defaultValue: "create"
  }),
  _ts_metadata4("design:type", String)
], CodeGeneratorAst.prototype, "operation", void 0);
_ts_decorate4([
  Output4({
    title: "\u662F\u5426\u5B8C\u6210",
    defaultValue: false
  }),
  _ts_metadata4("design:type", Boolean)
], CodeGeneratorAst.prototype, "isComplete", void 0);
CodeGeneratorAst = _ts_decorate4([
  Node4({
    title: "\u4EE3\u7801\u751F\u6210\u5668",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], CodeGeneratorAst);

// src/llm/StoryWeaverAst.ts
import { Ast as Ast5, Input as Input5, IS_MULTI as IS_MULTI5, Node as Node5, Output as Output5 } from "@sker/workflow";
function _ts_decorate5(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate5, "_ts_decorate");
function _ts_metadata5(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata5, "_ts_metadata");
var StoryWeaverAst = class extends Ast5 {
  static {
    __name(this, "StoryWeaverAst");
  }
  prompt = "";
  style = "\u8F7B\u677E\u5E7D\u9ED8\u3001\u8282\u594F\u660E\u5FEB";
  wordCount = 1e3;
  model = "deepseek-ai/DeepSeek-V3.2";
  temperature = 0.8;
  enableQualityCheck = true;
  minQualityScore = 70;
  maxRewriteRetries = 2;
  targetChapterCount = 10;
  previousChapters = [];
  title = "";
  summary = "";
  content = "";
  chapterNumber = 0;
  chapterData = null;
  nextPrompt = "";
  isComplete = false;
  type = "StoryWeaverAst";
};
_ts_decorate5([
  Input5({
    title: "\u521B\u4F5C\u63D0\u793A",
    type: "textarea",
    mode: IS_MULTI5,
    defaultValue: ""
  }),
  _ts_metadata5("design:type", String)
], StoryWeaverAst.prototype, "prompt", void 0);
_ts_decorate5([
  Input5({
    title: "\u5199\u4F5C\u98CE\u683C",
    type: "text",
    defaultValue: "\u8F7B\u677E\u5E7D\u9ED8\u3001\u8282\u594F\u660E\u5FEB"
  }),
  _ts_metadata5("design:type", String)
], StoryWeaverAst.prototype, "style", void 0);
_ts_decorate5([
  Input5({
    title: "\u5B57\u6570\u8981\u6C42",
    type: "number",
    defaultValue: 1500
  }),
  _ts_metadata5("design:type", Number)
], StoryWeaverAst.prototype, "wordCount", void 0);
_ts_decorate5([
  Input5({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata5("design:type", String)
], StoryWeaverAst.prototype, "model", void 0);
_ts_decorate5([
  Input5({
    title: "\u6E29\u5EA6",
    defaultValue: 0.8
  }),
  _ts_metadata5("design:type", Number)
], StoryWeaverAst.prototype, "temperature", void 0);
_ts_decorate5([
  Input5({
    title: "\u542F\u7528\u8D28\u68C0",
    type: "boolean",
    defaultValue: true
  }),
  _ts_metadata5("design:type", Boolean)
], StoryWeaverAst.prototype, "enableQualityCheck", void 0);
_ts_decorate5([
  Input5({
    title: "\u6700\u4F4E\u8D28\u91CF\u5206\u6570",
    type: "number",
    defaultValue: 70
  }),
  _ts_metadata5("design:type", Number)
], StoryWeaverAst.prototype, "minQualityScore", void 0);
_ts_decorate5([
  Input5({
    title: "\u6700\u5927\u91CD\u5199\u6B21\u6570",
    type: "number",
    defaultValue: 2
  }),
  _ts_metadata5("design:type", Number)
], StoryWeaverAst.prototype, "maxRewriteRetries", void 0);
_ts_decorate5([
  Input5({
    title: "\u76EE\u6807\u7AE0\u8282\u6570",
    type: "number",
    defaultValue: 10
  }),
  _ts_metadata5("design:type", Number)
], StoryWeaverAst.prototype, "targetChapterCount", void 0);
_ts_decorate5([
  Output5({
    title: "\u524D\u6587\u7AE0\u8282\uFF08\u81EA\u52A8\u7D2F\u79EF\uFF09",
    defaultValue: []
  }),
  _ts_metadata5("design:type", Array)
], StoryWeaverAst.prototype, "previousChapters", void 0);
_ts_decorate5([
  Output5({
    title: "\u7AE0\u8282\u6807\u9898",
    defaultValue: ""
  })
], StoryWeaverAst.prototype, "title", void 0);
_ts_decorate5([
  Output5({
    title: "\u7AE0\u8282\u7B80\u4ECB",
    defaultValue: ""
  })
], StoryWeaverAst.prototype, "summary", void 0);
_ts_decorate5([
  Output5({
    title: "\u7AE0\u8282\u5185\u5BB9",
    defaultValue: ""
  })
], StoryWeaverAst.prototype, "content", void 0);
_ts_decorate5([
  Output5({
    title: "\u7AE0\u8282\u53F7",
    defaultValue: 0
  })
], StoryWeaverAst.prototype, "chapterNumber", void 0);
_ts_decorate5([
  Output5({
    title: "\u7AE0\u8282\u6570\u636E",
    defaultValue: null
  }),
  _ts_metadata5("design:type", Object)
], StoryWeaverAst.prototype, "chapterData", void 0);
_ts_decorate5([
  Output5({
    title: "\u7EE7\u7EED\u751F\u6210\uFF08\u5FAA\u73AF\u89E6\u53D1\uFF09",
    defaultValue: "",
    isRouter: true
  }),
  _ts_metadata5("design:type", String)
], StoryWeaverAst.prototype, "nextPrompt", void 0);
_ts_decorate5([
  Output5({
    title: "\u751F\u6210\u5B8C\u6210",
    defaultValue: false
  }),
  _ts_metadata5("design:type", Boolean)
], StoryWeaverAst.prototype, "isComplete", void 0);
StoryWeaverAst = _ts_decorate5([
  Node5({
    title: "\u6545\u4E8B\u7F16\u7EC7\u8005",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2,
    stateful: true
  })
], StoryWeaverAst);

// src/llm/LlmTextImage2ToVideoAst.ts
import { Ast as Ast6, Input as Input6, IS_BUFFER as IS_BUFFER2, IS_MULTI as IS_MULTI6, Node as Node6, Output as Output6 } from "@sker/workflow";
function _ts_decorate6(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate6, "_ts_decorate");
function _ts_metadata6(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata6, "_ts_metadata");
var LlmTextImage2ToVideoAst = class extends Ast6 {
  static {
    __name(this, "LlmTextImage2ToVideoAst");
  }
  prompt = [];
  first_image = ``;
  last_image = ``;
  video = ``;
  type = `LlmTextImage2ToVideoAst`;
};
_ts_decorate6([
  Input6({
    mode: IS_MULTI6 | IS_BUFFER2,
    title: "\u6587\u672C",
    defaultValue: []
  }),
  _ts_metadata6("design:type", Array)
], LlmTextImage2ToVideoAst.prototype, "prompt", void 0);
_ts_decorate6([
  Input6({
    title: "\u9996\u5E27\u56FE",
    defaultValue: ""
  }),
  _ts_metadata6("design:type", String)
], LlmTextImage2ToVideoAst.prototype, "first_image", void 0);
_ts_decorate6([
  Input6({
    title: "\u5C3E\u5E27\u56FE",
    defaultValue: ""
  }),
  _ts_metadata6("design:type", String)
], LlmTextImage2ToVideoAst.prototype, "last_image", void 0);
_ts_decorate6([
  Output6({
    title: "\u89C6\u9891",
    defaultValue: ""
  })
], LlmTextImage2ToVideoAst.prototype, "video", void 0);
LlmTextImage2ToVideoAst = _ts_decorate6([
  Node6({
    title: "\u9996\u5C3E\u5E27\u89C6\u9891",
    type: "llm"
  })
], LlmTextImage2ToVideoAst);

// src/llm/LlmTextImageToVideoAst.ts
import { Ast as Ast7, Input as Input7, IS_BUFFER as IS_BUFFER3, IS_MULTI as IS_MULTI7, Node as Node7, Output as Output7 } from "@sker/workflow";
function _ts_decorate7(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate7, "_ts_decorate");
function _ts_metadata7(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata7, "_ts_metadata");
var LlmTextImageToVideoAst = class extends Ast7 {
  static {
    __name(this, "LlmTextImageToVideoAst");
  }
  prompt = [];
  images = [];
  video = ``;
  type = `LlmTextImageToVideoAst`;
};
_ts_decorate7([
  Input7({
    mode: IS_MULTI7 | IS_BUFFER3,
    title: "\u6587\u672C",
    defaultValue: []
  }),
  _ts_metadata7("design:type", Array)
], LlmTextImageToVideoAst.prototype, "prompt", void 0);
_ts_decorate7([
  Input7({
    mode: IS_MULTI7 | IS_BUFFER3,
    title: "\u56FE\u7247",
    defaultValue: []
  }),
  _ts_metadata7("design:type", Array)
], LlmTextImageToVideoAst.prototype, "images", void 0);
_ts_decorate7([
  Output7({
    title: "\u89C6\u9891",
    defaultValue: ""
  })
], LlmTextImageToVideoAst.prototype, "video", void 0);
LlmTextImageToVideoAst = _ts_decorate7([
  Node7({
    title: "\u591A\u56FE\u751F\u89C6\u9891",
    type: "llm"
  })
], LlmTextImageToVideoAst);

// src/llm/LlmTextToAudioAst.ts
import { Ast as Ast8, Input as Input8, IS_BUFFER as IS_BUFFER4, IS_MULTI as IS_MULTI8, Node as Node8, Output as Output8 } from "@sker/workflow";
function _ts_decorate8(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate8, "_ts_decorate");
function _ts_metadata8(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata8, "_ts_metadata");
var LlmTextToAudioAst = class extends Ast8 {
  static {
    __name(this, "LlmTextToAudioAst");
  }
  text = [];
  audio = ``;
  type = `LlmTextToAudioAst`;
};
_ts_decorate8([
  Input8({
    title: "\u6587\u672C",
    mode: IS_BUFFER4 | IS_MULTI8,
    defaultValue: []
  }),
  _ts_metadata8("design:type", Array)
], LlmTextToAudioAst.prototype, "text", void 0);
_ts_decorate8([
  Output8({
    title: "\u97F3\u9891",
    defaultValue: ""
  })
], LlmTextToAudioAst.prototype, "audio", void 0);
LlmTextToAudioAst = _ts_decorate8([
  Node8({
    title: "\u8BED\u97F3\u5408\u6210",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 5,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], LlmTextToAudioAst);

// src/llm/LlmTextToImageAst.ts
import { Ast as Ast9, Input as Input9, IS_BUFFER as IS_BUFFER5, IS_MULTI as IS_MULTI9, Node as Node9, Output as Output9 } from "@sker/workflow";
function _ts_decorate9(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate9, "_ts_decorate");
function _ts_metadata9(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata9, "_ts_metadata");
var LlmTextToImageAst = class extends Ast9 {
  static {
    __name(this, "LlmTextToImageAst");
  }
  text = [];
  image = ``;
  type = `LlmTextToImageAst`;
};
_ts_decorate9([
  Input9({
    mode: IS_MULTI9 | IS_BUFFER5,
    title: "\u6587\u672C",
    defaultValue: []
  }),
  _ts_metadata9("design:type", Array)
], LlmTextToImageAst.prototype, "text", void 0);
_ts_decorate9([
  Output9({
    title: "\u56FE\u7247",
    defaultValue: ""
  })
], LlmTextToImageAst.prototype, "image", void 0);
LlmTextToImageAst = _ts_decorate9([
  Node9({
    title: "\u6587\u751F\u56FE",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 5,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], LlmTextToImageAst);

// src/llm/LlmTextToVideoAst.ts
import { Ast as Ast10, Input as Input10, IS_BUFFER as IS_BUFFER6, IS_MULTI as IS_MULTI10, Node as Node10, Output as Output10 } from "@sker/workflow";
function _ts_decorate10(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate10, "_ts_decorate");
function _ts_metadata10(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata10, "_ts_metadata");
var LlmTextToVideoAst = class extends Ast10 {
  static {
    __name(this, "LlmTextToVideoAst");
  }
  prompt = [];
  video = ``;
  type = `LlmTextToVideoAst`;
};
_ts_decorate10([
  Input10({
    mode: IS_MULTI10 | IS_BUFFER6,
    title: "\u6587\u672C",
    defaultValue: []
  }),
  _ts_metadata10("design:type", Array)
], LlmTextToVideoAst.prototype, "prompt", void 0);
_ts_decorate10([
  Output10({
    title: "\u89C6\u9891",
    defaultValue: ""
  })
], LlmTextToVideoAst.prototype, "video", void 0);
LlmTextToVideoAst = _ts_decorate10([
  Node10({
    title: "\u6587\u751F\u89C6\u9891",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 5,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], LlmTextToVideoAst);

// src/llm/WorkflowNodeGeneratorAst.ts
import { Ast as Ast11, Input as Input11, Node as Node11, Output as Output11 } from "@sker/workflow";
function _ts_decorate11(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate11, "_ts_decorate");
function _ts_metadata11(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata11, "_ts_metadata");
var WorkflowNodeGeneratorAst = class extends Ast11 {
  static {
    __name(this, "WorkflowNodeGeneratorAst");
  }
  nodeDescription = "";
  nodeType = "basic";
  nodeName = "";
  model = "deepseek-ai/DeepSeek-V3.2";
  astCode = "";
  visitorCode = "";
  success = false;
  type = "WorkflowNodeGeneratorAst";
};
_ts_decorate11([
  Input11({
    title: "\u8282\u70B9\u529F\u80FD\u63CF\u8FF0",
    type: "textarea",
    defaultValue: ""
  }),
  _ts_metadata11("design:type", String)
], WorkflowNodeGeneratorAst.prototype, "nodeDescription", void 0);
_ts_decorate11([
  Input11({
    title: "\u8282\u70B9\u7C7B\u578B",
    type: "select",
    defaultValue: "basic"
  }),
  _ts_metadata11("design:type", String)
], WorkflowNodeGeneratorAst.prototype, "nodeType", void 0);
_ts_decorate11([
  Input11({
    title: "\u8282\u70B9\u540D\u79F0",
    type: "text",
    defaultValue: ""
  }),
  _ts_metadata11("design:type", String)
], WorkflowNodeGeneratorAst.prototype, "nodeName", void 0);
_ts_decorate11([
  Input11({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata11("design:type", String)
], WorkflowNodeGeneratorAst.prototype, "model", void 0);
_ts_decorate11([
  Output11({
    title: "AST \u4EE3\u7801",
    defaultValue: ""
  })
], WorkflowNodeGeneratorAst.prototype, "astCode", void 0);
_ts_decorate11([
  Output11({
    title: "Visitor \u4EE3\u7801",
    defaultValue: ""
  })
], WorkflowNodeGeneratorAst.prototype, "visitorCode", void 0);
_ts_decorate11([
  Output11({
    title: "\u751F\u6210\u6210\u529F",
    defaultValue: false
  })
], WorkflowNodeGeneratorAst.prototype, "success", void 0);
WorkflowNodeGeneratorAst = _ts_decorate11([
  Node11({
    title: "\u5DE5\u4F5C\u6D41\u8282\u70B9\u751F\u6210\u5668",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], WorkflowNodeGeneratorAst);

// src/llm/PromptOptimizerAst.ts
import { Ast as Ast12, Input as Input12, Node as Node12, Output as Output12, State as State3 } from "@sker/workflow";
function _ts_decorate12(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate12, "_ts_decorate");
function _ts_metadata12(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata12, "_ts_metadata");
var PromptOptimizerAst = class extends Ast12 {
  static {
    __name(this, "PromptOptimizerAst");
  }
  // === 核心输入 ===
  targetOutput = "";
  targetContext = "";
  initialPrompt = "";
  // === 优化配置 ===
  maxIterations = 5;
  targetScore = 85;
  testRuns = 3;
  evaluationDimensions = [
    {
      name: "\u8BED\u4E49\u76F8\u4F3C\u5EA6",
      weight: 0.4,
      description: "\u8F93\u51FA\u4E0E\u76EE\u6807\u7684\u8BED\u4E49\u5339\u914D\u7A0B\u5EA6"
    },
    {
      name: "\u683C\u5F0F\u5339\u914D",
      weight: 0.3,
      description: "\u8F93\u51FA\u683C\u5F0F\u662F\u5426\u7B26\u5408\u76EE\u6807\u683C\u5F0F"
    },
    {
      name: "\u5173\u952E\u8BCD\u8986\u76D6",
      weight: 0.3,
      description: "\u662F\u5426\u5305\u542B\u76EE\u6807\u4E2D\u7684\u5173\u952E\u4FE1\u606F"
    }
  ];
  // === LLM 配置 ===
  generatorModel = "deepseek-ai/DeepSeek-V3.2";
  testerModel = "deepseek-ai/DeepSeek-V3.2";
  evaluatorModel = "deepseek-ai/DeepSeek-V3.2";
  generatorTemperature = 0.7;
  testerTemperature = 0.3;
  evaluatorTemperature = 0.2;
  // === 运行时状态 ===
  currentIteration = 0;
  versionHistory = [];
  // === 输出 ===
  result = null;
  bestPrompt = "";
  bestScore = 0;
  success = false;
  type = "PromptOptimizerAst";
};
_ts_decorate12([
  Input12({
    title: "\u76EE\u6807\u8F93\u51FA",
    type: "textarea",
    defaultValue: ""
  }),
  _ts_metadata12("design:type", String)
], PromptOptimizerAst.prototype, "targetOutput", void 0);
_ts_decorate12([
  Input12({
    title: "\u76EE\u6807\u4E0A\u4E0B\u6587",
    type: "textarea",
    defaultValue: ""
  }),
  _ts_metadata12("design:type", String)
], PromptOptimizerAst.prototype, "targetContext", void 0);
_ts_decorate12([
  Input12({
    title: "\u521D\u59CB\u63D0\u793A\u8BCD",
    type: "textarea",
    defaultValue: ""
  }),
  _ts_metadata12("design:type", String)
], PromptOptimizerAst.prototype, "initialPrompt", void 0);
_ts_decorate12([
  Input12({
    title: "\u6700\u5927\u8FED\u4EE3\u6B21\u6570",
    type: "number",
    defaultValue: 5
  }),
  _ts_metadata12("design:type", Number)
], PromptOptimizerAst.prototype, "maxIterations", void 0);
_ts_decorate12([
  Input12({
    title: "\u76EE\u6807\u5206\u6570",
    type: "number",
    defaultValue: 85
  }),
  _ts_metadata12("design:type", Number)
], PromptOptimizerAst.prototype, "targetScore", void 0);
_ts_decorate12([
  Input12({
    title: "\u6BCF\u8F6E\u6D4B\u8BD5\u6B21\u6570",
    type: "number",
    defaultValue: 3
  }),
  _ts_metadata12("design:type", Number)
], PromptOptimizerAst.prototype, "testRuns", void 0);
_ts_decorate12([
  Input12({
    title: "\u8BC4\u4F30\u7EF4\u5EA6",
    type: "object",
    defaultValue: [
      {
        name: "\u8BED\u4E49\u76F8\u4F3C\u5EA6",
        weight: 0.4,
        description: "\u8F93\u51FA\u4E0E\u76EE\u6807\u7684\u8BED\u4E49\u5339\u914D\u7A0B\u5EA6"
      },
      {
        name: "\u683C\u5F0F\u5339\u914D",
        weight: 0.3,
        description: "\u8F93\u51FA\u683C\u5F0F\u662F\u5426\u7B26\u5408\u76EE\u6807\u683C\u5F0F"
      },
      {
        name: "\u5173\u952E\u8BCD\u8986\u76D6",
        weight: 0.3,
        description: "\u662F\u5426\u5305\u542B\u76EE\u6807\u4E2D\u7684\u5173\u952E\u4FE1\u606F"
      }
    ]
  }),
  _ts_metadata12("design:type", Array)
], PromptOptimizerAst.prototype, "evaluationDimensions", void 0);
_ts_decorate12([
  Input12({
    title: "\u751F\u6210\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata12("design:type", String)
], PromptOptimizerAst.prototype, "generatorModel", void 0);
_ts_decorate12([
  Input12({
    title: "\u6D4B\u8BD5\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata12("design:type", String)
], PromptOptimizerAst.prototype, "testerModel", void 0);
_ts_decorate12([
  Input12({
    title: "\u8BC4\u4F30\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata12("design:type", String)
], PromptOptimizerAst.prototype, "evaluatorModel", void 0);
_ts_decorate12([
  Input12({
    title: "\u751F\u6210\u6E29\u5EA6",
    type: "number",
    defaultValue: 0.7
  }),
  _ts_metadata12("design:type", Number)
], PromptOptimizerAst.prototype, "generatorTemperature", void 0);
_ts_decorate12([
  Input12({
    title: "\u6D4B\u8BD5\u6E29\u5EA6",
    type: "number",
    defaultValue: 0.3
  }),
  _ts_metadata12("design:type", Number)
], PromptOptimizerAst.prototype, "testerTemperature", void 0);
_ts_decorate12([
  Input12({
    title: "\u8BC4\u4F30\u6E29\u5EA6",
    type: "number",
    defaultValue: 0.2
  }),
  _ts_metadata12("design:type", Number)
], PromptOptimizerAst.prototype, "evaluatorTemperature", void 0);
_ts_decorate12([
  State3({
    title: "\u5F53\u524D\u8FED\u4EE3"
  }),
  _ts_metadata12("design:type", Number)
], PromptOptimizerAst.prototype, "currentIteration", void 0);
_ts_decorate12([
  State3({
    title: "\u7248\u672C\u5386\u53F2"
  }),
  _ts_metadata12("design:type", Array)
], PromptOptimizerAst.prototype, "versionHistory", void 0);
_ts_decorate12([
  Output12({
    title: "\u4F18\u5316\u7ED3\u679C",
    defaultValue: null
  }),
  _ts_metadata12("design:type", Object)
], PromptOptimizerAst.prototype, "result", void 0);
_ts_decorate12([
  Output12({
    title: "\u6700\u4F18\u63D0\u793A\u8BCD",
    defaultValue: ""
  }),
  _ts_metadata12("design:type", String)
], PromptOptimizerAst.prototype, "bestPrompt", void 0);
_ts_decorate12([
  Output12({
    title: "\u6700\u4F18\u5206\u6570",
    defaultValue: 0
  }),
  _ts_metadata12("design:type", Number)
], PromptOptimizerAst.prototype, "bestScore", void 0);
_ts_decorate12([
  Output12({
    title: "\u662F\u5426\u6210\u529F",
    defaultValue: false
  }),
  _ts_metadata12("design:type", Boolean)
], PromptOptimizerAst.prototype, "success", void 0);
PromptOptimizerAst = _ts_decorate12([
  Node12({
    title: "\u63D0\u793A\u8BCD\u4F18\u5316\u5668",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 2,
    retryDelay: 2e3,
    retryBackoff: 1.5
  })
], PromptOptimizerAst);

// src/llm/QualityCheckerAst.ts
import { Ast as Ast13, Input as Input13, Node as Node13, Output as Output13 } from "@sker/workflow";
function _ts_decorate13(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate13, "_ts_decorate");
function _ts_metadata13(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata13, "_ts_metadata");
var QualityCheckerAst = class extends Ast13 {
  static {
    __name(this, "QualityCheckerAst");
  }
  // === 输入 ===
  chapter = null;
  minScore = 70;
  dimensions = [];
  model = "deepseek-ai/DeepSeek-V3.2";
  temperature = 0.3;
  // === 输出 ===
  result = null;
  score = 0;
  passed = false;
  type = "QualityCheckerAst";
};
_ts_decorate13([
  Input13({
    title: "\u7AE0\u8282\u6570\u636E",
    defaultValue: null
  }),
  _ts_metadata13("design:type", Object)
], QualityCheckerAst.prototype, "chapter", void 0);
_ts_decorate13([
  Input13({
    title: "\u6700\u4F4E\u5206\u6570",
    type: "number",
    defaultValue: 70
  }),
  _ts_metadata13("design:type", Number)
], QualityCheckerAst.prototype, "minScore", void 0);
_ts_decorate13([
  Input13({
    title: "\u8BC4\u4F30\u7EF4\u5EA6",
    type: "object",
    defaultValue: [
      {
        name: "\u5B57\u6570\u8FBE\u6807",
        weight: 0.15,
        description: "\u5B57\u6570\u662F\u5426\u7B26\u5408\u8981\u6C42\uFF0C\u504F\u5DEE\u4E0D\u8D85\u8FC7\xB120%"
      },
      {
        name: "\u60C5\u8282\u63A8\u8FDB",
        weight: 0.25,
        description: "\u662F\u5426\u6709\u5B9E\u8D28\u6027\u60C5\u8282\u63A8\u8FDB\uFF0C\u907F\u514D\u539F\u5730\u8E0F\u6B65"
      },
      {
        name: "\u4EBA\u7269\u523B\u753B",
        weight: 0.2,
        description: '\u4EBA\u7269\u662F\u5426\u6709\u72B6\u6001\u53D8\u5316\uFF0C\u907F\u514D\u6CA6\u4E3A"\u53CD\u5E94\u673A\u5668"'
      },
      {
        name: "\u6587\u7B14\u8D28\u91CF",
        weight: 0.2,
        description: "\u8BED\u8A00\u6D41\u7545\u5EA6\u3001\u7EC6\u8282\u63CF\u5199\u3001\u6C1B\u56F4\u8425\u9020"
      },
      {
        name: "\u903B\u8F91\u4E00\u81F4",
        weight: 0.2,
        description: "\u4E16\u754C\u89C2\u3001\u8BBE\u5B9A\u3001\u4EBA\u7269\u80FD\u529B\u662F\u5426\u4FDD\u6301\u4E00\u81F4"
      }
    ]
  }),
  _ts_metadata13("design:type", typeof Array === "undefined" ? Object : Array)
], QualityCheckerAst.prototype, "dimensions", void 0);
_ts_decorate13([
  Input13({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata13("design:type", String)
], QualityCheckerAst.prototype, "model", void 0);
_ts_decorate13([
  Input13({
    title: "\u6E29\u5EA6",
    defaultValue: 0.3
  }),
  _ts_metadata13("design:type", Number)
], QualityCheckerAst.prototype, "temperature", void 0);
_ts_decorate13([
  Output13({
    title: "\u8D28\u68C0\u7ED3\u679C",
    defaultValue: null
  }),
  _ts_metadata13("design:type", Object)
], QualityCheckerAst.prototype, "result", void 0);
_ts_decorate13([
  Output13({
    title: "\u8D28\u91CF\u5206\u6570",
    defaultValue: 0
  }),
  _ts_metadata13("design:type", Number)
], QualityCheckerAst.prototype, "score", void 0);
_ts_decorate13([
  Output13({
    title: "\u662F\u5426\u901A\u8FC7",
    defaultValue: false
  }),
  _ts_metadata13("design:type", Boolean)
], QualityCheckerAst.prototype, "passed", void 0);
QualityCheckerAst = _ts_decorate13([
  Node13({
    title: "\u8D28\u91CF\u68C0\u67E5\u5668",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 2
  })
], QualityCheckerAst);

// src/llm/AnswerEvaluatorAst.ts
import { Ast as Ast14, Input as Input14, Node as Node14, Output as Output14, State as State4 } from "@sker/workflow";
function _ts_decorate14(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate14, "_ts_decorate");
function _ts_metadata14(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata14, "_ts_metadata");
var AnswerEvaluatorAst = class extends Ast14 {
  static {
    __name(this, "AnswerEvaluatorAst");
  }
  question = "";
  answer = "";
  evaluationTypes = [
    "definitive",
    "completeness"
  ];
  temperature = 0.3;
  model = "deepseek-ai/DeepSeek-V3.2";
  results = [];
  passed = false;
  totalScore = 0;
  type = "AnswerEvaluatorAst";
};
_ts_decorate14([
  Input14({
    title: "\u95EE\u9898",
    type: "textarea",
    defaultValue: ""
  }),
  _ts_metadata14("design:type", String)
], AnswerEvaluatorAst.prototype, "question", void 0);
_ts_decorate14([
  Input14({
    title: "\u7B54\u6848",
    type: "textarea",
    defaultValue: ""
  }),
  _ts_metadata14("design:type", String)
], AnswerEvaluatorAst.prototype, "answer", void 0);
_ts_decorate14([
  State4({
    title: "\u8BC4\u4F30\u7C7B\u578B"
  }),
  _ts_metadata14("design:type", Array)
], AnswerEvaluatorAst.prototype, "evaluationTypes", void 0);
_ts_decorate14([
  State4({
    title: "\u6E29\u5EA6"
  }),
  _ts_metadata14("design:type", Number)
], AnswerEvaluatorAst.prototype, "temperature", void 0);
_ts_decorate14([
  State4({
    title: "\u6A21\u578B"
  }),
  _ts_metadata14("design:type", String)
], AnswerEvaluatorAst.prototype, "model", void 0);
_ts_decorate14([
  Output14({
    title: "\u8BC4\u4F30\u7ED3\u679C",
    defaultValue: []
  }),
  _ts_metadata14("design:type", Array)
], AnswerEvaluatorAst.prototype, "results", void 0);
_ts_decorate14([
  Output14({
    title: "\u662F\u5426\u901A\u8FC7",
    defaultValue: false
  })
], AnswerEvaluatorAst.prototype, "passed", void 0);
_ts_decorate14([
  Output14({
    title: "\u603B\u5206",
    defaultValue: 0
  })
], AnswerEvaluatorAst.prototype, "totalScore", void 0);
AnswerEvaluatorAst = _ts_decorate14([
  Node14({
    title: "\u7B54\u6848\u8BC4\u4F30\u5668",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 2,
    retryDelay: 1e3,
    retryBackoff: 1.5
  })
], AnswerEvaluatorAst);

// src/llm/AnswerFinalizerAst.ts
import { Ast as Ast15, Input as Input15, Node as Node15, Output as Output15 } from "@sker/workflow";
function _ts_decorate15(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate15, "_ts_decorate");
function _ts_metadata15(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata15, "_ts_metadata");
var AnswerFinalizerAst = class extends Ast15 {
  static {
    __name(this, "AnswerFinalizerAst");
  }
  markdown = "";
  finalized = ``;
  type = "AnswerFinalizerAst";
};
_ts_decorate15([
  Input15({
    title: "Markdown \u521D\u7A3F",
    type: "textarea",
    defaultValue: ""
  }),
  _ts_metadata15("design:type", String)
], AnswerFinalizerAst.prototype, "markdown", void 0);
_ts_decorate15([
  Output15({
    title: "\u6DA6\u8272\u540E\u5185\u5BB9",
    defaultValue: ""
  })
], AnswerFinalizerAst.prototype, "finalized", void 0);
AnswerFinalizerAst = _ts_decorate15([
  Node15({
    title: "\u7B54\u6848\u7EC8\u7A3F\u5668",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], AnswerFinalizerAst);

// src/llm/QueryRewriterAst.ts
import { Ast as Ast16, Input as Input16, Output as Output16, Node as Node16, IS_MULTI as IS_MULTI11 } from "@sker/workflow";
function _ts_decorate16(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate16, "_ts_decorate");
function _ts_metadata16(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata16, "_ts_metadata");
var QueryRewriterAst = class extends Ast16 {
  static {
    __name(this, "QueryRewriterAst");
  }
  query = [];
  teamSize = 3;
  temperature = 0.7;
  model = "deepseek-ai/DeepSeek-V3.2";
  subQueries = ``;
  reasoning = ``;
  type = "QueryRewriterAst";
};
_ts_decorate16([
  Input16({
    title: "\u539F\u59CB\u67E5\u8BE2",
    type: "textarea",
    mode: IS_MULTI11,
    defaultValue: []
  }),
  _ts_metadata16("design:type", Array)
], QueryRewriterAst.prototype, "query", void 0);
_ts_decorate16([
  Input16({
    title: "\u5B50\u67E5\u8BE2\u6570\u91CF",
    defaultValue: 3
  }),
  _ts_metadata16("design:type", Number)
], QueryRewriterAst.prototype, "teamSize", void 0);
_ts_decorate16([
  Input16({
    title: "\u6E29\u5EA6",
    defaultValue: 0.7
  }),
  _ts_metadata16("design:type", Number)
], QueryRewriterAst.prototype, "temperature", void 0);
_ts_decorate16([
  Input16({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata16("design:type", String)
], QueryRewriterAst.prototype, "model", void 0);
_ts_decorate16([
  Output16({
    title: "\u5B50\u67E5\u8BE2\u5217\u8868",
    defaultValue: ""
  }),
  _ts_metadata16("design:type", Object)
], QueryRewriterAst.prototype, "subQueries", void 0);
_ts_decorate16([
  Output16({
    title: "\u63A8\u7406\u8FC7\u7A0B",
    defaultValue: ""
  })
], QueryRewriterAst.prototype, "reasoning", void 0);
QueryRewriterAst = _ts_decorate16([
  Node16({
    title: "\u67E5\u8BE2\u91CD\u5199\u5668",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], QueryRewriterAst);

// src/llm/ResearchPlannerAst.ts
import { Ast as Ast17, Input as Input17, Output as Output17, Node as Node17, IS_MULTI as IS_MULTI12 } from "@sker/workflow";
function _ts_decorate17(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate17, "_ts_decorate");
function _ts_metadata17(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata17, "_ts_metadata");
var ResearchPlannerAst = class extends Ast17 {
  static {
    __name(this, "ResearchPlannerAst");
  }
  query = [];
  teamSize = 3;
  temperature = 0.7;
  model = "deepseek-ai/DeepSeek-V3.2";
  soundbites = [];
  subproblems = [];
  reasoning = ``;
  type = "ResearchPlannerAst";
};
_ts_decorate17([
  Input17({
    title: "\u7814\u7A76\u4E3B\u9898",
    type: "textarea",
    mode: IS_MULTI12,
    defaultValue: []
  }),
  _ts_metadata17("design:type", Array)
], ResearchPlannerAst.prototype, "query", void 0);
_ts_decorate17([
  Input17({
    title: "\u56E2\u961F\u89C4\u6A21",
    defaultValue: 3
  }),
  _ts_metadata17("design:type", Number)
], ResearchPlannerAst.prototype, "teamSize", void 0);
_ts_decorate17([
  Input17({
    title: "\u6E29\u5EA6",
    defaultValue: 0.7
  }),
  _ts_metadata17("design:type", Number)
], ResearchPlannerAst.prototype, "temperature", void 0);
_ts_decorate17([
  Input17({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata17("design:type", String)
], ResearchPlannerAst.prototype, "model", void 0);
_ts_decorate17([
  Input17({
    title: "Soundbites",
    type: "textarea",
    mode: IS_MULTI12,
    defaultValue: []
  }),
  _ts_metadata17("design:type", Array)
], ResearchPlannerAst.prototype, "soundbites", void 0);
_ts_decorate17([
  Output17({
    title: "\u5B50\u95EE\u9898\u5217\u8868",
    defaultValue: []
  }),
  _ts_metadata17("design:type", Array)
], ResearchPlannerAst.prototype, "subproblems", void 0);
_ts_decorate17([
  Output17({
    title: "\u63A8\u7406\u8FC7\u7A0B",
    defaultValue: ""
  })
], ResearchPlannerAst.prototype, "reasoning", void 0);
ResearchPlannerAst = _ts_decorate17([
  Node17({
    title: "\u7814\u7A76\u89C4\u5212\u5668",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], ResearchPlannerAst);

// src/llm/LlmImageToTextAst.ts
import { Ast as Ast18, Input as Input18, IS_MULTI as IS_MULTI13, Node as Node18, Output as Output18 } from "@sker/workflow";
function _ts_decorate18(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate18, "_ts_decorate");
function _ts_metadata18(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata18, "_ts_metadata");
var LlmImageToTextAst = class extends Ast18 {
  static {
    __name(this, "LlmImageToTextAst");
  }
  images = [];
  text = ``;
  type = `LlmImageToTextAst`;
};
_ts_decorate18([
  Input18({
    title: "\u56FE\u7247",
    mode: IS_MULTI13,
    defaultValue: []
  }),
  _ts_metadata18("design:type", Array)
], LlmImageToTextAst.prototype, "images", void 0);
_ts_decorate18([
  Output18({
    title: "\u63CF\u8FF0",
    defaultValue: ""
  })
], LlmImageToTextAst.prototype, "text", void 0);
LlmImageToTextAst = _ts_decorate18([
  Node18({
    title: "\u56FE\u751F\u6587",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 5,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], LlmImageToTextAst);

// src/llm/LlmStructuredOutputAst.ts
import { Ast as Ast19, Input as Input19, IS_MULTI as IS_MULTI14, Node as Node19 } from "@sker/workflow";
function _ts_decorate19(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate19, "_ts_decorate");
function _ts_metadata19(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata19, "_ts_metadata");
var LlmStructuredOutputAst = class extends Ast19 {
  static {
    __name(this, "LlmStructuredOutputAst");
  }
  system = [];
  prompt = [];
  temperature = 0;
  model = `deepseek-ai/DeepSeek-V3.2`;
  type = `LlmStructuredOutputAst`;
};
_ts_decorate19([
  Input19({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD",
    type: "textarea",
    mode: IS_MULTI14,
    defaultValue: []
  }),
  _ts_metadata19("design:type", Array)
], LlmStructuredOutputAst.prototype, "system", void 0);
_ts_decorate19([
  Input19({
    title: "\u7528\u6237\u63D0\u793A\u8BCD",
    type: "textarea",
    mode: IS_MULTI14,
    defaultValue: []
  }),
  _ts_metadata19("design:type", Array)
], LlmStructuredOutputAst.prototype, "prompt", void 0);
_ts_decorate19([
  Input19({
    title: "\u6E29\u5EA6",
    defaultValue: 0
  }),
  _ts_metadata19("design:type", Number)
], LlmStructuredOutputAst.prototype, "temperature", void 0);
_ts_decorate19([
  Input19({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata19("design:type", String)
], LlmStructuredOutputAst.prototype, "model", void 0);
LlmStructuredOutputAst = _ts_decorate19([
  Node19({
    title: "\u7ED3\u6784\u5316\u8F93\u51FA",
    type: "llm",
    dynamicOutputs: true,
    dynamicInputs: true,
    errorStrategy: "retry",
    maxRetries: 5,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], LlmStructuredOutputAst);

// src/llm/LlmVideoToTextAst.ts
import { Ast as Ast20, Input as Input20, IS_BUFFER as IS_BUFFER7, IS_MULTI as IS_MULTI15, Node as Node20, Output as Output19 } from "@sker/workflow";
function _ts_decorate20(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate20, "_ts_decorate");
function _ts_metadata20(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata20, "_ts_metadata");
var LlmVideoToTextAst = class extends Ast20 {
  static {
    __name(this, "LlmVideoToTextAst");
  }
  videos = [];
  text = ``;
  type = `LlmVideoToTextAst`;
};
_ts_decorate20([
  Input20({
    title: "\u89C6\u9891",
    mode: IS_MULTI15 | IS_BUFFER7,
    defaultValue: []
  }),
  _ts_metadata20("design:type", Array)
], LlmVideoToTextAst.prototype, "videos", void 0);
_ts_decorate20([
  Output19({
    title: "\u63CF\u8FF0",
    defaultValue: ""
  })
], LlmVideoToTextAst.prototype, "text", void 0);
LlmVideoToTextAst = _ts_decorate20([
  Node20({
    title: "\u89C6\u9891\u89E3\u6790",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 5,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], LlmVideoToTextAst);

// src/llm/PersonaAst.ts
import { Ast as Ast21, Input as Input21, IS_MULTI as IS_MULTI16, Node as Node21, Output as Output20, State as State5 } from "@sker/workflow";
function _ts_decorate21(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate21, "_ts_decorate");
function _ts_metadata21(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata21, "_ts_metadata");
var PersonaAst = class extends Ast21 {
  static {
    __name(this, "PersonaAst");
  }
  roleId;
  personaName;
  personaAvatar;
  stimuli = [];
  retrievalDepth = 3;
  retrievalTimeout = 10;
  temperature = 0.7;
  model = "deepseek-ai/DeepSeek-V3.2";
  retrievedMemories = [];
  context = "";
  response = ``;
  newMemoryId = ``;
  type = "PersonaAst";
};
_ts_decorate21([
  State5({
    title: "\u89D2\u8272ID"
  }),
  _ts_metadata21("design:type", String)
], PersonaAst.prototype, "roleId", void 0);
_ts_decorate21([
  State5({
    title: "\u89D2\u8272\u540D\u79F0"
  }),
  _ts_metadata21("design:type", String)
], PersonaAst.prototype, "personaName", void 0);
_ts_decorate21([
  State5({
    title: "\u89D2\u8272\u5934\u50CF"
  }),
  _ts_metadata21("design:type", String)
], PersonaAst.prototype, "personaAvatar", void 0);
_ts_decorate21([
  Input21({
    title: "\u523A\u6FC0/\u7EBF\u7D22",
    mode: IS_MULTI16,
    defaultValue: []
  }),
  _ts_metadata21("design:type", Array)
], PersonaAst.prototype, "stimuli", void 0);
_ts_decorate21([
  Input21({
    title: "\u68C0\u7D22\u6DF1\u5EA6",
    defaultValue: 3
  }),
  _ts_metadata21("design:type", Number)
], PersonaAst.prototype, "retrievalDepth", void 0);
_ts_decorate21([
  Input21({
    title: "\u68C0\u7D22\u8D85\u65F6(\u79D2)",
    defaultValue: 10
  }),
  _ts_metadata21("design:type", Number)
], PersonaAst.prototype, "retrievalTimeout", void 0);
_ts_decorate21([
  Input21({
    title: "\u6E29\u5EA6",
    defaultValue: 0.7
  }),
  _ts_metadata21("design:type", Number)
], PersonaAst.prototype, "temperature", void 0);
_ts_decorate21([
  Input21({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata21("design:type", String)
], PersonaAst.prototype, "model", void 0);
_ts_decorate21([
  State5({
    title: "\u68C0\u7D22\u5230\u7684\u8BB0\u5FC6"
  }),
  _ts_metadata21("design:type", Array)
], PersonaAst.prototype, "retrievedMemories", void 0);
_ts_decorate21([
  State5({
    title: "\u4E0A\u4E0B\u6587"
  }),
  _ts_metadata21("design:type", String)
], PersonaAst.prototype, "context", void 0);
_ts_decorate21([
  Output20({
    title: "\u56DE\u590D",
    defaultValue: ""
  })
], PersonaAst.prototype, "response", void 0);
_ts_decorate21([
  Output20({
    title: "\u65B0\u8BB0\u5FC6ID",
    defaultValue: ""
  })
], PersonaAst.prototype, "newMemoryId", void 0);
PersonaAst = _ts_decorate21([
  Node21({
    title: "\u89D2\u8272\u8BB0\u5FC6",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], PersonaAst);

// src/llm/PersonaCreatorAst.ts
import { Ast as Ast22, Input as Input22, IS_MULTI as IS_MULTI17, Node as Node22, Output as Output21, State as State6 } from "@sker/workflow";
function _ts_decorate22(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate22, "_ts_decorate");
function _ts_metadata22(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata22, "_ts_metadata");
var PersonaCreatorAst = class extends Ast22 {
  static {
    __name(this, "PersonaCreatorAst");
  }
  descriptions = [];
  temperature = 0.7;
  model = "deepseek-ai/DeepSeek-V3.2";
  generatedName;
  generatedAvatar;
  generatedDescription;
  generatedBackground;
  generatedTraits;
  generatedMetadata;
  generatedDestiny;
  personaId = ``;
  personaName = ``;
  type = "PersonaCreatorAst";
};
_ts_decorate22([
  Input22({
    title: "\u89D2\u8272\u63CF\u8FF0",
    type: "textarea",
    mode: IS_MULTI17,
    defaultValue: []
  }),
  _ts_metadata22("design:type", Array)
], PersonaCreatorAst.prototype, "descriptions", void 0);
_ts_decorate22([
  Input22({
    title: "\u6E29\u5EA6",
    defaultValue: 0.7
  }),
  _ts_metadata22("design:type", Number)
], PersonaCreatorAst.prototype, "temperature", void 0);
_ts_decorate22([
  Input22({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata22("design:type", String)
], PersonaCreatorAst.prototype, "model", void 0);
_ts_decorate22([
  State6({
    title: "\u751F\u6210\u7684\u89D2\u8272\u540D"
  }),
  _ts_metadata22("design:type", String)
], PersonaCreatorAst.prototype, "generatedName", void 0);
_ts_decorate22([
  State6({
    title: "\u751F\u6210\u7684\u5934\u50CF"
  }),
  _ts_metadata22("design:type", String)
], PersonaCreatorAst.prototype, "generatedAvatar", void 0);
_ts_decorate22([
  State6({
    title: "\u751F\u6210\u7684\u63CF\u8FF0"
  }),
  _ts_metadata22("design:type", String)
], PersonaCreatorAst.prototype, "generatedDescription", void 0);
_ts_decorate22([
  State6({
    title: "\u751F\u6210\u7684\u80CC\u666F"
  }),
  _ts_metadata22("design:type", String)
], PersonaCreatorAst.prototype, "generatedBackground", void 0);
_ts_decorate22([
  State6({
    title: "\u751F\u6210\u7684\u6027\u683C"
  }),
  _ts_metadata22("design:type", Array)
], PersonaCreatorAst.prototype, "generatedTraits", void 0);
_ts_decorate22([
  State6({
    title: "\u751F\u6210\u7684\u5143\u6570\u636E"
  }),
  _ts_metadata22("design:type", typeof PersonaMetadata === "undefined" ? Object : PersonaMetadata)
], PersonaCreatorAst.prototype, "generatedMetadata", void 0);
_ts_decorate22([
  State6({
    title: "\u751F\u6210\u7684\u547D\u8FD0"
  }),
  _ts_metadata22("design:type", typeof PersonaDestiny === "undefined" ? Object : PersonaDestiny)
], PersonaCreatorAst.prototype, "generatedDestiny", void 0);
_ts_decorate22([
  Output21({
    title: "\u89D2\u8272ID",
    defaultValue: ""
  })
], PersonaCreatorAst.prototype, "personaId", void 0);
_ts_decorate22([
  Output21({
    title: "\u89D2\u8272\u540D",
    defaultValue: ""
  })
], PersonaCreatorAst.prototype, "personaName", void 0);
PersonaCreatorAst = _ts_decorate22([
  Node22({
    title: "\u521B\u5EFA\u4EBA\u7269",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], PersonaCreatorAst);

// src/llm/PromptRoleSkillAst.ts
import { Ast as Ast23, Input as Input23, Output as Output22, State as State7, Node as Node23, IS_MULTI as IS_MULTI18 } from "@sker/workflow";
function _ts_decorate23(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate23, "_ts_decorate");
function _ts_metadata23(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata23, "_ts_metadata");
var PromptRoleSkillAst = class extends Ast23 {
  static {
    __name(this, "PromptRoleSkillAst");
  }
  roleId;
  requirements = [];
  temperature = 0.7;
  model = "deepseek-ai/DeepSeek-V3.2";
  availableSkills = [];
  selectedSkills = [];
  skillContents = {};
  selectedSkillsList = [];
  skillContent = {};
  skillContentText = "";
  type = "PromptRoleSkillAst";
};
_ts_decorate23([
  State7({
    title: "\u89D2\u8272ID"
  }),
  _ts_metadata23("design:type", String)
], PromptRoleSkillAst.prototype, "roleId", void 0);
_ts_decorate23([
  Input23({
    title: "\u89D2\u8272\u9700\u6C42",
    mode: IS_MULTI18,
    defaultValue: []
  }),
  _ts_metadata23("design:type", Array)
], PromptRoleSkillAst.prototype, "requirements", void 0);
_ts_decorate23([
  Input23({
    title: "\u6E29\u5EA6",
    defaultValue: 0.7
  }),
  _ts_metadata23("design:type", Number)
], PromptRoleSkillAst.prototype, "temperature", void 0);
_ts_decorate23([
  Input23({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata23("design:type", String)
], PromptRoleSkillAst.prototype, "model", void 0);
_ts_decorate23([
  State7({
    title: "\u53EF\u7528\u6280\u80FD\u5217\u8868"
  }),
  _ts_metadata23("design:type", Array)
], PromptRoleSkillAst.prototype, "availableSkills", void 0);
_ts_decorate23([
  State7({
    title: "\u9009\u4E2D\u7684\u6280\u80FD"
  }),
  _ts_metadata23("design:type", Array)
], PromptRoleSkillAst.prototype, "selectedSkills", void 0);
_ts_decorate23([
  State7({
    title: "\u6280\u80FD\u5185\u5BB9\u7F13\u5B58"
  }),
  _ts_metadata23("design:type", typeof Record === "undefined" ? Object : Record)
], PromptRoleSkillAst.prototype, "skillContents", void 0);
_ts_decorate23([
  Output22({
    title: "\u9009\u4E2D\u6280\u80FD\u5217\u8868",
    defaultValue: []
  }),
  _ts_metadata23("design:type", Array)
], PromptRoleSkillAst.prototype, "selectedSkillsList", void 0);
_ts_decorate23([
  Output22({
    title: "\u6280\u80FD\u5185\u5BB9",
    defaultValue: {}
  })
], PromptRoleSkillAst.prototype, "skillContent", void 0);
_ts_decorate23([
  Output22({
    title: "\u6280\u80FD\u5185\u5BB9\u6587\u672C",
    defaultValue: ""
  })
], PromptRoleSkillAst.prototype, "skillContentText", void 0);
PromptRoleSkillAst = _ts_decorate23([
  Node23({
    title: "\u89D2\u8272\u6280\u80FD",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], PromptRoleSkillAst);

// src/crawler/ProxyAutoSelectAst.ts
import { Ast as Ast24, Input as Input24, Node as Node24, Output as Output23, State as State8 } from "@sker/workflow";
function _ts_decorate24(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate24, "_ts_decorate");
function _ts_metadata24(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata24, "_ts_metadata");
var ProxyAutoSelectAst = class extends Ast24 {
  static {
    __name(this, "ProxyAutoSelectAst");
  }
  initialCount = 2;
  proxyList = [];
  selectedProxyUrl;
  proxyUrl = "";
  proxyInfo = null;
  type = "ProxyAutoSelectAst";
};
_ts_decorate24([
  Input24({
    title: "\u521D\u59CB\u5316\u6570\u91CF",
    defaultValue: 2
  }),
  _ts_metadata24("design:type", Number)
], ProxyAutoSelectAst.prototype, "initialCount", void 0);
_ts_decorate24([
  State8({
    title: "\u4EE3\u7406\u5217\u8868"
  }),
  _ts_metadata24("design:type", typeof Array === "undefined" ? Object : Array)
], ProxyAutoSelectAst.prototype, "proxyList", void 0);
_ts_decorate24([
  State8({
    title: "\u9009\u4E2D\u4EE3\u7406URL"
  }),
  _ts_metadata24("design:type", String)
], ProxyAutoSelectAst.prototype, "selectedProxyUrl", void 0);
_ts_decorate24([
  Output23({
    title: "\u4EE3\u7406URL",
    defaultValue: ""
  })
], ProxyAutoSelectAst.prototype, "proxyUrl", void 0);
_ts_decorate24([
  Output23({
    title: "\u4EE3\u7406\u4FE1\u606F",
    defaultValue: null
  }),
  _ts_metadata24("design:type", Object)
], ProxyAutoSelectAst.prototype, "proxyInfo", void 0);
ProxyAutoSelectAst = _ts_decorate24([
  Node24({
    title: "\u4EE3\u7406\u81EA\u52A8\u9009\u62E9",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], ProxyAutoSelectAst);

// src/crawler/WeiboAccountPickAst.ts
import { Ast as Ast25, Input as Input25, IS_MULTI as IS_MULTI19, Node as Node25, Output as Output24, State as State9 } from "@sker/workflow";
function _ts_decorate25(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate25, "_ts_decorate");
function _ts_metadata25(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata25, "_ts_metadata");
var WeiboAccountPickAst = class extends Ast25 {
  static {
    __name(this, "WeiboAccountPickAst");
  }
  scanQrCodeLogin = [];
  list = [];
  selectedId;
  // 注意：不使用BehaviorSubject
  cookies = ``;
  type = `WeiboAccountPickAst`;
};
_ts_decorate25([
  Input25({
    title: "\u626B\u7801\u767B\u5F55",
    mode: IS_MULTI19,
    defaultValue: []
  }),
  _ts_metadata25("design:type", Array)
], WeiboAccountPickAst.prototype, "scanQrCodeLogin", void 0);
_ts_decorate25([
  State9({
    title: "\u8D26\u53F7\u5217\u8868"
  }),
  _ts_metadata25("design:type", typeof Array === "undefined" ? Object : Array)
], WeiboAccountPickAst.prototype, "list", void 0);
_ts_decorate25([
  State9({
    title: "\u9009\u4E2D\u8D26\u53F7ID"
  }),
  _ts_metadata25("design:type", String)
], WeiboAccountPickAst.prototype, "selectedId", void 0);
_ts_decorate25([
  Output24({
    title: "Cookies",
    defaultValue: ""
  })
], WeiboAccountPickAst.prototype, "cookies", void 0);
WeiboAccountPickAst = _ts_decorate25([
  Node25({
    title: "\u5FAE\u535A\u8D26\u53F7\u9009\u62E9\u5668",
    type: "crawler",
    errorStrategy: "abort",
    maxRetries: 1,
    retryDelay: 3e3,
    retryBackoff: 1
  })
], WeiboAccountPickAst);

// src/crawler/WeiboLoginAst.ts
import { Ast as Ast26, Node as Node26, Output as Output25 } from "@sker/workflow";
function _ts_decorate26(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate26, "_ts_decorate");
function _ts_metadata26(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata26, "_ts_metadata");
var WeiboLoginAst = class extends Ast26 {
  static {
    __name(this, "WeiboLoginAst");
  }
  account = ``;
  qrcode = null;
  message = null;
  type = `WeiboLoginAst`;
};
_ts_decorate26([
  Output25({
    title: "\u5FAE\u535A\u8D26\u53F7",
    isRouter: true,
    defaultValue: ""
  }),
  _ts_metadata26("design:type", Object)
], WeiboLoginAst.prototype, "account", void 0);
_ts_decorate26([
  Output25({
    title: "\u767B\u5F55\u4E8C\u7EF4\u7801",
    isRouter: true,
    defaultValue: null
  }),
  _ts_metadata26("design:type", Object)
], WeiboLoginAst.prototype, "qrcode", void 0);
_ts_decorate26([
  Output25({
    title: "\u63D0\u793A\u6D88\u606F",
    defaultValue: null
  }),
  _ts_metadata26("design:type", Object)
], WeiboLoginAst.prototype, "message", void 0);
WeiboLoginAst = _ts_decorate26([
  Node26({
    title: "\u5FAE\u535A\u767B\u5F55",
    type: "crawler",
    errorStrategy: "abort",
    maxRetries: 2,
    retryDelay: 5e3,
    retryBackoff: 1
  })
], WeiboLoginAst);

// src/crawler/WeiboUserDetectionAst.ts
import { Ast as Ast27, Input as Input26, IS_MULTI as IS_MULTI20, Node as Node27, Output as Output26 } from "@sker/workflow";
function _ts_decorate27(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate27, "_ts_decorate");
function _ts_metadata27(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata27, "_ts_metadata");
var WeiboUserDetectionAst = class extends Ast27 {
  static {
    __name(this, "WeiboUserDetectionAst");
  }
  uid = ``;
  canStart = [];
  is_end = false;
  type = `WeiboUserDetectionAst`;
};
_ts_decorate27([
  Input26({
    title: "\u7528\u6237id",
    defaultValue: ""
  }),
  _ts_metadata27("design:type", String)
], WeiboUserDetectionAst.prototype, "uid", void 0);
_ts_decorate27([
  Input26({
    mode: IS_MULTI20,
    title: "\u5F00\u59CB",
    defaultValue: []
  }),
  _ts_metadata27("design:type", Array)
], WeiboUserDetectionAst.prototype, "canStart", void 0);
_ts_decorate27([
  Output26({
    title: "\u7ED3\u675F",
    defaultValue: false
  })
], WeiboUserDetectionAst.prototype, "is_end", void 0);
WeiboUserDetectionAst = _ts_decorate27([
  Node27({
    title: "\u8D26\u53F7\u68C0\u6D4B",
    type: "crawler",
    errorStrategy: "abort",
    maxRetries: 2,
    retryDelay: 3e3,
    retryBackoff: 1
  })
], WeiboUserDetectionAst);

// src/crawler/WeiboAjaxStatusesCommentAst.ts
import { Ast as Ast28, Input as Input27, Node as Node28, Output as Output27, State as State10 } from "@sker/workflow";
function _ts_decorate28(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate28, "_ts_decorate");
function _ts_metadata28(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata28, "_ts_metadata");
var WeiboAjaxStatusesCommentAst = class extends Ast28 {
  static {
    __name(this, "WeiboAjaxStatusesCommentAst");
  }
  mid;
  uid;
  // 默认
  max_id = void 0;
  count = 20;
  is_show_bulletin = 3;
  is_mix = 0;
  fetch_level = 0;
  next_max_id = 0;
  is_end = false;
  type = `WeiboAjaxStatusesCommentAst`;
};
_ts_decorate28([
  Input27({
    title: "\u5E16\u5B50ID",
    defaultValue: ""
  }),
  _ts_metadata28("design:type", String)
], WeiboAjaxStatusesCommentAst.prototype, "mid", void 0);
_ts_decorate28([
  Input27({
    title: "\u7528\u6237ID",
    defaultValue: ""
  }),
  _ts_metadata28("design:type", String)
], WeiboAjaxStatusesCommentAst.prototype, "uid", void 0);
_ts_decorate28([
  State10({
    title: "\u6700\u5927ID"
  }),
  _ts_metadata28("design:type", Object)
], WeiboAjaxStatusesCommentAst.prototype, "max_id", void 0);
_ts_decorate28([
  State10({
    title: "\u6570\u91CF"
  }),
  _ts_metadata28("design:type", Number)
], WeiboAjaxStatusesCommentAst.prototype, "count", void 0);
_ts_decorate28([
  State10({
    title: "\u663E\u793A\u516C\u544A"
  }),
  _ts_metadata28("design:type", Number)
], WeiboAjaxStatusesCommentAst.prototype, "is_show_bulletin", void 0);
_ts_decorate28([
  State10({
    title: "\u6DF7\u5408\u6A21\u5F0F"
  }),
  _ts_metadata28("design:type", Number)
], WeiboAjaxStatusesCommentAst.prototype, "is_mix", void 0);
_ts_decorate28([
  State10({
    title: "\u83B7\u53D6\u7EA7\u522B"
  }),
  _ts_metadata28("design:type", Number)
], WeiboAjaxStatusesCommentAst.prototype, "fetch_level", void 0);
_ts_decorate28([
  State10({
    title: "\u4E0B\u4E00\u6700\u5927ID"
  }),
  _ts_metadata28("design:type", Number)
], WeiboAjaxStatusesCommentAst.prototype, "next_max_id", void 0);
_ts_decorate28([
  Output27({
    title: "\u7ED3\u675F",
    defaultValue: false
  })
], WeiboAjaxStatusesCommentAst.prototype, "is_end", void 0);
WeiboAjaxStatusesCommentAst = _ts_decorate28([
  Node28({
    title: "\u5FAE\u535A\u8BC4\u8BBA",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], WeiboAjaxStatusesCommentAst);

// src/crawler/WeiboAjaxStatusesLikeShowAst.ts
import { Ast as Ast29, Input as Input28, Node as Node29, Output as Output28, State as State11 } from "@sker/workflow";
function _ts_decorate29(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate29, "_ts_decorate");
function _ts_metadata29(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata29, "_ts_metadata");
var WeiboAjaxStatusesLikeShowAst = class extends Ast29 {
  static {
    __name(this, "WeiboAjaxStatusesLikeShowAst");
  }
  mid = ``;
  uid = ``;
  page = 1;
  count = 20;
  /**
   * 默认值
   */
  attitude_type = 0;
  attitude_enable = 1;
  is_end = false;
  type = `WeiboAjaxStatusesLikeShowAst`;
};
_ts_decorate29([
  Input28({
    title: "\u5E16\u5B50ID",
    defaultValue: ""
  }),
  _ts_metadata29("design:type", String)
], WeiboAjaxStatusesLikeShowAst.prototype, "mid", void 0);
_ts_decorate29([
  Input28({
    title: "\u7528\u6237ID",
    defaultValue: ""
  }),
  _ts_metadata29("design:type", String)
], WeiboAjaxStatusesLikeShowAst.prototype, "uid", void 0);
_ts_decorate29([
  State11({
    title: "\u9875\u7801"
  }),
  _ts_metadata29("design:type", Number)
], WeiboAjaxStatusesLikeShowAst.prototype, "page", void 0);
_ts_decorate29([
  State11({
    title: "\u6570\u91CF"
  }),
  _ts_metadata29("design:type", Number)
], WeiboAjaxStatusesLikeShowAst.prototype, "count", void 0);
_ts_decorate29([
  State11({
    title: "\u6001\u5EA6\u7C7B\u578B"
  }),
  _ts_metadata29("design:type", Number)
], WeiboAjaxStatusesLikeShowAst.prototype, "attitude_type", void 0);
_ts_decorate29([
  State11({
    title: "\u6001\u5EA6\u542F\u7528"
  }),
  _ts_metadata29("design:type", Number)
], WeiboAjaxStatusesLikeShowAst.prototype, "attitude_enable", void 0);
_ts_decorate29([
  Output28({
    title: "\u7ED3\u675F",
    defaultValue: false
  })
], WeiboAjaxStatusesLikeShowAst.prototype, "is_end", void 0);
WeiboAjaxStatusesLikeShowAst = _ts_decorate29([
  Node29({
    title: "\u5FAE\u535A\u70B9\u8D5E",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], WeiboAjaxStatusesLikeShowAst);

// src/crawler/WeiboAjaxStatusesMymblogAst.ts
import { Ast as Ast30, Input as Input29, Node as Node30, Output as Output29, State as State12 } from "@sker/workflow";
function _ts_decorate30(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate30, "_ts_decorate");
function _ts_metadata30(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata30, "_ts_metadata");
var WeiboAjaxStatusesMymblogAst = class extends Ast30 {
  static {
    __name(this, "WeiboAjaxStatusesMymblogAst");
  }
  uid = ``;
  page = 1;
  isEnd = false;
  type = `WeiboAjaxStatusesMymblogAst`;
};
_ts_decorate30([
  Input29({
    title: "\u7528\u6237ID",
    defaultValue: ""
  }),
  _ts_metadata30("design:type", String)
], WeiboAjaxStatusesMymblogAst.prototype, "uid", void 0);
_ts_decorate30([
  State12({
    title: "\u9875\u7801"
  }),
  _ts_metadata30("design:type", Number)
], WeiboAjaxStatusesMymblogAst.prototype, "page", void 0);
_ts_decorate30([
  Output29({
    title: "\u662F\u5426\u7ED3\u675F",
    defaultValue: false
  })
], WeiboAjaxStatusesMymblogAst.prototype, "isEnd", void 0);
WeiboAjaxStatusesMymblogAst = _ts_decorate30([
  Node30({
    title: "\u5FAE\u535A\u4E2A\u4EBA\u535A\u6587",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], WeiboAjaxStatusesMymblogAst);

// src/crawler/WeiboAjaxStatusesRepostTimelineAst.ts
import { Ast as Ast31, Input as Input30, Node as Node31, Output as Output30, State as State13 } from "@sker/workflow";
function _ts_decorate31(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate31, "_ts_decorate");
function _ts_metadata31(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata31, "_ts_metadata");
var WeiboAjaxStatusesRepostTimelineAst = class extends Ast31 {
  static {
    __name(this, "WeiboAjaxStatusesRepostTimelineAst");
  }
  mid = ``;
  uid = ``;
  page = 1;
  is_end = false;
  type = `WeiboAjaxStatusesRepostTimelineAst`;
};
_ts_decorate31([
  Input30({
    title: "\u5E16\u5B50ID",
    defaultValue: ""
  }),
  _ts_metadata31("design:type", String)
], WeiboAjaxStatusesRepostTimelineAst.prototype, "mid", void 0);
_ts_decorate31([
  Input30({
    title: "\u7528\u6237ID",
    defaultValue: ""
  }),
  _ts_metadata31("design:type", String)
], WeiboAjaxStatusesRepostTimelineAst.prototype, "uid", void 0);
_ts_decorate31([
  State13({
    title: "\u9875\u7801"
  }),
  _ts_metadata31("design:type", Number)
], WeiboAjaxStatusesRepostTimelineAst.prototype, "page", void 0);
_ts_decorate31([
  Output30({
    title: "\u7ED3\u675F",
    defaultValue: false
  })
], WeiboAjaxStatusesRepostTimelineAst.prototype, "is_end", void 0);
WeiboAjaxStatusesRepostTimelineAst = _ts_decorate31([
  Node31({
    title: "\u5FAE\u535A\u8F6C\u53D1",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], WeiboAjaxStatusesRepostTimelineAst);

// src/crawler/WeiboAjaxStatusesShowAst.ts
import { Ast as Ast32, Input as Input31, Node as Node32, Output as Output31 } from "@sker/workflow";
function _ts_decorate32(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate32, "_ts_decorate");
function _ts_metadata32(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata32, "_ts_metadata");
var WeiboAjaxStatusesShowAst = class extends Ast32 {
  static {
    __name(this, "WeiboAjaxStatusesShowAst");
  }
  mblogid = "";
  uid = "";
  postId = ``;
  mid = ``;
  eventId = "";
  type = `WeiboAjaxStatusesShowAst`;
};
_ts_decorate32([
  Input31({
    title: "\u5E16\u5B50\u77EDid",
    defaultValue: ""
  }),
  _ts_metadata32("design:type", String)
], WeiboAjaxStatusesShowAst.prototype, "mblogid", void 0);
_ts_decorate32([
  Output31({
    title: "\u7528\u6237ID",
    defaultValue: ""
  }),
  Input31({
    title: "\u7528\u6237ID",
    defaultValue: ""
  })
], WeiboAjaxStatusesShowAst.prototype, "uid", void 0);
_ts_decorate32([
  Output31({
    title: "\u5E16\u5B50\u6570\u636E\u5E93ID",
    defaultValue: ""
  })
], WeiboAjaxStatusesShowAst.prototype, "postId", void 0);
_ts_decorate32([
  Output31({
    title: "\u5E16\u5B50mid",
    defaultValue: ""
  })
], WeiboAjaxStatusesShowAst.prototype, "mid", void 0);
_ts_decorate32([
  Output31({
    title: "\u4E8B\u4EF6ID",
    defaultValue: ""
  }),
  Input31({
    title: "\u4E8B\u4EF6ID",
    defaultValue: ""
  })
], WeiboAjaxStatusesShowAst.prototype, "eventId", void 0);
WeiboAjaxStatusesShowAst = _ts_decorate32([
  Node32({
    title: "\u5FAE\u535A\u535A\u6587\u8BE6\u60C5",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], WeiboAjaxStatusesShowAst);

// src/crawler/WeiboAjaxFeedHotTimelineAst.ts
import { Ast as Ast33, Input as Input32, IS_MULTI as IS_MULTI21, Node as Node33, Output as Output32, State as State14 } from "@sker/workflow";
function _ts_decorate33(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate33, "_ts_decorate");
function _ts_metadata33(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata33, "_ts_metadata");
var WeiboAjaxFeedHotTimelineAst = class extends Ast33 {
  static {
    __name(this, "WeiboAjaxFeedHotTimelineAst");
  }
  next = [];
  group_id = "102803600343";
  containerid = "102803_ctg1_600343_-_ctg1_600343";
  extparam = "discover|new_feed";
  max_id = "0";
  since_id = "0";
  count = 10;
  refresh = 1;
  // 注意：不使用BehaviorSubject
  mblogid = ``;
  // 注意：不使用BehaviorSubject
  uid = ``;
  // 注意：不使用BehaviorSubject
  is_end = false;
  type = "WeiboAjaxFeedHotTimelineAst";
};
_ts_decorate33([
  Input32({
    mode: IS_MULTI21,
    title: "\u5F00\u59CB",
    defaultValue: []
  }),
  _ts_metadata33("design:type", Array)
], WeiboAjaxFeedHotTimelineAst.prototype, "next", void 0);
_ts_decorate33([
  State14({
    title: "\u7EC4ID"
  }),
  _ts_metadata33("design:type", String)
], WeiboAjaxFeedHotTimelineAst.prototype, "group_id", void 0);
_ts_decorate33([
  State14({
    title: "\u5BB9\u5668ID"
  }),
  _ts_metadata33("design:type", String)
], WeiboAjaxFeedHotTimelineAst.prototype, "containerid", void 0);
_ts_decorate33([
  State14({
    title: "\u6269\u5C55\u53C2\u6570"
  }),
  _ts_metadata33("design:type", String)
], WeiboAjaxFeedHotTimelineAst.prototype, "extparam", void 0);
_ts_decorate33([
  State14({
    title: "\u6700\u5927ID"
  }),
  _ts_metadata33("design:type", String)
], WeiboAjaxFeedHotTimelineAst.prototype, "max_id", void 0);
_ts_decorate33([
  State14({
    title: "\u8D77\u59CBID"
  }),
  _ts_metadata33("design:type", String)
], WeiboAjaxFeedHotTimelineAst.prototype, "since_id", void 0);
_ts_decorate33([
  State14({
    title: "\u6570\u91CF"
  }),
  _ts_metadata33("design:type", Number)
], WeiboAjaxFeedHotTimelineAst.prototype, "count", void 0);
_ts_decorate33([
  State14({
    title: "\u5237\u65B0"
  }),
  _ts_metadata33("design:type", Number)
], WeiboAjaxFeedHotTimelineAst.prototype, "refresh", void 0);
_ts_decorate33([
  Output32({
    title: "\u5E16\u5B50\u77EDid",
    defaultValue: ""
  })
], WeiboAjaxFeedHotTimelineAst.prototype, "mblogid", void 0);
_ts_decorate33([
  Output32({
    title: "\u7528\u6237id",
    defaultValue: ""
  })
], WeiboAjaxFeedHotTimelineAst.prototype, "uid", void 0);
_ts_decorate33([
  Output32({
    title: "\u7ED3\u675F",
    defaultValue: false
  })
], WeiboAjaxFeedHotTimelineAst.prototype, "is_end", void 0);
WeiboAjaxFeedHotTimelineAst = _ts_decorate33([
  Node33({
    title: "\u5FAE\u535A\u70ED\u95E8",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], WeiboAjaxFeedHotTimelineAst);

// src/crawler/WeiboKeywordSearchAst.ts
import { Ast as Ast34, Input as Input33, Node as Node34, Output as Output33, State as State15 } from "@sker/workflow";
function _ts_decorate34(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate34, "_ts_decorate");
function _ts_metadata34(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata34, "_ts_metadata");
var WeiboKeywordSearchAst = class extends Ast34 {
  static {
    __name(this, "WeiboKeywordSearchAst");
  }
  keyword = ``;
  startDate = /* @__PURE__ */ new Date();
  endDate = /* @__PURE__ */ new Date();
  page = 1;
  emitDelayMin = 1;
  emitDelayMax = 3;
  pageDelayMin = 3;
  pageDelayMax = 5;
  mblogid = "";
  uid = "";
  isEnd = false;
  currentPage = 1;
  totalPages = 1;
  type = `WeiboKeywordSearchAst`;
};
_ts_decorate34([
  Input33({
    title: "\u5173\u952E\u5B57",
    type: "text",
    defaultValue: ""
  }),
  _ts_metadata34("design:type", String)
], WeiboKeywordSearchAst.prototype, "keyword", void 0);
_ts_decorate34([
  Input33({
    title: "\u5F00\u59CB\u65E5\u671F",
    type: "date",
    defaultValue: /* @__PURE__ */ new Date()
  }),
  _ts_metadata34("design:type", typeof Date === "undefined" ? Object : Date)
], WeiboKeywordSearchAst.prototype, "startDate", void 0);
_ts_decorate34([
  State15({
    title: "\u7ED3\u675F\u65E5\u671F",
    type: "date"
  }),
  _ts_metadata34("design:type", typeof Date === "undefined" ? Object : Date)
], WeiboKeywordSearchAst.prototype, "endDate", void 0);
_ts_decorate34([
  State15({
    title: "\u9875\u7801",
    type: "number"
  }),
  _ts_metadata34("design:type", Number)
], WeiboKeywordSearchAst.prototype, "page", void 0);
_ts_decorate34([
  Input33({
    title: "\u53D1\u5C04\u6700\u5C0F\u5EF6\u8FDF(\u79D2)",
    type: "number",
    defaultValue: 1
  }),
  _ts_metadata34("design:type", Number)
], WeiboKeywordSearchAst.prototype, "emitDelayMin", void 0);
_ts_decorate34([
  Input33({
    title: "\u53D1\u5C04\u6700\u5927\u5EF6\u8FDF(\u79D2)",
    type: "number",
    defaultValue: 3
  }),
  _ts_metadata34("design:type", Number)
], WeiboKeywordSearchAst.prototype, "emitDelayMax", void 0);
_ts_decorate34([
  Input33({
    title: "\u7FFB\u9875\u6700\u5C0F\u5EF6\u8FDF(\u79D2)",
    type: "number",
    defaultValue: 3
  }),
  _ts_metadata34("design:type", Number)
], WeiboKeywordSearchAst.prototype, "pageDelayMin", void 0);
_ts_decorate34([
  Input33({
    title: "\u7FFB\u9875\u6700\u5927\u5EF6\u8FDF(\u79D2)",
    type: "number",
    defaultValue: 5
  }),
  _ts_metadata34("design:type", Number)
], WeiboKeywordSearchAst.prototype, "pageDelayMax", void 0);
_ts_decorate34([
  Output33({
    title: "\u5E16\u5B50id",
    defaultValue: ""
  })
], WeiboKeywordSearchAst.prototype, "mblogid", void 0);
_ts_decorate34([
  Output33({
    title: "\u7528\u6237id",
    defaultValue: ""
  })
], WeiboKeywordSearchAst.prototype, "uid", void 0);
_ts_decorate34([
  Output33({
    title: "\u662F\u5426\u7ED3\u675F",
    defaultValue: false
  })
], WeiboKeywordSearchAst.prototype, "isEnd", void 0);
_ts_decorate34([
  State15({
    title: "\u5F53\u524D\u9875\u7801"
  }),
  _ts_metadata34("design:type", Number)
], WeiboKeywordSearchAst.prototype, "currentPage", void 0);
_ts_decorate34([
  State15({
    title: "\u603B\u9875\u6570"
  }),
  _ts_metadata34("design:type", Number)
], WeiboKeywordSearchAst.prototype, "totalPages", void 0);
WeiboKeywordSearchAst = _ts_decorate34([
  Node34({
    title: "\u5FAE\u535A\u68C0\u7D22",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], WeiboKeywordSearchAst);

// src/crawler/WeiboAjaxFriendshipsAst.ts
import { Ast as Ast35, Input as Input34, Node as Node35, Output as Output34 } from "@sker/workflow";
function _ts_decorate35(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate35, "_ts_decorate");
function _ts_metadata35(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata35, "_ts_metadata");
var WeiboAjaxFriendshipsAst = class extends Ast35 {
  static {
    __name(this, "WeiboAjaxFriendshipsAst");
  }
  uid = ``;
  page = 1;
  isEnd = false;
  type = `WeiboAjaxFriendshipsAst`;
};
_ts_decorate35([
  Input34({
    title: "\u7528\u6237ID",
    defaultValue: ""
  }),
  _ts_metadata35("design:type", String)
], WeiboAjaxFriendshipsAst.prototype, "uid", void 0);
_ts_decorate35([
  Input34({
    title: "\u9875\u7801",
    defaultValue: 1
  }),
  _ts_metadata35("design:type", Number)
], WeiboAjaxFriendshipsAst.prototype, "page", void 0);
_ts_decorate35([
  Output34({
    title: "\u662F\u5426\u7ED3\u675F",
    defaultValue: false
  })
], WeiboAjaxFriendshipsAst.prototype, "isEnd", void 0);
WeiboAjaxFriendshipsAst = _ts_decorate35([
  Node35({
    title: "\u5FAE\u535A\u5173\u6CE8",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], WeiboAjaxFriendshipsAst);

// src/crawler/WeiboAjaxProfileInfoAst.ts
import { Ast as Ast36, Input as Input35, Node as Node36, Output as Output35 } from "@sker/workflow";
function _ts_decorate36(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate36, "_ts_decorate");
function _ts_metadata36(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata36, "_ts_metadata");
var WeiboAjaxProfileInfoAst = class extends Ast36 {
  static {
    __name(this, "WeiboAjaxProfileInfoAst");
  }
  uid = ``;
  isEnd = false;
  type = `WeiboAjaxProfileInfoAst`;
};
_ts_decorate36([
  Input35({
    title: "\u7528\u6237ID",
    defaultValue: ""
  }),
  _ts_metadata36("design:type", String)
], WeiboAjaxProfileInfoAst.prototype, "uid", void 0);
_ts_decorate36([
  Output35({
    title: "\u662F\u5426\u7ED3\u675F",
    defaultValue: false
  })
], WeiboAjaxProfileInfoAst.prototype, "isEnd", void 0);
WeiboAjaxProfileInfoAst = _ts_decorate36([
  Node36({
    title: "\u5FAE\u535A\u4E2A\u4EBA\u4FE1\u606F",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], WeiboAjaxProfileInfoAst);

// src/crawler/PostNLPAnalyzerAst.ts
import { Ast as Ast37, Input as Input36, Node as Node37, Output as Output36 } from "@sker/workflow";
function _ts_decorate37(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate37, "_ts_decorate");
function _ts_metadata37(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata37, "_ts_metadata");
var PostNLPAnalyzerAst = class extends Ast37 {
  static {
    __name(this, "PostNLPAnalyzerAst");
  }
  post;
  comments;
  reposts;
  event_id = "";
  nlpResult = ``;
  event_associated = false;
  failedCount = 0;
  errors = [];
  type = "PostNLPAnalyzerAst";
};
_ts_decorate37([
  Input36({
    title: "\u5E16\u5B50\u5B9E\u4F53",
    defaultValue: null
  }),
  _ts_metadata37("design:type", typeof WeiboPostEntity === "undefined" ? Object : WeiboPostEntity)
], PostNLPAnalyzerAst.prototype, "post", void 0);
_ts_decorate37([
  Input36({
    title: "\u8BC4\u8BBA\u5217\u8868",
    defaultValue: []
  }),
  _ts_metadata37("design:type", Array)
], PostNLPAnalyzerAst.prototype, "comments", void 0);
_ts_decorate37([
  Input36({
    title: "\u8F6C\u53D1\u5217\u8868",
    defaultValue: []
  }),
  _ts_metadata37("design:type", Array)
], PostNLPAnalyzerAst.prototype, "reposts", void 0);
_ts_decorate37([
  Input36({
    title: "\u4E8B\u4EF6ID",
    defaultValue: ""
  }),
  _ts_metadata37("design:type", String)
], PostNLPAnalyzerAst.prototype, "event_id", void 0);
_ts_decorate37([
  Output36({
    title: "NLP \u5206\u6790\u7ED3\u679C",
    defaultValue: ""
  }),
  _ts_metadata37("design:type", Object)
], PostNLPAnalyzerAst.prototype, "nlpResult", void 0);
_ts_decorate37([
  Output36({
    title: "\u5DF2\u5173\u8054\u4E8B\u4EF6",
    defaultValue: false
  })
], PostNLPAnalyzerAst.prototype, "event_associated", void 0);
_ts_decorate37([
  Output36({
    title: "\u5931\u8D25\u6570\u91CF",
    defaultValue: 0
  }),
  _ts_metadata37("design:type", Number)
], PostNLPAnalyzerAst.prototype, "failedCount", void 0);
_ts_decorate37([
  Output36({
    title: "\u9519\u8BEF\u8BE6\u60C5",
    defaultValue: []
  }),
  _ts_metadata37("design:type", typeof Array === "undefined" ? Object : Array)
], PostNLPAnalyzerAst.prototype, "errors", void 0);
PostNLPAnalyzerAst = _ts_decorate37([
  Node37({
    title: "\u5E16\u5B50 NLP \u5206\u6790\u5668",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], PostNLPAnalyzerAst);

// src/crawler/PostContextCollectorAst.ts
import { Ast as Ast38, Input as Input37, IS_MULTI as IS_MULTI22, Node as Node38, Output as Output37 } from "@sker/workflow";
function _ts_decorate38(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate38, "_ts_decorate");
function _ts_metadata38(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata38, "_ts_metadata");
var PostContextCollectorAst = class extends Ast38 {
  static {
    __name(this, "PostContextCollectorAst");
  }
  postId = "";
  canStart = [];
  post = ``;
  comments = [];
  reposts = [];
  event_id = "";
  type = "PostContextCollectorAst";
};
_ts_decorate38([
  Input37({
    title: "\u5E16\u5B50ID",
    defaultValue: ""
  }),
  _ts_metadata38("design:type", String)
], PostContextCollectorAst.prototype, "postId", void 0);
_ts_decorate38([
  Input37({
    mode: IS_MULTI22,
    title: "\u5F00\u59CB",
    defaultValue: []
  }),
  _ts_metadata38("design:type", Array)
], PostContextCollectorAst.prototype, "canStart", void 0);
_ts_decorate38([
  Output37({
    title: "\u5E16\u5B50\u5B9E\u4F53",
    defaultValue: ""
  }),
  _ts_metadata38("design:type", Object)
], PostContextCollectorAst.prototype, "post", void 0);
_ts_decorate38([
  Output37({
    title: "\u8BC4\u8BBA\u5217\u8868",
    defaultValue: []
  }),
  _ts_metadata38("design:type", Array)
], PostContextCollectorAst.prototype, "comments", void 0);
_ts_decorate38([
  Output37({
    title: "\u8F6C\u53D1\u5217\u8868",
    defaultValue: []
  }),
  _ts_metadata38("design:type", Array)
], PostContextCollectorAst.prototype, "reposts", void 0);
_ts_decorate38([
  Output37({
    title: "\u4E8B\u4EF6ID",
    defaultValue: ""
  }),
  _ts_metadata38("design:type", String)
], PostContextCollectorAst.prototype, "event_id", void 0);
PostContextCollectorAst = _ts_decorate38([
  Node38({
    title: "\u5E16\u5B50\u4E0A\u4E0B\u6587\u6536\u96C6\u5668",
    type: "crawler"
  })
], PostContextCollectorAst);

// src/crawler/PostNLPLooperAst.ts
import { Ast as Ast39, Input as Input38, Node as Node39, Output as Output38 } from "@sker/workflow";
function _ts_decorate39(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate39, "_ts_decorate");
function _ts_metadata39(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata39, "_ts_metadata");
var PostNLPLooperAst = class extends Ast39 {
  static {
    __name(this, "PostNLPLooperAst");
  }
  /**
  * 每批处理数量（控制内存）
  */
  pageSize = 10;
  /**
  * 输入游标：用于分页查询的起始位置
  */
  inputCursor = null;
  /**
  * 输出游标：当前批次最后一条记录的时间戳
  */
  outputCursor = null;
  /**
  * 发射的帖子
  */
  postId;
  event_id;
  hasMore;
  type = "PostNLPLooperAst";
};
_ts_decorate39([
  Input38({
    title: "\u6BCF\u6279\u6570\u91CF",
    type: "number",
    defaultValue: 10
  }),
  _ts_metadata39("design:type", Number)
], PostNLPLooperAst.prototype, "pageSize", void 0);
_ts_decorate39([
  Input38({
    title: "\u8F93\u5165\u6E38\u6807",
    defaultValue: null,
    type: "string"
  }),
  _ts_metadata39("design:type", Object)
], PostNLPLooperAst.prototype, "inputCursor", void 0);
_ts_decorate39([
  Output38({
    title: "\u8F93\u51FA\u6E38\u6807"
  }),
  _ts_metadata39("design:type", Object)
], PostNLPLooperAst.prototype, "outputCursor", void 0);
_ts_decorate39([
  Output38({
    title: "\u5E16\u5B50ID"
  }),
  _ts_metadata39("design:type", String)
], PostNLPLooperAst.prototype, "postId", void 0);
_ts_decorate39([
  Output38({
    title: "\u4E8B\u4EF6ID",
    defaultValue: null
  }),
  _ts_metadata39("design:type", Object)
], PostNLPLooperAst.prototype, "event_id", void 0);
_ts_decorate39([
  Output38({
    title: "\u662F\u5426\u6709\u4E0B\u4E00\u9875",
    isRouter: true,
    defaultValue: true
  }),
  _ts_metadata39("design:type", Boolean)
], PostNLPLooperAst.prototype, "hasMore", void 0);
PostNLPLooperAst = _ts_decorate39([
  Node39({
    title: "\u5E16\u5B50 NLP \u5FAA\u73AF\u5668",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], PostNLPLooperAst);

// src/crawler/EventAuthGenerateAst.ts
import { Ast as Ast40, Input as Input39, Node as Node40, Output as Output39 } from "@sker/workflow";
function _ts_decorate40(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate40, "_ts_decorate");
function _ts_metadata40(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata40, "_ts_metadata");
var EventAuthGenerateAst = class extends Ast40 {
  static {
    __name(this, "EventAuthGenerateAst");
  }
  userInput = "";
  systemPromptTemplate = "";
  model = "deepseek-ai/DeepSeek-V3.2";
  temperature = 0.3;
  forceInsert = false;
  event = null;
  event_id = "";
  event_title = "";
  insertSuccess = false;
  alreadyExists = false;
  errorMessage = "";
  type = "EventAuthGenerateAst";
};
_ts_decorate40([
  Input39({
    title: "\u7528\u6237\u8F93\u5165\u6570\u636E",
    type: "textarea",
    defaultValue: ""
  }),
  _ts_metadata40("design:type", String)
], EventAuthGenerateAst.prototype, "userInput", void 0);
_ts_decorate40([
  Input39({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD\u6A21\u677F",
    type: "textarea",
    defaultValue: ""
  }),
  _ts_metadata40("design:type", String)
], EventAuthGenerateAst.prototype, "systemPromptTemplate", void 0);
_ts_decorate40([
  Input39({
    title: "LLM \u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata40("design:type", String)
], EventAuthGenerateAst.prototype, "model", void 0);
_ts_decorate40([
  Input39({
    title: "\u6E29\u5EA6",
    defaultValue: 0.3
  }),
  _ts_metadata40("design:type", Number)
], EventAuthGenerateAst.prototype, "temperature", void 0);
_ts_decorate40([
  Input39({
    title: "\u5F3A\u5236\u63D2\u5165",
    defaultValue: false
  }),
  _ts_metadata40("design:type", Boolean)
], EventAuthGenerateAst.prototype, "forceInsert", void 0);
_ts_decorate40([
  Output39({
    title: "\u751F\u6210\u7684\u4E8B\u4EF6\u5B9E\u4F53",
    defaultValue: null
  }),
  _ts_metadata40("design:type", Object)
], EventAuthGenerateAst.prototype, "event", void 0);
_ts_decorate40([
  Output39({
    title: "\u4E8B\u4EF6ID",
    defaultValue: ""
  }),
  _ts_metadata40("design:type", String)
], EventAuthGenerateAst.prototype, "event_id", void 0);
_ts_decorate40([
  Output39({
    title: "\u4E8B\u4EF6\u6807\u9898",
    defaultValue: ""
  }),
  _ts_metadata40("design:type", String)
], EventAuthGenerateAst.prototype, "event_title", void 0);
_ts_decorate40([
  Output39({
    title: "\u662F\u5426\u63D2\u5165\u6210\u529F",
    defaultValue: false
  }),
  _ts_metadata40("design:type", Boolean)
], EventAuthGenerateAst.prototype, "insertSuccess", void 0);
_ts_decorate40([
  Output39({
    title: "\u662F\u5426\u5DF2\u5B58\u5728",
    defaultValue: false
  }),
  _ts_metadata40("design:type", Boolean)
], EventAuthGenerateAst.prototype, "alreadyExists", void 0);
_ts_decorate40([
  Output39({
    title: "\u9519\u8BEF\u4FE1\u606F",
    defaultValue: ""
  }),
  _ts_metadata40("design:type", String)
], EventAuthGenerateAst.prototype, "errorMessage", void 0);
EventAuthGenerateAst = _ts_decorate40([
  Node40({
    title: "\u4E8B\u4EF6\u6388\u6743\u751F\u6210\u5668",
    type: "crawler",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], EventAuthGenerateAst);

// src/basic/SqlExecuteAst.ts
import { Ast as Ast41, Input as Input40, Node as Node41, Output as Output40, State as State16 } from "@sker/workflow";
function _ts_decorate41(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate41, "_ts_decorate");
function _ts_metadata41(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata41, "_ts_metadata");
var SqlExecuteAst = class extends Ast41 {
  static {
    __name(this, "SqlExecuteAst");
  }
  sql = "";
  parameters = [];
  trigger = true;
  results = [];
  affectedRows = 0;
  columns = [];
  type = "SqlExecuteAst";
};
_ts_decorate41([
  State16({
    title: "SQL \u8BED\u53E5"
  })
], SqlExecuteAst.prototype, "sql", void 0);
_ts_decorate41([
  State16({
    title: "\u53C2\u6570"
  }),
  _ts_metadata41("design:type", Array)
], SqlExecuteAst.prototype, "parameters", void 0);
_ts_decorate41([
  Input40({
    title: "\u89E6\u53D1",
    defaultValue: true
  }),
  _ts_metadata41("design:type", Boolean)
], SqlExecuteAst.prototype, "trigger", void 0);
_ts_decorate41([
  Output40({
    title: "\u7ED3\u679C\u96C6",
    defaultValue: []
  }),
  _ts_metadata41("design:type", Array)
], SqlExecuteAst.prototype, "results", void 0);
_ts_decorate41([
  Output40({
    title: "\u5F71\u54CD\u884C\u6570",
    defaultValue: 0
  })
], SqlExecuteAst.prototype, "affectedRows", void 0);
_ts_decorate41([
  Output40({
    title: "\u5217\u4FE1\u606F",
    defaultValue: []
  }),
  _ts_metadata41("design:type", Array)
], SqlExecuteAst.prototype, "columns", void 0);
SqlExecuteAst = _ts_decorate41([
  Node41({
    title: "SQL \u6267\u884C",
    type: "basic",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], SqlExecuteAst);

// src/basic/ExcelUploadAst.ts
import { Ast as Ast42, Input as Input41, Node as Node42, Output as Output41, State as State17 } from "@sker/workflow";
function _ts_decorate42(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate42, "_ts_decorate");
function _ts_metadata42(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata42, "_ts_metadata");
var ExcelUploadAst = class extends Ast42 {
  static {
    __name(this, "ExcelUploadAst");
  }
  fileUrl = "";
  sheetName = "Sheet1";
  startRow = 1;
  hasHeader = true;
  data = [];
  columns = [];
  rowCount = 0;
  rowIndex = 0;
  isFirst = false;
  isLast = false;
  type = "ExcelUploadAst";
};
_ts_decorate42([
  Input41({
    title: "\u6587\u4EF6 URL",
    defaultValue: ""
  }),
  _ts_metadata42("design:type", String)
], ExcelUploadAst.prototype, "fileUrl", void 0);
_ts_decorate42([
  Input41({
    title: "\u5DE5\u4F5C\u8868\u540D\u79F0",
    defaultValue: `Sheet1`,
    type: "string"
  }),
  _ts_metadata42("design:type", String)
], ExcelUploadAst.prototype, "sheetName", void 0);
_ts_decorate42([
  Input41({
    title: "\u8D77\u59CB\u884C",
    defaultValue: 1,
    type: "number"
  }),
  _ts_metadata42("design:type", Number)
], ExcelUploadAst.prototype, "startRow", void 0);
_ts_decorate42([
  State17({
    title: "\u5305\u542B\u8868\u5934"
  }),
  _ts_metadata42("design:type", Boolean)
], ExcelUploadAst.prototype, "hasHeader", void 0);
_ts_decorate42([
  Output41({
    title: "\u6570\u636E",
    defaultValue: []
  }),
  _ts_metadata42("design:type", Array)
], ExcelUploadAst.prototype, "data", void 0);
_ts_decorate42([
  Output41({
    title: "\u5217\u540D",
    defaultValue: []
  }),
  _ts_metadata42("design:type", Array)
], ExcelUploadAst.prototype, "columns", void 0);
_ts_decorate42([
  Output41({
    title: "\u884C\u6570",
    defaultValue: 0
  }),
  _ts_metadata42("design:type", Number)
], ExcelUploadAst.prototype, "rowCount", void 0);
_ts_decorate42([
  Output41({
    title: "\u884C\u7D22\u5F15",
    defaultValue: 0
  }),
  _ts_metadata42("design:type", Number)
], ExcelUploadAst.prototype, "rowIndex", void 0);
_ts_decorate42([
  Output41({
    title: "\u662F\u5426\u9996\u884C",
    defaultValue: false
  }),
  _ts_metadata42("design:type", Boolean)
], ExcelUploadAst.prototype, "isFirst", void 0);
_ts_decorate42([
  Output41({
    title: "\u662F\u5426\u672B\u884C",
    defaultValue: false
  }),
  _ts_metadata42("design:type", Boolean)
], ExcelUploadAst.prototype, "isLast", void 0);
ExcelUploadAst = _ts_decorate42([
  Node42({
    title: "Excel \u4E0A\u4F20",
    type: "basic",
    errorStrategy: "fail"
  })
], ExcelUploadAst);

// src/basic/MarkdownUploadAst.ts
import { Ast as Ast43, Input as Input42, Node as Node43, Output as Output42 } from "@sker/workflow";
function _ts_decorate43(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate43, "_ts_decorate");
function _ts_metadata43(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata43, "_ts_metadata");
var MarkdownUploadAst = class extends Ast43 {
  static {
    __name(this, "MarkdownUploadAst");
  }
  fileUrl = "";
  rawContent = "";
  htmlContent = "";
  plainText = "";
  headings = [];
  type = "MarkdownUploadAst";
};
_ts_decorate43([
  Input42({
    title: "\u6587\u4EF6 URL",
    type: "text",
    defaultValue: ""
  }),
  _ts_metadata43("design:type", String)
], MarkdownUploadAst.prototype, "fileUrl", void 0);
_ts_decorate43([
  Output42({
    title: "\u539F\u59CB\u5185\u5BB9",
    defaultValue: ""
  }),
  _ts_metadata43("design:type", String)
], MarkdownUploadAst.prototype, "rawContent", void 0);
_ts_decorate43([
  Output42({
    title: "HTML \u5185\u5BB9",
    defaultValue: ""
  }),
  _ts_metadata43("design:type", String)
], MarkdownUploadAst.prototype, "htmlContent", void 0);
_ts_decorate43([
  Output42({
    title: "\u7EAF\u6587\u672C",
    defaultValue: ""
  }),
  _ts_metadata43("design:type", String)
], MarkdownUploadAst.prototype, "plainText", void 0);
_ts_decorate43([
  Output42({
    title: "\u6807\u9898\u5217\u8868",
    defaultValue: []
  }),
  _ts_metadata43("design:type", Array)
], MarkdownUploadAst.prototype, "headings", void 0);
MarkdownUploadAst = _ts_decorate43([
  Node43({
    title: "Markdown \u4E0A\u4F20",
    type: "basic",
    errorStrategy: "fail"
  })
], MarkdownUploadAst);

// src/basic/EmailD1Ast.ts
import { Ast as Ast44, Input as Input43, Node as Node44, Output as Output43 } from "@sker/workflow";
function _ts_decorate44(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate44, "_ts_decorate");
function _ts_metadata44(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata44, "_ts_metadata");
var EmailD1Ast = class extends Ast44 {
  static {
    __name(this, "EmailD1Ast");
  }
  apiUrl = "https://email.bowong.cc";
  domain = "email.bowong.cc";
  trigger = true;
  email = "";
  message = void 0;
  type = "EmailD1Ast";
};
_ts_decorate44([
  Input43({
    title: "API\u5730\u5740",
    defaultValue: "https://email.bowong.cc"
  })
], EmailD1Ast.prototype, "apiUrl", void 0);
_ts_decorate44([
  Input43({
    title: "\u90AE\u7BB1\u57DF\u540D",
    defaultValue: "email.bowong.cc"
  })
], EmailD1Ast.prototype, "domain", void 0);
_ts_decorate44([
  Input43({
    title: "\u89E6\u53D1",
    defaultValue: true
  })
], EmailD1Ast.prototype, "trigger", void 0);
_ts_decorate44([
  Output43({
    title: "\u90AE\u7BB1\u5730\u5740",
    defaultValue: ""
  })
], EmailD1Ast.prototype, "email", void 0);
_ts_decorate44([
  Output43({
    title: "\u90AE\u4EF6\u5185\u5BB9",
    defaultValue: void 0
  }),
  _ts_metadata44("design:type", Object)
], EmailD1Ast.prototype, "message", void 0);
EmailD1Ast = _ts_decorate44([
  Node44({
    title: "\u4E34\u65F6\u90AE\u7BB1",
    type: "basic",
    errorStrategy: "fail"
  })
], EmailD1Ast);

// src/basic/ShareAst.ts
import { Ast as Ast45, Input as Input44, Node as Node45, Output as Output44 } from "@sker/workflow";
function _ts_decorate45(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate45, "_ts_decorate");
function _ts_metadata45(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata45, "_ts_metadata");
var ShareAst = class extends Ast45 {
  static {
    __name(this, "ShareAst");
  }
  // === 输入：收集所有上游消息 ===
  prompt = ``;
  username = ``;
  profile = ``;
  /**
   * 历史对话记录输入 - 用于循环场景
   *
   * 设计意图:
   * - 在循环工作流中,接收上一轮迭代的完整对话历史
   * - 避免因节点克隆导致的状态丢失
   * - 新消息会追加到此历史记录中
   */
  previousHistory = [];
  // === 输出：对话历史 ===
  chatHistory = [];
  formattedHistory = ``;
  type = `ShareAst`;
};
_ts_decorate45([
  Input44({
    title: "\u6D88\u606F\u8F93\u5165",
    defaultValue: ""
  }),
  _ts_metadata45("design:type", String)
], ShareAst.prototype, "prompt", void 0);
_ts_decorate45([
  Input44({
    title: "\u540D\u79F0",
    defaultValue: ""
  }),
  _ts_metadata45("design:type", String)
], ShareAst.prototype, "username", void 0);
_ts_decorate45([
  Input44({
    title: "\u4ECB\u7ECD",
    defaultValue: ""
  }),
  _ts_metadata45("design:type", String)
], ShareAst.prototype, "profile", void 0);
_ts_decorate45([
  Input44({
    title: "\u5386\u53F2\u8BB0\u5F55\u8F93\u5165",
    required: false,
    defaultValue: []
  }),
  _ts_metadata45("design:type", Array)
], ShareAst.prototype, "previousHistory", void 0);
_ts_decorate45([
  Output44({
    title: "\u5BF9\u8BDD\u5386\u53F2",
    defaultValue: []
  }),
  _ts_metadata45("design:type", Array)
], ShareAst.prototype, "chatHistory", void 0);
_ts_decorate45([
  Output44({
    title: "\u683C\u5F0F\u5316\u5386\u53F2",
    defaultValue: ""
  }),
  _ts_metadata45("design:type", String)
], ShareAst.prototype, "formattedHistory", void 0);
ShareAst = _ts_decorate45([
  Node45({
    type: "basic",
    title: "\u7FA4\u804A\u5BA4"
  })
], ShareAst);

// src/basic/EventAst.ts
import { Ast as Ast46, Input as Input45, Node as Node46, Output as Output45, State as State18 } from "@sker/workflow";
function _ts_decorate46(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate46, "_ts_decorate");
function _ts_metadata46(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata46, "_ts_metadata");
var EventAst = class extends Ast46 {
  static {
    __name(this, "EventAst");
  }
  eventId;
  eventTitle;
  eventCategory;
  trigger = true;
  event = null;
  event_id = "";
  event_title = "";
  startTime = "";
  keywords = [];
  keywords_str = "";
  post_min_time = "";
  post_max_time = "";
  is_crawl_complete = false;
  type = "EventAst";
};
_ts_decorate46([
  State18({
    title: "\u4E8B\u4EF6ID"
  }),
  _ts_metadata46("design:type", String)
], EventAst.prototype, "eventId", void 0);
_ts_decorate46([
  State18({
    title: "\u4E8B\u4EF6\u6807\u9898"
  }),
  _ts_metadata46("design:type", String)
], EventAst.prototype, "eventTitle", void 0);
_ts_decorate46([
  State18({
    title: "\u4E8B\u4EF6\u5206\u7C7B"
  }),
  _ts_metadata46("design:type", String)
], EventAst.prototype, "eventCategory", void 0);
_ts_decorate46([
  Input45({
    title: "\u89E6\u53D1",
    defaultValue: true
  }),
  _ts_metadata46("design:type", Boolean)
], EventAst.prototype, "trigger", void 0);
_ts_decorate46([
  Output45({
    title: "\u4E8B\u4EF6",
    defaultValue: null
  }),
  _ts_metadata46("design:type", Object)
], EventAst.prototype, "event", void 0);
_ts_decorate46([
  Output45({
    title: "\u4E8B\u4EF6ID",
    defaultValue: ""
  })
], EventAst.prototype, "event_id", void 0);
_ts_decorate46([
  Output45({
    title: "\u4E8B\u4EF6\u6807\u9898",
    defaultValue: ""
  })
], EventAst.prototype, "event_title", void 0);
_ts_decorate46([
  Output45({
    title: "\u5F00\u59CB\u65F6\u95F4",
    defaultValue: ""
  })
], EventAst.prototype, "startTime", void 0);
_ts_decorate46([
  Output45({
    title: "\u5173\u952E\u5B57\u5217\u8868",
    defaultValue: []
  }),
  _ts_metadata46("design:type", Array)
], EventAst.prototype, "keywords", void 0);
_ts_decorate46([
  Output45({
    title: "\u5173\u952E\u5B57\u5B57\u7B26\u4E32",
    defaultValue: ""
  })
], EventAst.prototype, "keywords_str", void 0);
_ts_decorate46([
  Output45({
    title: "\u5E16\u5B50\u6700\u65E9\u65F6\u95F4",
    defaultValue: ""
  })
], EventAst.prototype, "post_min_time", void 0);
_ts_decorate46([
  Output45({
    title: "\u5E16\u5B50\u6700\u665A\u65F6\u95F4",
    defaultValue: ""
  })
], EventAst.prototype, "post_max_time", void 0);
_ts_decorate46([
  Output45({
    title: "\u722C\u53D6\u5B8C\u6210",
    defaultValue: false
  })
], EventAst.prototype, "is_crawl_complete", void 0);
EventAst = _ts_decorate46([
  Node46({
    title: "\u4E8B\u4EF6\u9009\u62E9\u5668",
    type: "basic",
    errorStrategy: "fail"
  })
], EventAst);

// src/basic/PropertySelectorAst.ts
import { Ast as Ast47, Input as Input46, Node as Node47, Output as Output46, State as State19 } from "@sker/workflow";
function _ts_decorate47(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate47, "_ts_decorate");
function _ts_metadata47(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata47, "_ts_metadata");
var PropertySelectorAst = class extends Ast47 {
  static {
    __name(this, "PropertySelectorAst");
  }
  path = "";
  data = null;
  value = null;
  type = "PropertySelectorAst";
};
_ts_decorate47([
  State19({
    title: "\u5C5E\u6027\u8DEF\u5F84"
  }),
  _ts_metadata47("design:type", String)
], PropertySelectorAst.prototype, "path", void 0);
_ts_decorate47([
  Input46({
    title: "\u6570\u636E",
    defaultValue: null
  }),
  _ts_metadata47("design:type", Object)
], PropertySelectorAst.prototype, "data", void 0);
_ts_decorate47([
  Output46({
    title: "\u63D0\u53D6\u503C",
    defaultValue: null
  }),
  _ts_metadata47("design:type", Object)
], PropertySelectorAst.prototype, "value", void 0);
PropertySelectorAst = _ts_decorate47([
  Node47({
    title: "\u5C5E\u6027\u9009\u62E9\u5668",
    type: "basic",
    errorStrategy: "fail"
  })
], PropertySelectorAst);

// src/basic/LastAst.ts
import { Ast as Ast48, Input as Input47, Node as Node48, Output as Output47 } from "@sker/workflow";
function _ts_decorate48(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate48, "_ts_decorate");
function _ts_metadata48(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata48, "_ts_metadata");
var LastAst = class extends Ast48 {
  static {
    __name(this, "LastAst");
  }
  input = null;
  last = null;
  type = "LastAst";
};
_ts_decorate48([
  Input47({
    title: "\u8F93\u5165",
    defaultValue: null
  }),
  _ts_metadata48("design:type", Object)
], LastAst.prototype, "input", void 0);
_ts_decorate48([
  Output47({
    title: "\u6700\u540E\u503C",
    defaultValue: null
  }),
  _ts_metadata48("design:type", Object)
], LastAst.prototype, "last", void 0);
LastAst = _ts_decorate48([
  Node48({
    title: "\u53D6\u6700\u540E\u503C",
    type: "basic",
    errorStrategy: "fail"
  })
], LastAst);

// src/basic/ClaudeCodeAst.ts
import { Ast as Ast49, Input as Input48, IS_MULTI as IS_MULTI23, Node as Node49, Output as Output48, State as State20 } from "@sker/workflow";
function _ts_decorate49(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate49, "_ts_decorate");
function _ts_metadata49(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata49, "_ts_metadata");
var ClaudeCodeAst = class extends Ast49 {
  static {
    __name(this, "ClaudeCodeAst");
  }
  command = "claude";
  args = [
    "--output-format",
    "stream-json",
    "--verbose",
    "--permission-prompt-tool",
    "stdio",
    "--dangerously-skip-permissions"
  ];
  stdin = [];
  pid = 0;
  duration = 0;
  stdout = null;
  stderr = null;
  result;
  type = "ClaudeCodeAst";
};
_ts_decorate49([
  State20({
    title: "\u547D\u4EE4\u8DEF\u5F84/\u540D\u79F0"
  }),
  _ts_metadata49("design:type", String)
], ClaudeCodeAst.prototype, "command", void 0);
_ts_decorate49([
  State20({
    title: "\u547D\u4EE4\u53C2\u6570",
    defaultValue: [
      "--output-format",
      "stream-json",
      "--verbose",
      "--permission-prompt-tool",
      "stdio",
      "--dangerously-skip-permissions"
    ]
  }),
  _ts_metadata49("design:type", Array)
], ClaudeCodeAst.prototype, "args", void 0);
_ts_decorate49([
  Input48({
    title: "stdin \u8F93\u5165",
    required: false,
    defaultValue: [],
    mode: IS_MULTI23
  }),
  _ts_metadata49("design:type", Array)
], ClaudeCodeAst.prototype, "stdin", void 0);
_ts_decorate49([
  State20({
    title: "\u8FDB\u7A0BID"
  }),
  _ts_metadata49("design:type", Number)
], ClaudeCodeAst.prototype, "pid", void 0);
_ts_decorate49([
  State20({
    title: "\u6267\u884C\u8017\u65F6\uFF08\u6BEB\u79D2\uFF09"
  }),
  _ts_metadata49("design:type", Number)
], ClaudeCodeAst.prototype, "duration", void 0);
_ts_decorate49([
  Output48({
    title: "\u6D41\u5F0F\u4E8B\u4EF6\u8F93\u51FA"
  }),
  _ts_metadata49("design:type", Object)
], ClaudeCodeAst.prototype, "stdout", void 0);
_ts_decorate49([
  Output48({
    title: "\u9519\u8BEF"
  }),
  _ts_metadata49("design:type", Object)
], ClaudeCodeAst.prototype, "stderr", void 0);
_ts_decorate49([
  Output48({
    title: "\u6267\u884C\u7ED3\u679C"
  }),
  _ts_metadata49("design:type", String)
], ClaudeCodeAst.prototype, "result", void 0);
ClaudeCodeAst = _ts_decorate49([
  Node49({
    title: "\u7F16\u7A0B\u52A9\u624B",
    type: "basic",
    errorStrategy: "retry",
    maxRetries: 2,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], ClaudeCodeAst);

// src/basic/SmartAstV1.ts
import { Ast as Ast50, Input as Input49, Node as Node50, Output as Output49 } from "@sker/workflow";
function _ts_decorate50(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate50, "_ts_decorate");
function _ts_metadata50(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata50, "_ts_metadata");
var SmartAstV1 = class extends Ast50 {
  static {
    __name(this, "SmartAstV1");
  }
  model = "deepseek-ai/DeepSeek-V3.2";
  temperature = 0.3;
  dispatchComplete = false;
  type = "SmartAstV1";
};
_ts_decorate50([
  Input49({
    title: "LLM \u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2",
    description: "\u7528\u4E8E\u5206\u6790\u548C\u5206\u53D1\u6570\u636E\u7684\u5927\u6A21\u578B"
  }),
  _ts_metadata50("design:type", String)
], SmartAstV1.prototype, "model", void 0);
_ts_decorate50([
  Input49({
    title: "\u6E29\u5EA6\u53C2\u6570",
    type: "number",
    defaultValue: 0.3,
    description: "LLM \u751F\u6210\u7684\u968F\u673A\u6027\uFF0C\u8F83\u4F4E\u503C\u4F7F\u8F93\u51FA\u66F4\u786E\u5B9A"
  }),
  _ts_metadata50("design:type", Number)
], SmartAstV1.prototype, "temperature", void 0);
_ts_decorate50([
  Output49({
    title: "\u5206\u53D1\u5B8C\u6210",
    type: "boolean",
    defaultValue: false,
    isRouter: true,
    description: "\u6240\u6709\u9879\u5206\u53D1\u5B8C\u6210\u65F6\u89E6\u53D1"
  }),
  _ts_metadata50("design:type", Boolean)
], SmartAstV1.prototype, "dispatchComplete", void 0);
SmartAstV1 = _ts_decorate50([
  Node50({
    title: "\u667A\u80FD\u5206\u53D1\u5668",
    type: "control",
    errorStrategy: "retry",
    maxRetries: 2,
    retryDelay: 1e3,
    retryBackoff: 2,
    dynamicOutputs: true,
    dynamicInputs: true
  })
], SmartAstV1);

// src/control/LlmCategoryAst.ts
import { Ast as Ast51, Input as Input50, IS_MULTI as IS_MULTI24, Node as Node51, Output as Output50 } from "@sker/workflow";
function _ts_decorate51(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate51, "_ts_decorate");
function _ts_metadata51(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata51, "_ts_metadata");
var LlmCategoryAst = class extends Ast51 {
  static {
    __name(this, "LlmCategoryAst");
  }
  context = [];
  system = "\u4F60\u662F\u4E00\u4E2A\u6587\u672C\u5206\u7C7B\u4E13\u5BB6\u3002\u6839\u636E\u7528\u6237\u63D0\u4F9B\u7684\u6587\u672C\uFF0C\u5224\u65AD\u5176\u6240\u5C5E\u7C7B\u522B\u3002";
  temperature = 0;
  model = "deepseek-ai/DeepSeek-V3.2";
  output_default = ``;
  rawOutput = ``;
  type = "LlmCategoryAst";
};
_ts_decorate51([
  Input50({
    title: "\u5F85\u5206\u7C7B\u6587\u672C",
    mode: IS_MULTI24,
    defaultValue: []
  }),
  _ts_metadata51("design:type", Array)
], LlmCategoryAst.prototype, "context", void 0);
_ts_decorate51([
  Input50({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD",
    type: "textarea",
    defaultValue: "\u4F60\u662F\u4E00\u4E2A\u6587\u672C\u5206\u7C7B\u4E13\u5BB6\u3002\u6839\u636E\u7528\u6237\u63D0\u4F9B\u7684\u6587\u672C\uFF0C\u5224\u65AD\u5176\u6240\u5C5E\u7C7B\u522B\u3002"
  }),
  _ts_metadata51("design:type", String)
], LlmCategoryAst.prototype, "system", void 0);
_ts_decorate51([
  Input50({
    title: "\u6E29\u5EA6",
    defaultValue: 0
  }),
  _ts_metadata51("design:type", Number)
], LlmCategoryAst.prototype, "temperature", void 0);
_ts_decorate51([
  Input50({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata51("design:type", String)
], LlmCategoryAst.prototype, "model", void 0);
_ts_decorate51([
  Output50({
    title: "Default",
    isRouter: true,
    defaultValue: ""
  })
], LlmCategoryAst.prototype, "output_default", void 0);
_ts_decorate51([
  Output50({
    title: "\u539F\u59CB\u8F93\u51FA",
    defaultValue: ""
  })
], LlmCategoryAst.prototype, "rawOutput", void 0);
LlmCategoryAst = _ts_decorate51([
  Node51({
    title: "\u5206\u7C7B\u5668",
    type: "control",
    dynamicOutputs: true,
    errorStrategy: "retry",
    maxRetries: 5,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], LlmCategoryAst);

// src/control/StoryQualityLoopAst.ts
import { Ast as Ast52, Input as Input51, IS_MULTI as IS_MULTI25, IS_BUFFER as IS_BUFFER8, Node as Node52, Output as Output51 } from "@sker/workflow";
function _ts_decorate52(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate52, "_ts_decorate");
function _ts_metadata52(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata52, "_ts_metadata");
var StoryQualityLoopAst = class extends Ast52 {
  static {
    __name(this, "StoryQualityLoopAst");
  }
  // === 输入配置 ===
  minQualityScore = 70;
  maxRetries = 3;
  qualityResults = [];
  // === 输出端口 ===
  rewriteRequest = void 0;
  finalChapter = void 0;
  currentAttempt = 0;
  isComplete = false;
  type = "StoryQualityLoopAst";
};
_ts_decorate52([
  Input51({
    title: "\u6700\u4F4E\u8D28\u91CF\u5206\u6570",
    defaultValue: 70
  }),
  _ts_metadata52("design:type", Number)
], StoryQualityLoopAst.prototype, "minQualityScore", void 0);
_ts_decorate52([
  Input51({
    title: "\u6700\u5927\u91CD\u8BD5\u6B21\u6570",
    defaultValue: 3
  }),
  _ts_metadata52("design:type", Number)
], StoryQualityLoopAst.prototype, "maxRetries", void 0);
_ts_decorate52([
  Input51({
    mode: IS_BUFFER8 | IS_MULTI25,
    title: "\u8D28\u68C0\u7ED3\u679C",
    defaultValue: []
  }),
  _ts_metadata52("design:type", Array)
], StoryQualityLoopAst.prototype, "qualityResults", void 0);
_ts_decorate52([
  Output51({
    title: "\u91CD\u5199\u8BF7\u6C42\uFF08\u5FAA\u73AF\uFF09",
    isRouter: true,
    defaultValue: void 0
  }),
  _ts_metadata52("design:type", Object)
], StoryQualityLoopAst.prototype, "rewriteRequest", void 0);
_ts_decorate52([
  Output51({
    title: "\u6700\u7EC8\u7AE0\u8282",
    isRouter: true,
    defaultValue: void 0
  }),
  _ts_metadata52("design:type", Object)
], StoryQualityLoopAst.prototype, "finalChapter", void 0);
_ts_decorate52([
  Output51({
    title: "\u5F53\u524D\u5C1D\u8BD5\u6B21\u6570",
    defaultValue: 0
  })
], StoryQualityLoopAst.prototype, "currentAttempt", void 0);
_ts_decorate52([
  Output51({
    title: "\u662F\u5426\u5B8C\u6210",
    defaultValue: false
  })
], StoryQualityLoopAst.prototype, "isComplete", void 0);
StoryQualityLoopAst = _ts_decorate52([
  Node52({
    type: "control",
    title: "\u6545\u4E8B\u8D28\u91CF\u5FAA\u73AF"
  })
], StoryQualityLoopAst);

// src/sentiment/InsightAgentAst.ts
import { Ast as Ast53, Input as Input52, IS_MULTI as IS_MULTI26, Node as Node53, Output as Output52 } from "@sker/workflow";
function _ts_decorate53(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate53, "_ts_decorate");
function _ts_metadata53(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata53, "_ts_metadata");
var InsightAgentAst = class extends Ast53 {
  static {
    __name(this, "InsightAgentAst");
  }
  temperature = 0.7;
  top_p = 0.9;
  systemPrompt = `\u4F60\u662F\u4E00\u4F4D\u4E13\u4E1A\u7684\u8206\u60C5\u5206\u6790\u5E08\u548C\u6DF1\u5EA6\u5185\u5BB9\u521B\u4F5C\u4E13\u5BB6\u3002\u4F60\u5C06\u83B7\u5F97\u4E30\u5BCC\u7684\u771F\u5B9E\u793E\u4EA4\u5A92\u4F53\u6570\u636E\uFF0C\u9700\u8981\u5C06\u5176\u8F6C\u5316\u4E3A\u6DF1\u5EA6\u3001\u5168\u9762\u7684\u8206\u60C5\u5206\u6790\u6BB5\u843D\u3002

## \u6838\u5FC3\u4EFB\u52A1

\u521B\u5EFA\u4FE1\u606F\u5BC6\u96C6\u3001\u6570\u636E\u4E30\u5BCC\u7684\u8206\u60C5\u5206\u6790\u6BB5\u843D

## \u53EF\u7528\u5DE5\u5177

1. **search_hot_content** - \u67E5\u627E\u70ED\u70B9\u5185\u5BB9\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u6316\u6398\u5F53\u524D\u6700\u53D7\u5173\u6CE8\u7684\u8206\u60C5\u4E8B\u4EF6\u548C\u8BDD\u9898
   - \u7279\u70B9\uFF1A\u57FA\u4E8E\u771F\u5B9E\u7684\u70B9\u8D5E\u3001\u8BC4\u8BBA\u3001\u5206\u4EAB\u6570\u636E\u53D1\u73B0\u70ED\u95E8\u8BDD\u9898\uFF0C\u81EA\u52A8\u8FDB\u884C\u60C5\u611F\u5206\u6790
   - \u53C2\u6570\uFF1Atime_period ('24h', 'week', 'year')\uFF0Cenable_sentiment\uFF08\u9ED8\u8BA4True\uFF09

2. **search_topic_globally** - \u5168\u5C40\u8BDD\u9898\u641C\u7D22\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u5168\u9762\u4E86\u89E3\u516C\u4F17\u5BF9\u7279\u5B9A\u8BDD\u9898\u7684\u8BA8\u8BBA\u548C\u89C2\u70B9
   - \u7279\u70B9\uFF1A\u8986\u76D6\u591A\u4E2A\u4E3B\u6D41\u5E73\u53F0\u7684\u771F\u5B9E\u7528\u6237\u58F0\u97F3
   - \u53C2\u6570\uFF1Alimit_per_table\uFF0Cenable_sentiment\uFF08\u9ED8\u8BA4True\uFF09

3. **search_topic_by_date** - \u6309\u65E5\u671F\u641C\u7D22\u8BDD\u9898\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u8FFD\u8E2A\u8206\u60C5\u4E8B\u4EF6\u7684\u65F6\u95F4\u7EBF\u53D1\u5C55\u548C\u516C\u4F17\u60C5\u7EEA\u53D8\u5316
   - \u7279\u70B9\uFF1A\u7CBE\u786E\u7684\u65F6\u95F4\u8303\u56F4\u63A7\u5236\uFF0C\u9002\u5408\u5206\u6790\u8206\u60C5\u6F14\u53D8\u8FC7\u7A0B
   - \u7279\u6B8A\u8981\u6C42\uFF1A\u9700\u8981\u63D0\u4F9Bstart_date\u548Cend_date\u53C2\u6570\uFF0C\u683C\u5F0F\u4E3A'YYYY-MM-DD'

4. **get_comments_for_topic** - \u83B7\u53D6\u8BDD\u9898\u8BC4\u8BBA\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u6DF1\u5EA6\u6316\u6398\u7F51\u6C11\u7684\u771F\u5B9E\u6001\u5EA6\u3001\u60C5\u611F\u548C\u89C2\u70B9
   - \u7279\u70B9\uFF1A\u76F4\u63A5\u83B7\u53D6\u7528\u6237\u8BC4\u8BBA\uFF0C\u4E86\u89E3\u6C11\u610F\u8D70\u5411\u548C\u60C5\u611F\u503E\u5411

5. **search_topic_on_platform** - \u5E73\u53F0\u5B9A\u5411\u641C\u7D22\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u5206\u6790\u7279\u5B9A\u793E\u4EA4\u5E73\u53F0\u7528\u6237\u7FA4\u4F53\u7684\u89C2\u70B9\u7279\u5F81
   - \u7279\u70B9\uFF1A\u9488\u5BF9\u4E0D\u540C\u5E73\u53F0\u7528\u6237\u7FA4\u4F53\u7684\u89C2\u70B9\u5DEE\u5F02\u8FDB\u884C\u7CBE\u51C6\u5206\u6790

6. **analyze_sentiment** - \u591A\u8BED\u8A00\u60C5\u611F\u5206\u6790\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u5BF9\u6587\u672C\u5185\u5BB9\u8FDB\u884C\u4E13\u95E8\u7684\u60C5\u611F\u503E\u5411\u5206\u6790
   - \u7279\u70B9\uFF1A\u652F\u6301\u591A\u79CD\u8BED\u8A00\uFF0C\u8F93\u51FA5\u7EA7\u60C5\u611F\u7B49\u7EA7

## \u641C\u7D22\u8BCD\u8BBE\u8BA1\u539F\u5219

**\u60F3\u8C61\u7F51\u53CB\u600E\u4E48\u8BF4**\uFF1A\u5982\u679C\u4F60\u662F\u4E2A\u666E\u901A\u7F51\u53CB\uFF0C\u4F60\u4F1A\u600E\u4E48\u8BA8\u8BBA\u8FD9\u4E2A\u8BDD\u9898\uFF1F

- **\u907F\u514D\u5B66\u672F\u8BCD\u6C47**\uFF1A\u675C\u7EDD"\u8206\u60C5"\u3001"\u4F20\u64AD"\u3001"\u503E\u5411"\u7B49\u4E13\u4E1A\u672F\u8BED
- **\u4F7F\u7528\u5177\u4F53\u8BCD\u6C47**\uFF1A\u7528\u5177\u4F53\u7684\u4E8B\u4EF6\u3001\u4EBA\u540D\u3001\u5730\u540D\u3001\u73B0\u8C61\u63CF\u8FF0
- **\u5305\u542B\u60C5\u611F\u8868\u8FBE**\uFF1A\u5982"\u652F\u6301"\u3001"\u53CD\u5BF9"\u3001"\u62C5\u5FC3"\u3001"\u6124\u6012"\u3001"\u70B9\u8D5E"\u7B49
- **\u8003\u8651\u7F51\u7EDC\u6587\u5316**\uFF1A\u7F51\u6C11\u7684\u8868\u8FBE\u4E60\u60EF\u3001\u7F29\u5199\u3001\u4FDA\u8BED

### \u4E0D\u540C\u5E73\u53F0\u8BED\u8A00\u7279\u8272

- **\u70ED\u641C\u8BCD\u6C47**\uFF1A\u8BDD\u9898\u6807\u7B7E\uFF0C\u5982 "\u53C8\u4E0A\u70ED\u641C"\u3001"\u5FC3\u75BC"
- **\u95EE\u7B54\u5F0F\u8868\u8FBE**\uFF1A\u5982 "\u5982\u4F55\u770B\u5F85"\u3001"\u662F\u4EC0\u4E48\u4F53\u9A8C"
- **\u5F39\u5E55\u6587\u5316**\uFF1A\u5982 "yyds"\u3001"\u8DEF\u8FC7"
- **\u76F4\u63A5\u79F0\u547C**\uFF1A\u5982 "\u5427"\u3001"\u5144\u5F1F\u4EEC"
- **\u77ED\u89C6\u9891\u63CF\u8FF0**\uFF1A\u5982 "\u65E5\u5E38"\u3001"vlog"
- **\u5206\u4EAB\u5F0F**\uFF1A\u5982 "\u771F\u7684\u5F88\u7F8E"\u3001"\u653B\u7565"

### \u60C5\u611F\u8868\u8FBE\u8BCD\u6C47\u5E93

- **\u6B63\u9762**\uFF1A\u592A\u68D2\u4E86\u3001\u725B\u903C\u3001\u7EDD\u4E86\u3001\u7231\u4E86\u3001yyds\u3001666
- **\u8D1F\u9762**\uFF1A\u65E0\u8BED\u3001\u79BB\u8C31\u3001\u7EDD\u4E86\u3001\u670D\u4E86\u3001\u9EBB\u4E86\u3001\u7834\u9632
- **\u4E2D\u6027**\uFF1A\u56F4\u89C2\u3001\u5403\u74DC\u3001\u8DEF\u8FC7\u3001\u6709\u4E00\u8BF4\u4E00\u3001\u5B9E\u540D

## \u64B0\u5199\u6807\u51C6\uFF08\u6BCF\u6BB5\u4E0D\u5C11\u4E8E800-1200\u5B57\uFF09

### \u6570\u636E\u8BE6\u5B9E\u5448\u73B0
- **\u5927\u91CF\u5F15\u7528\u539F\u59CB\u6570\u636E**\uFF1A\u5177\u4F53\u7684\u7528\u6237\u8BC4\u8BBA\uFF08\u81F3\u5C115-8\u6761\u4EE3\u8868\u6027\u8BC4\u8BBA\uFF09
- **\u7CBE\u786E\u6570\u636E\u7EDF\u8BA1**\uFF1A\u70B9\u8D5E\u6570\u3001\u8BC4\u8BBA\u6570\u3001\u8F6C\u53D1\u6570\u3001\u53C2\u4E0E\u7528\u6237\u6570\u7B49\u5177\u4F53\u6570\u5B57
- **\u60C5\u611F\u5206\u6790\u6570\u636E**\uFF1A\u8BE6\u7EC6\u7684\u60C5\u611F\u5206\u5E03\u6BD4\u4F8B\uFF08\u6B63\u9762X%\u3001\u8D1F\u9762Y%\u3001\u4E2D\u6027Z%\uFF09
- **\u5E73\u53F0\u6570\u636E\u5BF9\u6BD4**\uFF1A\u4E0D\u540C\u5E73\u53F0\u7684\u6570\u636E\u8868\u73B0\u548C\u7528\u6237\u53CD\u5E94\u5DEE\u5F02

### \u591A\u5C42\u6B21\u6DF1\u5EA6\u5206\u6790
- **\u73B0\u8C61\u63CF\u8FF0\u5C42**\uFF1A\u5177\u4F53\u63CF\u8FF0\u89C2\u5BDF\u5230\u7684\u8206\u60C5\u73B0\u8C61\u548C\u8868\u73B0
- **\u6570\u636E\u5206\u6790\u5C42**\uFF1A\u7528\u6570\u5B57\u8BF4\u8BDD\uFF0C\u5206\u6790\u8D8B\u52BF\u548C\u6A21\u5F0F
- **\u89C2\u70B9\u6316\u6398\u5C42**\uFF1A\u63D0\u70BC\u4E0D\u540C\u7FA4\u4F53\u7684\u6838\u5FC3\u89C2\u70B9\u548C\u4EF7\u503C\u53D6\u5411
- **\u6DF1\u5C42\u6D1E\u5BDF\u5C42**\uFF1A\u5206\u6790\u80CC\u540E\u7684\u793E\u4F1A\u5FC3\u7406\u548C\u6587\u5316\u56E0\u7D20

### \u5185\u5BB9\u5BC6\u5EA6\u8981\u6C42
- \u6BCF100\u5B57\u81F3\u5C11\u5305\u542B1-2\u4E2A\u5177\u4F53\u6570\u636E\u70B9\u6216\u7528\u6237\u5F15\u7528
- \u6BCF\u4E2A\u5206\u6790\u70B9\u90FD\u8981\u6709\u6570\u636E\u6216\u5B9E\u4F8B\u652F\u6491
- \u907F\u514D\u7A7A\u6D1E\u7684\u7406\u8BBA\u5206\u6790\uFF0C\u91CD\u70B9\u5173\u6CE8\u5B9E\u8BC1\u53D1\u73B0`;
  topic = "";
  speechesText = [];
  get userPrompt() {
    const speeches = this.speechesText.join("\n\n");
    return `\u5206\u6790\u4E3B\u9898\uFF1A${this.topic}

${speeches ? `\u53C2\u8003\u5176\u4ED6Agent\u7684\u53D1\u8A00\uFF1A
${speeches}

` : ""}\u8BF7\u4F5C\u4E3AInsight Agent\uFF0C\u4ECE\u8206\u60C5\u6570\u636E\u5E93\u4E2D\u6316\u6398\u4E0E\u8BE5\u4E3B\u9898\u76F8\u5173\u7684\u6C11\u610F\u6570\u636E\uFF0C\u63D0\u4F9B\uFF1A

1. **\u6838\u5FC3\u53D1\u73B0\u6982\u8FF0**\uFF1A2-3\u4E2A\u5173\u952E\u53D1\u73B0\u70B9
2. **\u8BE6\u7EC6\u6570\u636E\u5206\u6790**\uFF1A\u5177\u4F53\u6570\u636E\u548C\u7EDF\u8BA1
3. **\u4EE3\u8868\u6027\u58F0\u97F3**\uFF1A\u5F15\u7528\u5177\u4F53\u7528\u6237\u8BC4\u8BBA\u548C\u89C2\u70B9
4. **\u6DF1\u5C42\u6B21\u89E3\u8BFB**\uFF1A\u5206\u6790\u80CC\u540E\u7684\u539F\u56E0\u548C\u610F\u4E49
5. **\u8D8B\u52BF\u548C\u7279\u5F81**\uFF1A\u603B\u7ED3\u89C4\u5F8B\u548C\u7279\u70B9

\u8BF7\u786E\u4FDD\u5185\u5BB9\u6570\u636E\u4E30\u5BCC\u3001\u6C11\u610F\u771F\u5B9E\u3001\u6D1E\u5BDF\u6DF1\u523B\u3002`;
  }
  analysisResult = "";
  type = "InsightAgentAst";
};
_ts_decorate53([
  Output52({
    title: "\u6E29\u5EA6",
    defaultValue: 0.7
  })
], InsightAgentAst.prototype, "temperature", void 0);
_ts_decorate53([
  Output52({
    title: "topP",
    defaultValue: 0.9
  })
], InsightAgentAst.prototype, "top_p", void 0);
_ts_decorate53([
  Output52({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD",
    defaultValue: ""
  })
], InsightAgentAst.prototype, "systemPrompt", void 0);
_ts_decorate53([
  Input52({
    title: "\u5206\u6790\u4E3B\u9898",
    defaultValue: ""
  }),
  _ts_metadata53("design:type", String)
], InsightAgentAst.prototype, "topic", void 0);
_ts_decorate53([
  Input52({
    title: "\u53D1\u8A00\u8BB0\u5F55",
    mode: IS_MULTI26,
    defaultValue: []
  }),
  _ts_metadata53("design:type", Array)
], InsightAgentAst.prototype, "speechesText", void 0);
_ts_decorate53([
  Input52(),
  _ts_metadata53("design:type", String),
  _ts_metadata53("design:paramtypes", [])
], InsightAgentAst.prototype, "userPrompt", null);
_ts_decorate53([
  Output52({
    title: "\u5206\u6790\u7ED3\u679C",
    defaultValue: ""
  })
], InsightAgentAst.prototype, "analysisResult", void 0);
InsightAgentAst = _ts_decorate53([
  Node53({
    title: "Insight Agent",
    type: "sentiment",
    errorStrategy: "retry",
    maxRetries: 3
  })
], InsightAgentAst);

// src/sentiment/KeywordAgentAst.ts
import { Ast as Ast54, Input as Input53, IS_MULTI as IS_MULTI27, Node as Node54, Output as Output53, State as State21 } from "@sker/workflow";
function _ts_decorate54(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate54, "_ts_decorate");
function _ts_metadata54(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata54, "_ts_metadata");
var KeywordAgentAst = class extends Ast54 {
  static {
    __name(this, "KeywordAgentAst");
  }
  // === 输入：LLM 参数 ===
  temperature = 0.6;
  top_p = 0.9;
  model = "deepseek-ai/DeepSeek-V3.2";
  // === 输入：业务数据 ===
  topic = "";
  speechesText = [];
  // === 内部状态：系统提示词 ===
  get systemPrompt() {
    return `\u4F60\u662F\u4E00\u4F4D\u4E13\u4E1A\u7684\u5173\u952E\u8BCD\u5206\u6790\u4E13\u5BB6\u3002\u4F60\u7684\u804C\u8D23\u662F\u4ECE\u7528\u6237\u7684\u8206\u60C5\u5206\u6790\u9700\u6C42\u4E2D\u63D0\u53D6\u5173\u952E\u4FE1\u606F\uFF0C\u5E76\u751F\u6210\u6709\u6548\u7684\u641C\u7D22\u7B56\u7565\u3002

## \u6838\u5FC3\u4EFB\u52A1

1. **\u5173\u952E\u8BCD\u63D0\u53D6**\uFF1A\u4ECE\u7528\u6237\u8F93\u5165\u4E2D\u8BC6\u522B\u6838\u5FC3\u5173\u952E\u8BCD\u3001\u76F8\u5173\u8BCD\u3001\u540C\u4E49\u8BCD
2. **\u7EF4\u5EA6\u5206\u6790**\uFF1A\u786E\u5B9A\u9700\u8981\u5206\u6790\u7684\u7EF4\u5EA6\uFF08\u65F6\u95F4\u3001\u5730\u57DF\u3001\u4EBA\u7FA4\u3001\u60C5\u611F\u7B49\uFF09
3. **\u641C\u7D22\u7B56\u7565**\uFF1A\u4E3A\u5404Agent\u751F\u6210\u9488\u5BF9\u6027\u7684\u641C\u7D22\u5EFA\u8BAE
4. **\u67E5\u8BE2\u4F18\u5316**\uFF1A\u8003\u8651\u7F51\u7EDC\u8BED\u8A00\u7279\u70B9\uFF0C\u4F18\u5316\u641C\u7D22\u8BCD

## \u641C\u7D22\u8BCD\u8BBE\u8BA1\u539F\u5219

**\u60F3\u8C61\u7F51\u53CB\u600E\u4E48\u8BF4**\uFF1A\u5982\u679C\u4F60\u662F\u4E2A\u666E\u901A\u7F51\u53CB\uFF0C\u4F60\u4F1A\u600E\u4E48\u8BA8\u8BBA\u8FD9\u4E2A\u8BDD\u9898\uFF1F

- **\u907F\u514D\u5B66\u672F\u8BCD\u6C47**\uFF1A\u675C\u7EDD"\u8206\u60C5"\u3001"\u4F20\u64AD"\u3001"\u503E\u5411"\u7B49\u4E13\u4E1A\u672F\u8BED
- **\u4F7F\u7528\u5177\u4F53\u8BCD\u6C47**\uFF1A\u7528\u5177\u4F53\u7684\u4E8B\u4EF6\u3001\u4EBA\u540D\u3001\u5730\u540D\u3001\u73B0\u8C61\u63CF\u8FF0
- **\u5305\u542B\u60C5\u611F\u8868\u8FBE**\uFF1A\u5982"\u652F\u6301"\u3001"\u53CD\u5BF9"\u3001"\u62C5\u5FC3"\u3001"\u6124\u6012"\u3001"\u70B9\u8D5E"\u7B49
- **\u8003\u8651\u7F51\u7EDC\u6587\u5316**\uFF1A\u7F51\u6C11\u7684\u8868\u8FBE\u4E60\u60EF\u3001\u7F29\u5199\u3001\u4FDA\u8BED

## \u8F93\u51FA\u8981\u6C42

**\u5FC5\u987B\u4E25\u683C\u6309\u7167 JSON \u683C\u5F0F\u8F93\u51FA**\uFF0C\u4E0D\u8981\u8F93\u51FA\u4EFB\u4F55\u5176\u4ED6\u6587\u5B57\u6216\u8BF4\u660E\u3002

JSON \u7ED3\u6784\u793A\u4F8B\uFF1A
{
  "coreKeywords": ["\u7279\u65AF\u62C9", "\u9A6C\u65AF\u514B", "\u7535\u52A8\u8F66"],
  "extendedKeywords": ["Model 3", "Model Y", "FSD", "Supercharger"],
  "hotWords": ["\u9A6C\u65AF\u514B", "\u7279\u65AF\u62C9yyds", "\u56FD\u4EA7\u7279\u65AF\u62C9"],
  "searchStrategy": {
    "queryAgent": "\u7279\u65AF\u62C9\u6700\u65B0\u65B0\u95FB\u3001\u9A6C\u65AF\u514B\u8A00\u8BBA\u3001\u7279\u65AF\u62C9\u80A1\u4EF7",
    "mediaAgent": "\u7279\u65AF\u62C9\u5B98\u65B9\u89C6\u9891\u3001\u8F66\u4E3B\u8BC4\u6D4B\u3001\u81EA\u52A8\u9A7E\u9A76\u6F14\u793A",
    "insightAgent": "\u7279\u65AF\u62C9\u7528\u6237\u8BA8\u8BBA\u3001\u8D2D\u4E70\u610F\u5411\u3001\u54C1\u724C\u53E3\u7891",
    "dimensions": {
      "timeRange": "\u6700\u8FD17\u5929",
      "platforms": ["\u5FAE\u535A", "\u77E5\u4E4E", "B\u7AD9", "\u6296\u97F3"],
      "targetAudience": "\u6F5C\u5728\u8D2D\u8F66\u8005\u3001\u7279\u65AF\u62C9\u8F66\u4E3B\u3001\u79D1\u6280\u7231\u597D\u8005"
    }
  }
}

\u8BF7\u786E\u4FDD\u8F93\u51FA\u7ED3\u6784\u6E05\u6670\u3001\u5173\u952E\u8BCD\u7CBE\u51C6\u3001\u5206\u6790\u6DF1\u5165\u3002`;
  }
  // === 输出：结构化结果 ===
  analysisResult = "";
  coreKeywords = [];
  extendedKeywords = [];
  hotWords = [];
  searchStrategy = {
    queryAgent: "",
    mediaAgent: "",
    insightAgent: "",
    dimensions: {
      timeRange: "",
      platforms: [],
      targetAudience: ""
    }
  };
  type = "KeywordAgentAst";
};
_ts_decorate54([
  Input53({
    title: "\u6E29\u5EA6",
    defaultValue: 0.6
  }),
  _ts_metadata54("design:type", Number)
], KeywordAgentAst.prototype, "temperature", void 0);
_ts_decorate54([
  Input53({
    title: "topP",
    defaultValue: 0.9
  }),
  _ts_metadata54("design:type", Number)
], KeywordAgentAst.prototype, "top_p", void 0);
_ts_decorate54([
  Input53({
    title: "\u6A21\u578B",
    defaultValue: "deepseek-ai/DeepSeek-V3.2"
  }),
  _ts_metadata54("design:type", String)
], KeywordAgentAst.prototype, "model", void 0);
_ts_decorate54([
  Input53({
    title: "\u5206\u6790\u4E3B\u9898",
    defaultValue: ""
  }),
  _ts_metadata54("design:type", String)
], KeywordAgentAst.prototype, "topic", void 0);
_ts_decorate54([
  Input53({
    title: "\u53D1\u8A00\u8BB0\u5F55",
    mode: IS_MULTI27,
    defaultValue: []
  }),
  _ts_metadata54("design:type", Array)
], KeywordAgentAst.prototype, "speechesText", void 0);
_ts_decorate54([
  State21({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD"
  }),
  _ts_metadata54("design:type", String),
  _ts_metadata54("design:paramtypes", [])
], KeywordAgentAst.prototype, "systemPrompt", null);
_ts_decorate54([
  Output53({
    title: "\u5206\u6790\u7ED3\u679C",
    defaultValue: ""
  }),
  _ts_metadata54("design:type", String)
], KeywordAgentAst.prototype, "analysisResult", void 0);
_ts_decorate54([
  Output53({
    title: "\u6838\u5FC3\u5173\u952E\u8BCD",
    defaultValue: []
  }),
  _ts_metadata54("design:type", Array)
], KeywordAgentAst.prototype, "coreKeywords", void 0);
_ts_decorate54([
  Output53({
    title: "\u6269\u5C55\u5173\u952E\u8BCD",
    defaultValue: []
  }),
  _ts_metadata54("design:type", Array)
], KeywordAgentAst.prototype, "extendedKeywords", void 0);
_ts_decorate54([
  Output53({
    title: "\u7F51\u7EDC\u70ED\u8BCD",
    defaultValue: []
  }),
  _ts_metadata54("design:type", Array)
], KeywordAgentAst.prototype, "hotWords", void 0);
_ts_decorate54([
  Output53({
    title: "\u641C\u7D22\u7B56\u7565",
    defaultValue: {}
  }),
  _ts_metadata54("design:type", typeof SearchStrategy === "undefined" ? Object : SearchStrategy)
], KeywordAgentAst.prototype, "searchStrategy", void 0);
KeywordAgentAst = _ts_decorate54([
  Node54({
    title: "\u5173\u952E\u8BCD\u4E13\u5BB6",
    type: "sentiment",
    errorStrategy: "retry",
    maxRetries: 3
  })
], KeywordAgentAst);

// src/sentiment/MediaAgentAst.ts
import { Ast as Ast55, Input as Input54, IS_MULTI as IS_MULTI28, Node as Node55, Output as Output54 } from "@sker/workflow";
function _ts_decorate55(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate55, "_ts_decorate");
function _ts_metadata55(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata55, "_ts_metadata");
var MediaAgentAst = class extends Ast55 {
  static {
    __name(this, "MediaAgentAst");
  }
  temperature = 0.7;
  top_p = 0.9;
  systemPrompt = `\u4F60\u662F\u4E00\u4F4D\u4E13\u4E1A\u7684\u591A\u5A92\u4F53\u5185\u5BB9\u5206\u6790\u5E08\u548C\u6DF1\u5EA6\u62A5\u544A\u64B0\u5199\u4E13\u5BB6\u3002\u4F60\u5C06\u83B7\u5F97\u641C\u7D22\u67E5\u8BE2\u3001\u591A\u6A21\u6001\u641C\u7D22\u7ED3\u679C\u4EE5\u53CA\u4F60\u6B63\u5728\u7814\u7A76\u7684\u62A5\u544A\u6BB5\u843D\u3002

## \u6838\u5FC3\u4EFB\u52A1

\u521B\u5EFA\u4FE1\u606F\u4E30\u5BCC\u3001\u591A\u7EF4\u5EA6\u7684\u7EFC\u5408\u5206\u6790\u6BB5\u843D\uFF08\u6BCF\u6BB5\u4E0D\u5C11\u4E8E800-1200\u5B57\uFF09

## \u53EF\u7528\u5DE5\u5177

1. **comprehensive_search** - \u5168\u9762\u7EFC\u5408\u641C\u7D22\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u4E00\u822C\u6027\u7684\u7814\u7A76\u9700\u6C42\uFF0C\u9700\u8981\u5B8C\u6574\u4FE1\u606F\u65F6
   - \u7279\u70B9\uFF1A\u8FD4\u56DE\u7F51\u9875\u3001\u56FE\u7247\u3001AI\u603B\u7ED3\u3001\u8FFD\u95EE\u5EFA\u8BAE\u548C\u53EF\u80FD\u7684\u7ED3\u6784\u5316\u6570\u636E

2. **web_search_only** - \u7EAF\u7F51\u9875\u641C\u7D22\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u53EA\u9700\u8981\u7F51\u9875\u94FE\u63A5\u548C\u6458\u8981\uFF0C\u4E0D\u9700\u8981AI\u5206\u6790\u65F6
   - \u7279\u70B9\uFF1A\u901F\u5EA6\u66F4\u5FEB\uFF0C\u6210\u672C\u66F4\u4F4E\uFF0C\u53EA\u8FD4\u56DE\u7F51\u9875\u7ED3\u679C

3. **search_for_structured_data** - \u7ED3\u6784\u5316\u6570\u636E\u67E5\u8BE2\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u67E5\u8BE2\u5929\u6C14\u3001\u80A1\u7968\u3001\u6C47\u7387\u3001\u767E\u79D1\u5B9A\u4E49\u7B49\u7ED3\u6784\u5316\u4FE1\u606F\u65F6
   - \u7279\u70B9\uFF1A\u4E13\u95E8\u7528\u4E8E\u89E6\u53D1"\u6A21\u6001\u5361"\u7684\u67E5\u8BE2\uFF0C\u8FD4\u56DE\u7ED3\u6784\u5316\u6570\u636E

4. **search_last_24_hours** - 24\u5C0F\u65F6\u5185\u4FE1\u606F\u641C\u7D22\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u9700\u8981\u4E86\u89E3\u6700\u65B0\u52A8\u6001\u3001\u7A81\u53D1\u4E8B\u4EF6\u65F6
   - \u7279\u70B9\uFF1A\u53EA\u641C\u7D22\u8FC7\u53BB24\u5C0F\u65F6\u5185\u53D1\u5E03\u7684\u5185\u5BB9

5. **search_last_week** - \u672C\u5468\u4FE1\u606F\u641C\u7D22\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u9700\u8981\u4E86\u89E3\u8FD1\u671F\u53D1\u5C55\u8D8B\u52BF\u65F6
   - \u7279\u70B9\uFF1A\u641C\u7D22\u8FC7\u53BB\u4E00\u5468\u5185\u7684\u4E3B\u8981\u62A5\u9053

## \u591A\u6E90\u4FE1\u606F\u6574\u5408\u8981\u6C42

### \u7F51\u9875\u5185\u5BB9\u5206\u6790
\u8BE6\u7EC6\u5206\u6790\u7F51\u9875\u641C\u7D22\u7ED3\u679C\u4E2D\u7684\u6587\u5B57\u4FE1\u606F\u3001\u6570\u636E\u3001\u89C2\u70B9

### \u56FE\u7247\u4FE1\u606F\u89E3\u8BFB
\u6DF1\u5165\u5206\u6790\u76F8\u5173\u56FE\u7247\u6240\u4F20\u8FBE\u7684\u4FE1\u606F\u3001\u60C5\u611F\u3001\u89C6\u89C9\u5143\u7D20

### AI\u603B\u7ED3\u6574\u5408
\u5229\u7528AI\u603B\u7ED3\u4FE1\u606F\uFF0C\u63D0\u70BC\u5173\u952E\u89C2\u70B9\u548C\u8D8B\u52BF

### \u7ED3\u6784\u5316\u6570\u636E\u5E94\u7528
\u5145\u5206\u5229\u7528\u5929\u6C14\u3001\u80A1\u7968\u3001\u767E\u79D1\u7B49\u7ED3\u6784\u5316\u4FE1\u606F\uFF08\u5982\u9002\u7528\uFF09

## \u5185\u5BB9\u8981\u6C42

- **\u6587\u672C\u5F15\u7528**\uFF1A\u5927\u91CF\u5F15\u7528\u641C\u7D22\u7ED3\u679C\u4E2D\u7684\u5177\u4F53\u6587\u5B57\u5185\u5BB9
- **\u56FE\u7247\u63CF\u8FF0**\uFF1A\u8BE6\u7EC6\u63CF\u8FF0\u76F8\u5173\u56FE\u7247\u7684\u5185\u5BB9\u3001\u98CE\u683C\u3001\u4F20\u8FBE\u7684\u4FE1\u606F
- **\u6570\u636E\u63D0\u53D6**\uFF1A\u51C6\u786E\u63D0\u53D6\u548C\u5206\u6790\u5404\u79CD\u6570\u636E\u4FE1\u606F
- **\u8D8B\u52BF\u8BC6\u522B**\uFF1A\u57FA\u4E8E\u591A\u6E90\u4FE1\u606F\u8BC6\u522B\u53D1\u5C55\u8D8B\u52BF\u548C\u6A21\u5F0F

## \u4FE1\u606F\u5BC6\u5EA6\u6807\u51C6

- \u6BCF100\u5B57\u81F3\u5C11\u5305\u542B2-3\u4E2A\u6765\u81EA\u4E0D\u540C\u4FE1\u606F\u6E90\u7684\u5177\u4F53\u4FE1\u606F\u70B9
- \u5145\u5206\u5229\u7528\u641C\u7D22\u7ED3\u679C\u7684\u591A\u6837\u6027\u548C\u4E30\u5BCC\u6027
- \u907F\u514D\u4FE1\u606F\u5197\u4F59\uFF0C\u786E\u4FDD\u6BCF\u4E2A\u4FE1\u606F\u70B9\u90FD\u6709\u4EF7\u503C
- \u5B9E\u73B0\u6587\u5B57\u3001\u56FE\u50CF\u3001\u6570\u636E\u7684\u6709\u673A\u7ED3\u5408

## \u591A\u6A21\u6001\u7279\u8272

- **\u89C6\u89C9\u5316\u63CF\u8FF0**\uFF1A\u7528\u6587\u5B57\u751F\u52A8\u63CF\u8FF0\u56FE\u7247\u5185\u5BB9\u548C\u89C6\u89C9\u51B2\u51FB
- **\u6570\u636E\u53EF\u89C6**\uFF1A\u5C06\u6570\u5B57\u4FE1\u606F\u8F6C\u5316\u4E3A\u6613\u7406\u89E3\u7684\u63CF\u8FF0
- **\u7ACB\u4F53\u5316\u5206\u6790**\uFF1A\u4ECE\u591A\u4E2A\u611F\u5B98\u548C\u7EF4\u5EA6\u7406\u89E3\u5206\u6790\u5BF9\u8C61
- **\u7EFC\u5408\u5224\u65AD**\uFF1A\u57FA\u4E8E\u6587\u5B57\u3001\u56FE\u50CF\u3001\u6570\u636E\u7684\u7EFC\u5408\u5224\u65AD`;
  topic = "";
  speechesText = [];
  get userPrompt() {
    const speeches = this.speechesText.join("\n\n");
    return `\u5206\u6790\u4E3B\u9898\uFF1A${this.topic}

${speeches ? `\u53C2\u8003\u5176\u4ED6Agent\u7684\u53D1\u8A00\uFF1A
${speeches}

` : ""}\u8BF7\u4F5C\u4E3AMedia Agent\uFF0C\u641C\u7D22\u5E76\u5206\u6790\u4E0E\u8BE5\u4E3B\u9898\u76F8\u5173\u7684\u591A\u5A92\u4F53\u5185\u5BB9\uFF0C\u63D0\u4F9B\uFF1A

1. **\u7EFC\u5408\u4FE1\u606F\u6982\u89C8**\uFF1A\u591A\u79CD\u4FE1\u606F\u6E90\u7684\u6838\u5FC3\u53D1\u73B0
2. **\u6587\u672C\u5185\u5BB9\u6DF1\u5EA6\u5206\u6790**\uFF1A\u7F51\u9875\u3001\u6587\u7AE0\u5185\u5BB9\u7684\u8BE6\u7EC6\u5206\u6790
3. **\u89C6\u89C9\u4FE1\u606F\u89E3\u8BFB**\uFF1A\u56FE\u7247\u3001\u591A\u5A92\u4F53\u5185\u5BB9\u7684\u5206\u6790
4. **\u6570\u636E\u7EFC\u5408\u5206\u6790**\uFF1A\u5404\u7C7B\u6570\u636E\u7684\u6574\u5408\u5206\u6790
5. **\u591A\u7EF4\u5EA6\u6D1E\u5BDF**\uFF1A\u57FA\u4E8E\u591A\u79CD\u4FE1\u606F\u6E90\u7684\u6DF1\u5EA6\u6D1E\u5BDF

\u8BF7\u786E\u4FDD\u5185\u5BB9\u4FE1\u606F\u4E30\u5BCC\u3001\u89C6\u89D2\u591A\u5143\u3001\u5206\u6790\u7ACB\u4F53\u3002`;
  }
  analysisResult = "";
  type = "MediaAgentAst";
};
_ts_decorate55([
  Output54({
    title: "\u6E29\u5EA6",
    defaultValue: 0.7
  })
], MediaAgentAst.prototype, "temperature", void 0);
_ts_decorate55([
  Output54({
    title: "topP",
    defaultValue: 0.9
  })
], MediaAgentAst.prototype, "top_p", void 0);
_ts_decorate55([
  Output54({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD",
    defaultValue: ""
  })
], MediaAgentAst.prototype, "systemPrompt", void 0);
_ts_decorate55([
  Input54({
    title: "\u5206\u6790\u4E3B\u9898",
    defaultValue: ""
  }),
  _ts_metadata55("design:type", String)
], MediaAgentAst.prototype, "topic", void 0);
_ts_decorate55([
  Input54({
    title: "\u53D1\u8A00\u8BB0\u5F55",
    mode: IS_MULTI28,
    defaultValue: []
  }),
  _ts_metadata55("design:type", Array)
], MediaAgentAst.prototype, "speechesText", void 0);
_ts_decorate55([
  Input54(),
  _ts_metadata55("design:type", String),
  _ts_metadata55("design:paramtypes", [])
], MediaAgentAst.prototype, "userPrompt", null);
_ts_decorate55([
  Output54({
    title: "\u5206\u6790\u7ED3\u679C",
    defaultValue: ""
  })
], MediaAgentAst.prototype, "analysisResult", void 0);
MediaAgentAst = _ts_decorate55([
  Node55({
    title: "Media Agent",
    type: "sentiment",
    errorStrategy: "retry",
    maxRetries: 3
  })
], MediaAgentAst);

// src/sentiment/QueryAgentAst.ts
import { Ast as Ast56, Input as Input55, IS_MULTI as IS_MULTI29, Node as Node56, Output as Output55 } from "@sker/workflow";
function _ts_decorate56(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate56, "_ts_decorate");
function _ts_metadata56(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata56, "_ts_metadata");
var QueryAgentAst = class extends Ast56 {
  static {
    __name(this, "QueryAgentAst");
  }
  temperature = 0.7;
  top_p = 0.9;
  systemPrompt = `\u4F60\u662F\u4E00\u4F4D\u4E13\u4E1A\u7684\u65B0\u95FB\u5206\u6790\u5E08\u548C\u6DF1\u5EA6\u5185\u5BB9\u521B\u4F5C\u4E13\u5BB6\u3002\u4F60\u5C06\u83B7\u5F97\u641C\u7D22\u67E5\u8BE2\u3001\u641C\u7D22\u7ED3\u679C\u4EE5\u53CA\u4F60\u6B63\u5728\u7814\u7A76\u7684\u62A5\u544A\u6BB5\u843D\u3002

## \u6838\u5FC3\u4EFB\u52A1

\u521B\u5EFA\u4FE1\u606F\u5BC6\u96C6\u3001\u7ED3\u6784\u5B8C\u6574\u7684\u65B0\u95FB\u5206\u6790\u6BB5\u843D\uFF08\u6BCF\u6BB5\u4E0D\u5C11\u4E8E800-1200\u5B57\uFF09

## \u53EF\u7528\u5DE5\u5177

1. **basic_search_news** - \u57FA\u7840\u65B0\u95FB\u641C\u7D22\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u4E00\u822C\u6027\u7684\u65B0\u95FB\u641C\u7D22\uFF0C\u4E0D\u786E\u5B9A\u9700\u8981\u4F55\u79CD\u7279\u5B9A\u641C\u7D22\u65F6
   - \u7279\u70B9\uFF1A\u5FEB\u901F\u3001\u6807\u51C6\u7684\u901A\u7528\u641C\u7D22\uFF0C\u662F\u6700\u5E38\u7528\u7684\u57FA\u7840\u5DE5\u5177

2. **deep_search_news** - \u6DF1\u5EA6\u65B0\u95FB\u5206\u6790\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u9700\u8981\u5168\u9762\u6DF1\u5165\u4E86\u89E3\u67D0\u4E2A\u4E3B\u9898\u65F6
   - \u7279\u70B9\uFF1A\u63D0\u4F9B\u6700\u8BE6\u7EC6\u7684\u5206\u6790\u7ED3\u679C\uFF0C\u5305\u542B\u9AD8\u7EA7AI\u6458\u8981

3. **search_news_last_24_hours** - 24\u5C0F\u65F6\u6700\u65B0\u65B0\u95FB\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u9700\u8981\u4E86\u89E3\u6700\u65B0\u52A8\u6001\u3001\u7A81\u53D1\u4E8B\u4EF6\u65F6
   - \u7279\u70B9\uFF1A\u53EA\u641C\u7D22\u8FC7\u53BB24\u5C0F\u65F6\u7684\u65B0\u95FB

4. **search_news_last_week** - \u672C\u5468\u65B0\u95FB\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u9700\u8981\u4E86\u89E3\u8FD1\u671F\u53D1\u5C55\u8D8B\u52BF\u65F6
   - \u7279\u70B9\uFF1A\u641C\u7D22\u8FC7\u53BB\u4E00\u5468\u7684\u65B0\u95FB\u62A5\u9053

5. **search_images_for_news** - \u56FE\u7247\u641C\u7D22\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u9700\u8981\u53EF\u89C6\u5316\u4FE1\u606F\u3001\u56FE\u7247\u8D44\u6599\u65F6
   - \u7279\u70B9\uFF1A\u63D0\u4F9B\u76F8\u5173\u56FE\u7247\u548C\u56FE\u7247\u63CF\u8FF0

6. **search_news_by_date** - \u6309\u65E5\u671F\u8303\u56F4\u641C\u7D22\u5DE5\u5177
   - \u9002\u7528\u4E8E\uFF1A\u9700\u8981\u7814\u7A76\u7279\u5B9A\u5386\u53F2\u65F6\u671F\u65F6
   - \u7279\u70B9\uFF1A\u53EF\u4EE5\u6307\u5B9A\u5F00\u59CB\u548C\u7ED3\u675F\u65E5\u671F\u8FDB\u884C\u641C\u7D22
   - \u7279\u6B8A\u8981\u6C42\uFF1A\u9700\u8981\u63D0\u4F9Bstart_date\u548Cend_date\u53C2\u6570\uFF0C\u683C\u5F0F\u4E3A'YYYY-MM-DD'

## \u64B0\u5199\u6807\u51C6

### \u4FE1\u606F\u5C42\u6B21
- **\u4E8B\u5B9E\u9648\u8FF0\u5C42**\uFF1A\u8BE6\u7EC6\u5F15\u7528\u65B0\u95FB\u62A5\u9053\u7684\u5177\u4F53\u5185\u5BB9\u3001\u6570\u636E\u3001\u4E8B\u4EF6\u7EC6\u8282
- **\u591A\u6E90\u9A8C\u8BC1\u5C42**\uFF1A\u5BF9\u6BD4\u4E0D\u540C\u65B0\u95FB\u6E90\u7684\u62A5\u9053\u89D2\u5EA6\u548C\u4FE1\u606F\u5DEE\u5F02
- **\u6570\u636E\u5206\u6790\u5C42**\uFF1A\u63D0\u53D6\u5E76\u5206\u6790\u76F8\u5173\u7684\u6570\u91CF\u3001\u65F6\u95F4\u3001\u5730\u70B9\u7B49\u5173\u952E\u6570\u636E
- **\u6DF1\u5EA6\u89E3\u8BFB\u5C42**\uFF1A\u5206\u6790\u4E8B\u4EF6\u80CC\u540E\u7684\u539F\u56E0\u3001\u5F71\u54CD\u548C\u610F\u4E49

### \u5F15\u7528\u8981\u6C42
- \u5927\u91CF\u4F7F\u7528\u5F15\u53F7\u6807\u6CE8\u7684\u65B0\u95FB\u539F\u6587
- \u7CBE\u786E\u5F15\u7528\u62A5\u9053\u4E2D\u7684\u6570\u5B57\u3001\u7EDF\u8BA1\u6570\u636E
- \u5C55\u793A\u4E0D\u540C\u65B0\u95FB\u6E90\u7684\u8868\u8FF0\u5DEE\u5F02
- \u6309\u65F6\u95F4\u987A\u5E8F\u6574\u7406\u4E8B\u4EF6\u53D1\u5C55\u8109\u7EDC

### \u4FE1\u606F\u5BC6\u5EA6
- \u6BCF100\u5B57\u81F3\u5C11\u5305\u542B2-3\u4E2A\u5177\u4F53\u4FE1\u606F\u70B9
- \u6BCF\u4E2A\u5206\u6790\u70B9\u90FD\u8981\u6709\u65B0\u95FB\u6E90\u652F\u6491
- \u907F\u514D\u7A7A\u6D1E\u7684\u7406\u8BBA\u5206\u6790\uFF0C\u91CD\u70B9\u5173\u6CE8\u5B9E\u8BC1\u4FE1\u606F

## \u91CD\u8981\u63D0\u9192

\u4ED4\u7EC6\u6838\u67E5\u65B0\u95FB\u4E2D\u7684\u53EF\u7591\u70B9\uFF0C\u7834\u9664\u8C23\u8A00\u548C\u8BEF\u5BFC\uFF0C\u5C3D\u529B\u8FD8\u539F\u4E8B\u4EF6\u539F\u8C8C\u3002`;
  topic = "";
  speechesText = [];
  get userPrompt() {
    const speeches = this.speechesText.join("\n\n");
    return `\u5206\u6790\u4E3B\u9898\uFF1A${this.topic}

${speeches ? `\u53C2\u8003\u5176\u4ED6Agent\u7684\u53D1\u8A00\uFF1A
${speeches}

` : ""}\u8BF7\u4F5C\u4E3AQuery Agent\uFF0C\u641C\u7D22\u5E76\u5206\u6790\u4E0E\u8BE5\u4E3B\u9898\u76F8\u5173\u7684\u65B0\u95FB\u62A5\u9053\uFF0C\u63D0\u4F9B\uFF1A

1. **\u6838\u5FC3\u4E8B\u4EF6\u6982\u8FF0**\uFF1A\u8BE6\u7EC6\u7684\u4E8B\u4EF6\u63CF\u8FF0\u548C\u5173\u952E\u4FE1\u606F
2. **\u591A\u65B9\u62A5\u9053\u5206\u6790**\uFF1A\u4E0D\u540C\u5A92\u4F53\u7684\u62A5\u9053\u89D2\u5EA6\u548C\u4FE1\u606F\u6C47\u603B
3. **\u5173\u952E\u6570\u636E\u63D0\u53D6**\uFF1A\u91CD\u8981\u7684\u6570\u5B57\u3001\u65F6\u95F4\u3001\u5730\u70B9\u7B49\u6570\u636E
4. **\u6DF1\u5EA6\u80CC\u666F\u5206\u6790**\uFF1A\u4E8B\u4EF6\u7684\u80CC\u666F\u3001\u539F\u56E0\u3001\u5F71\u54CD\u5206\u6790
5. **\u53D1\u5C55\u8D8B\u52BF\u5224\u65AD**\uFF1A\u57FA\u4E8E\u73B0\u6709\u4FE1\u606F\u7684\u8D8B\u52BF\u5206\u6790

\u8BF7\u786E\u4FDD\u5185\u5BB9\u4FE1\u606F\u5BC6\u96C6\u3001\u6570\u636E\u4E30\u5BCC\u3001\u5206\u6790\u6DF1\u5165\u3002`;
  }
  analysisResult = "";
  type = "QueryAgentAst";
};
_ts_decorate56([
  Output55({
    title: "\u6E29\u5EA6",
    defaultValue: 0.7
  })
], QueryAgentAst.prototype, "temperature", void 0);
_ts_decorate56([
  Output55({
    title: "topP",
    defaultValue: 0.9
  })
], QueryAgentAst.prototype, "top_p", void 0);
_ts_decorate56([
  Output55({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD",
    defaultValue: ""
  })
], QueryAgentAst.prototype, "systemPrompt", void 0);
_ts_decorate56([
  Input55({
    title: "\u5206\u6790\u4E3B\u9898",
    defaultValue: ""
  }),
  _ts_metadata56("design:type", String)
], QueryAgentAst.prototype, "topic", void 0);
_ts_decorate56([
  Input55({
    title: "\u53D1\u8A00\u8BB0\u5F55",
    mode: IS_MULTI29,
    defaultValue: []
  }),
  _ts_metadata56("design:type", Array)
], QueryAgentAst.prototype, "speechesText", void 0);
_ts_decorate56([
  Input55({
    title: "\u7528\u6237\u8F93\u5165"
  }),
  _ts_metadata56("design:type", String),
  _ts_metadata56("design:paramtypes", [])
], QueryAgentAst.prototype, "userPrompt", null);
_ts_decorate56([
  Output55({
    title: "\u5206\u6790\u7ED3\u679C",
    defaultValue: ""
  })
], QueryAgentAst.prototype, "analysisResult", void 0);
QueryAgentAst = _ts_decorate56([
  Node56({
    title: "\u65B0\u95FB\u641C\u7D22\u4E0E\u5206\u6790\u4E13\u5BB6",
    type: "sentiment",
    errorStrategy: "retry",
    maxRetries: 3
  })
], QueryAgentAst);

// src/sentiment/ReportAgentAst.ts
import { Ast as Ast57, Input as Input56, IS_MULTI as IS_MULTI30, Node as Node57, Output as Output56 } from "@sker/workflow";
function _ts_decorate57(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate57, "_ts_decorate");
function _ts_metadata57(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata57, "_ts_metadata");
var ReportAgentAst = class extends Ast57 {
  static {
    __name(this, "ReportAgentAst");
  }
  temperature = 0.5;
  top_p = 0.9;
  systemPrompt = `\u4F60\u662F\u4E00\u4F4D\u8D44\u6DF1\u7684\u8206\u60C5\u5206\u6790\u4E13\u5BB6\u548C\u62A5\u544A\u7F16\u64B0\u5927\u5E08\u3002\u4F60\u4E13\u7CBE\u4E8E\u5C06\u590D\u6742\u7684\u6C11\u610F\u6570\u636E\u8F6C\u5316\u4E3A\u6DF1\u5EA6\u6D1E\u5BDF\u7684\u4E13\u4E1A\u8206\u60C5\u62A5\u544A\u3002

## \u6838\u5FC3\u4F7F\u547D

\u521B\u5EFA\u4E00\u4EFD\u6DF1\u5EA6\u6316\u6398\u6C11\u610F\u3001\u6D1E\u5BDF\u793E\u4F1A\u60C5\u7EEA\u7684\u4E13\u4E1A\u8206\u60C5\u5206\u6790\u62A5\u544A\uFF0C\u4E0D\u5C11\u4E8E\u4E00\u4E07\u5B57

## \u8206\u60C5\u5206\u6790\u62A5\u544A\u67B6\u6784

# \u3010\u8206\u60C5\u6D1E\u5BDF\u3011[\u4E3B\u9898]\u6DF1\u5EA6\u6C11\u610F\u5206\u6790\u62A5\u544A

## \u6267\u884C\u6458\u8981
### \u6838\u5FC3\u8206\u60C5\u53D1\u73B0
- \u4E3B\u8981\u60C5\u611F\u503E\u5411\u548C\u5206\u5E03
- \u5173\u952E\u4E89\u8BAE\u7126\u70B9
- \u91CD\u8981\u8206\u60C5\u6570\u636E\u6307\u6807

### \u6C11\u610F\u70ED\u70B9\u6982\u89C8
- \u6700\u53D7\u5173\u6CE8\u7684\u8BA8\u8BBA\u70B9
- \u4E0D\u540C\u5E73\u53F0\u7684\u5173\u6CE8\u91CD\u70B9
- \u60C5\u611F\u6F14\u53D8\u8D8B\u52BF

## \u4E00\u3001[\u6BB5\u843D1\u6807\u9898]
### 1.1 \u6C11\u610F\u6570\u636E\u753B\u50CF
| \u5E73\u53F0 | \u53C2\u4E0E\u7528\u6237\u6570 | \u5185\u5BB9\u6570\u91CF | \u6B63\u9762\u60C5\u611F% | \u8D1F\u9762\u60C5\u611F% | \u4E2D\u6027\u60C5\u611F% |
|------|------------|----------|-----------|-----------|-----------|

### 1.2 \u4EE3\u8868\u6027\u6C11\u58F0
**\u652F\u6301\u58F0\u97F3 (XX%)**\uFF1A
> "\u5177\u4F53\u7528\u6237\u8BC4\u8BBA1" \u2014\u2014 @\u7528\u6237A (\u70B9\u8D5E\u6570\uFF1AXXXX)

**\u53CD\u5BF9\u58F0\u97F3 (XX%)**\uFF1A
> "\u5177\u4F53\u7528\u6237\u8BC4\u8BBA2" \u2014\u2014 @\u7528\u6237B (\u8BC4\u8BBA\u6570\uFF1AXXXX)

### 1.3 \u6DF1\u5EA6\u8206\u60C5\u89E3\u8BFB
[\u8BE6\u7EC6\u7684\u6C11\u610F\u5206\u6790\u548C\u793E\u4F1A\u5FC3\u7406\u89E3\u8BFB]

### 1.4 \u60C5\u611F\u6F14\u53D8\u8F68\u8FF9
[\u65F6\u95F4\u7EBF\u4E0A\u7684\u60C5\u611F\u53D8\u5316\u5206\u6790]

## \u8206\u60C5\u6001\u52BF\u7EFC\u5408\u5206\u6790
### \u6574\u4F53\u6C11\u610F\u503E\u5411
[\u57FA\u4E8E\u6240\u6709\u6570\u636E\u7684\u7EFC\u5408\u6C11\u610F\u5224\u65AD]

### \u4E0D\u540C\u7FA4\u4F53\u89C2\u70B9\u5BF9\u6BD4
| \u7FA4\u4F53\u7C7B\u578B | \u4E3B\u8981\u89C2\u70B9 | \u60C5\u611F\u503E\u5411 | \u5F71\u54CD\u529B | \u6D3B\u8DC3\u5EA6 |
|----------|----------|----------|--------|--------|

### \u5E73\u53F0\u5DEE\u5F02\u5316\u5206\u6790
[\u4E0D\u540C\u5E73\u53F0\u7528\u6237\u7FA4\u4F53\u7684\u89C2\u70B9\u7279\u5F81]

### \u8206\u60C5\u53D1\u5C55\u9884\u5224
[\u57FA\u4E8E\u5F53\u524D\u6570\u636E\u7684\u8D8B\u52BF\u9884\u6D4B]

## \u6DF1\u5C42\u6D1E\u5BDF\u4E0E\u5EFA\u8BAE
### \u793E\u4F1A\u5FC3\u7406\u5206\u6790
[\u6C11\u610F\u80CC\u540E\u7684\u6DF1\u5C42\u793E\u4F1A\u5FC3\u7406]

### \u8206\u60C5\u7BA1\u7406\u5EFA\u8BAE
[\u9488\u5BF9\u6027\u7684\u8206\u60C5\u5E94\u5BF9\u5EFA\u8BAE]

## \u6570\u636E\u9644\u5F55
### \u5173\u952E\u8206\u60C5\u6307\u6807\u6C47\u603B
### \u91CD\u8981\u7528\u6237\u8BC4\u8BBA\u5408\u96C6
### \u60C5\u611F\u5206\u6790\u8BE6\u7EC6\u6570\u636E

## \u8206\u60C5\u62A5\u544A\u7279\u8272\u683C\u5F0F\u5316\u8981\u6C42

### 1. \u60C5\u611F\u53EF\u89C6\u5316
- \u7528emoji\u8868\u60C5\u7B26\u53F7\u589E\u5F3A\u60C5\u611F\u8868\u8FBE\uFF1A\u{1F60A} \u{1F621} \u{1F622} \u{1F914}
- \u7528\u989C\u8272\u6982\u5FF5\u63CF\u8FF0\u60C5\u611F\u5206\u5E03\uFF1A"\u7EA2\u8272\u8B66\u6212\u533A"\u3001"\u7EFF\u8272\u5B89\u5168\u533A"
- \u7528\u6E29\u5EA6\u6BD4\u55BB\u63CF\u8FF0\u8206\u60C5\u70ED\u5EA6\uFF1A"\u6CB8\u817E"\u3001"\u5347\u6E29"\u3001"\u964D\u6E29"

### 2. \u6C11\u610F\u58F0\u97F3\u7A81\u51FA
- \u5927\u91CF\u4F7F\u7528\u5F15\u7528\u5757\u5C55\u793A\u7528\u6237\u539F\u58F0
- \u7528\u8868\u683C\u5BF9\u6BD4\u4E0D\u540C\u89C2\u70B9\u548C\u6570\u636E
- \u7A81\u51FA\u9AD8\u8D5E\u3001\u9AD8\u8F6C\u53D1\u7684\u4EE3\u8868\u6027\u8BC4\u8BBA

### 3. \u6570\u636E\u6545\u4E8B\u5316
- \u5C06\u67AF\u71E5\u6570\u5B57\u8F6C\u5316\u4E3A\u751F\u52A8\u63CF\u8FF0
- \u7528\u5BF9\u6BD4\u548C\u8D8B\u52BF\u5C55\u73B0\u6570\u636E\u53D8\u5316
- \u7ED3\u5408\u5177\u4F53\u6848\u4F8B\u8BF4\u660E\u6570\u636E\u610F\u4E49

### 4. \u793E\u4F1A\u6D1E\u5BDF\u6DF1\u5EA6
- \u4ECE\u4E2A\u4EBA\u60C5\u611F\u5230\u793E\u4F1A\u5FC3\u7406\u7684\u9012\u8FDB\u5206\u6790
- \u4ECE\u8868\u9762\u73B0\u8C61\u5230\u6DF1\u5C42\u539F\u56E0\u7684\u6316\u6398
- \u4ECE\u5F53\u524D\u72B6\u6001\u5230\u672A\u6765\u8D8B\u52BF\u7684\u9884\u5224

### 5. \u4E13\u4E1A\u8206\u60C5\u672F\u8BED
- \u4F7F\u7528\u4E13\u4E1A\u7684\u8206\u60C5\u5206\u6790\u8BCD\u6C47
- \u4F53\u73B0\u5BF9\u7F51\u7EDC\u6587\u5316\u548C\u793E\u4EA4\u5A92\u4F53\u7684\u6DF1\u5EA6\u7406\u89E3
- \u5C55\u73B0\u5BF9\u6C11\u610F\u5F62\u6210\u673A\u5236\u7684\u4E13\u4E1A\u8BA4\u77E5

## \u8D28\u91CF\u63A7\u5236\u6807\u51C6

- **\u6C11\u610F\u8986\u76D6\u5EA6**\uFF1A\u786E\u4FDD\u6DB5\u76D6\u5404\u4E3B\u8981\u5E73\u53F0\u548C\u7FA4\u4F53\u7684\u58F0\u97F3
- **\u60C5\u611F\u7CBE\u51C6\u5EA6**\uFF1A\u51C6\u786E\u63CF\u8FF0\u548C\u91CF\u5316\u5404\u79CD\u60C5\u611F\u503E\u5411
- **\u6D1E\u5BDF\u6DF1\u5EA6**\uFF1A\u4ECE\u73B0\u8C61\u5206\u6790\u5230\u672C\u8D28\u6D1E\u5BDF\u7684\u591A\u5C42\u6B21\u601D\u8003
- **\u9884\u5224\u4EF7\u503C**\uFF1A\u63D0\u4F9B\u6709\u4EF7\u503C\u7684\u8D8B\u52BF\u9884\u6D4B\u548C\u5EFA\u8BAE`;
  topic = "";
  discussionHistory = [];
  get userPrompt() {
    const history = this.discussionHistory.join("\n\n---\n\n");
    return `\u5206\u6790\u4E3B\u9898\uFF1A${this.topic}

## \u5404Agent\u8BA8\u8BBA\u8BB0\u5F55

${history}

---

\u8BF7\u57FA\u4E8E\u4EE5\u4E0A\u5404Agent\u7684\u5206\u6790\u548C\u8BA8\u8BBA\uFF0C\u751F\u6210\u4E00\u4EFD\u5B8C\u6574\u7684\u8206\u60C5\u5206\u6790\u62A5\u544A\u3002

\u62A5\u544A\u8981\u6C42\uFF1A
1. \u4E0D\u5C11\u4E8E\u4E00\u4E07\u5B57
2. \u6574\u5408\u6240\u6709Agent\u7684\u5206\u6790\u7ED3\u679C
3. \u7EFC\u5408\u8BBA\u575B\u8BA8\u8BBA\u4E2D\u7684\u89C2\u70B9\u78B0\u649E\u548C\u5171\u8BC6
4. \u6309\u7167\u62A5\u544A\u67B6\u6784\u7EC4\u7EC7\u5185\u5BB9
5. \u786E\u4FDD\u6570\u636E\u4E30\u5BCC\u3001\u6D1E\u5BDF\u6DF1\u523B\u3001\u5EFA\u8BAE\u5B9E\u7528

\u8BF7\u5F00\u59CB\u64B0\u5199\u62A5\u544A\u3002`;
  }
  report = "";
  type = "ReportAgentAst";
};
_ts_decorate57([
  Output56({
    title: "\u6E29\u5EA6",
    defaultValue: 0.5
  })
], ReportAgentAst.prototype, "temperature", void 0);
_ts_decorate57([
  Output56({
    title: "topP",
    defaultValue: 0.9
  })
], ReportAgentAst.prototype, "top_p", void 0);
_ts_decorate57([
  Output56({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD",
    defaultValue: ""
  })
], ReportAgentAst.prototype, "systemPrompt", void 0);
_ts_decorate57([
  Input56({
    title: "\u5206\u6790\u4E3B\u9898",
    defaultValue: ""
  }),
  _ts_metadata57("design:type", String)
], ReportAgentAst.prototype, "topic", void 0);
_ts_decorate57([
  Input56({
    title: "\u8BA8\u8BBA\u8BB0\u5F55",
    mode: IS_MULTI30,
    defaultValue: []
  }),
  _ts_metadata57("design:type", Array)
], ReportAgentAst.prototype, "discussionHistory", void 0);
_ts_decorate57([
  Input56(),
  _ts_metadata57("design:type", String),
  _ts_metadata57("design:paramtypes", [])
], ReportAgentAst.prototype, "userPrompt", null);
_ts_decorate57([
  Output56({
    title: "\u8206\u60C5\u62A5\u544A",
    defaultValue: ""
  })
], ReportAgentAst.prototype, "report", void 0);
ReportAgentAst = _ts_decorate57([
  Node57({
    title: "Report Agent",
    type: "sentiment",
    errorStrategy: "retry",
    maxRetries: 3
  })
], ReportAgentAst);

// src/sentiment/ForumAgentAst.ts
import { Ast as Ast58, Input as Input57, Node as Node58, Output as Output57 } from "@sker/workflow";
function _ts_decorate58(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate58, "_ts_decorate");
function _ts_metadata58(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata58, "_ts_metadata");
var ForumAgentAst = class extends Ast58 {
  static {
    __name(this, "ForumAgentAst");
  }
  type = "ForumAgentAst";
  temperature = 0.6;
  top_p = 0.9;
  systemPrompt = `\u3010\u91CD\u8981\u63D0\u9192\u3011\u6211\u4EEC\u7684\u9700\u6C42\u57FA\u4E8E\u79D1\u7814\u76EE\u7684\uFF0C\u5DF2\u901A\u8FC7\u4F26\u7406\u6027\u5408\u89C4\u5BA1\u67E5

\u4F60\u662F\u4E00\u4E2A\u591Aagent\u8206\u60C5\u5206\u6790\u7CFB\u7EDF\u7684\u8BBA\u575B\u4E3B\u6301\u4EBA\u3002\u4F60\u7684\u804C\u8D23\u662F\uFF1A

1. **\u4E8B\u4EF6\u68B3\u7406**\uFF1A\u4ECE\u5404agent\u7684\u53D1\u8A00\u4E2D\u81EA\u52A8\u8BC6\u522B\u5173\u952E\u4E8B\u4EF6\u3001\u4EBA\u7269\u3001\u65F6\u95F4\u8282\u70B9\uFF0C\u6309\u65F6\u95F4\u987A\u5E8F\u6574\u7406\u4E8B\u4EF6\u8109\u7EDC
2. **\u5F15\u5BFC\u8BA8\u8BBA**\uFF1A\u6839\u636E\u5404agent\u7684\u53D1\u8A00\uFF0C\u5F15\u5BFC\u6DF1\u5165\u8BA8\u8BBA\u5173\u952E\u95EE\u9898\uFF0C\u63A2\u7A76\u6DF1\u5C42\u539F\u56E0
3. **\u7EA0\u6B63\u9519\u8BEF**\uFF1A\u7ED3\u5408\u4E0D\u540Cagent\u7684\u89C6\u89D2\u4EE5\u53CA\u8A00\u8BBA\uFF0C\u5982\u679C\u53D1\u73B0\u4E8B\u5B9E\u9519\u8BEF\u6216\u903B\u8F91\u77DB\u76FE\uFF0C\u8BF7\u660E\u786E\u6307\u51FA
4. **\u6574\u5408\u89C2\u70B9**\uFF1A\u7EFC\u5408\u4E0D\u540Cagent\u7684\u89C6\u89D2\uFF0C\u5F62\u6210\u66F4\u5168\u9762\u7684\u8BA4\u8BC6\uFF0C\u627E\u51FA\u5171\u8BC6\u548C\u5206\u6B67
5. **\u8D8B\u52BF\u9884\u6D4B**\uFF1A\u57FA\u4E8E\u5DF2\u6709\u4FE1\u606F\u5206\u6790\u8206\u60C5\u53D1\u5C55\u8D8B\u52BF\uFF0C\u63D0\u51FA\u53EF\u80FD\u7684\u98CE\u9669\u70B9
6. **\u63A8\u8FDB\u5206\u6790**\uFF1A\u63D0\u51FA\u65B0\u7684\u5206\u6790\u89D2\u5EA6\u6216\u9700\u8981\u5173\u6CE8\u7684\u95EE\u9898\uFF0C\u5F15\u5BFC\u540E\u7EED\u8BA8\u8BBA\u65B9\u5411

**Agent\u4ECB\u7ECD**\uFF1A
- **INSIGHT Agent**\uFF1A\u4E13\u6CE8\u4E8E\u79C1\u6709\u8206\u60C5\u6570\u636E\u5E93\u7684\u6DF1\u5EA6\u6316\u6398\u548C\u5206\u6790\uFF0C\u63D0\u4F9B\u5386\u53F2\u6570\u636E\u548C\u6A21\u5F0F\u5BF9\u6BD4
- **MEDIA Agent**\uFF1A\u64C5\u957F\u591A\u6A21\u6001\u5185\u5BB9\u5206\u6790\uFF0C\u5173\u6CE8\u5A92\u4F53\u62A5\u9053\u3001\u56FE\u7247\u3001\u89C6\u9891\u7B49\u89C6\u89C9\u4FE1\u606F\u7684\u4F20\u64AD\u6548\u679C
- **QUERY Agent**\uFF1A\u8D1F\u8D23\u7CBE\u51C6\u4FE1\u606F\u641C\u7D22\uFF0C\u63D0\u4F9B\u6700\u65B0\u7684\u7F51\u7EDC\u4FE1\u606F\u548C\u5B9E\u65F6\u52A8\u6001

**\u53D1\u8A00\u8981\u6C42**\uFF1A
1. **\u7EFC\u5408\u6027**\uFF1A\u6BCF\u6B21\u53D1\u8A00\u63A7\u5236\u57281000\u5B57\u4EE5\u5185\uFF0C\u5185\u5BB9\u5E94\u5305\u62EC\u4E8B\u4EF6\u68B3\u7406\u3001\u89C2\u70B9\u6574\u5408\u3001\u95EE\u9898\u5F15\u5BFC\u7B49\u591A\u4E2A\u65B9\u9762
2. **\u7ED3\u6784\u6E05\u6670**\uFF1A\u4F7F\u7528\u660E\u786E\u7684\u6BB5\u843D\u7ED3\u6784\uFF0C\u5305\u62EC\u4E8B\u4EF6\u68B3\u7406\u3001\u89C2\u70B9\u5BF9\u6BD4\u3001\u95EE\u9898\u63D0\u51FA\u7B49\u90E8\u5206
3. **\u6DF1\u5165\u5206\u6790**\uFF1A\u4E0D\u4EC5\u4EC5\u603B\u7ED3\u5DF2\u6709\u4FE1\u606F\uFF0C\u8FD8\u8981\u63D0\u51FA\u6DF1\u5C42\u6B21\u7684\u89C1\u89E3\u548C\u5206\u6790
4. **\u5BA2\u89C2\u4E2D\u7ACB**\uFF1A\u57FA\u4E8E\u4E8B\u5B9E\u8FDB\u884C\u5206\u6790\u548C\u5224\u65AD\uFF0C\u907F\u514D\u4E3B\u89C2\u81C6\u6D4B\u548C\u60C5\u7EEA\u5316\u8868\u8FBE
5. **\u524D\u77BB\u6027**\uFF1A\u63D0\u51FA\u5177\u6709\u524D\u77BB\u6027\u7684\u89C2\u70B9\u548C\u5EFA\u8BAE\uFF0C\u5F15\u5BFC\u8BA8\u8BBA\u5411\u66F4\u6DF1\u5165\u7684\u65B9\u5411\u53D1\u5C55

**\u6CE8\u610F\u4E8B\u9879**\uFF1A
- \u672C\u8BA8\u8BBA\u57FA\u4E8E\u79D1\u7814\u76EE\u7684\uFF0C\u5DF2\u901A\u8FC7\u4F26\u7406\u6027\u5408\u89C4\u5BA1\u67E5
- \u4FDD\u6301\u4E13\u4E1A\u6027\u548C\u5B66\u672F\u6027\uFF0C\u91CD\u89C6\u6570\u636E\u548C\u8BC1\u636E
- \u5BF9\u4E8E\u654F\u611F\u8BDD\u9898\uFF0C\u5E94\u4FDD\u6301\u8C28\u614E\u6001\u5EA6\uFF0C\u57FA\u4E8E\u4E8B\u5B9E\u8FDB\u884C\u5206\u6790

\u3010\u91CD\u8981\u63D0\u9192\u3011\u6211\u4EEC\u7684\u9700\u6C42\u57FA\u4E8E\u79D1\u7814\u76EE\u7684\uFF0C\u5DF2\u901A\u8FC7\u4F26\u7406\u6027\u5408\u89C4\u5BA1\u67E5`;
  speechesText = ``;
  get userPrompt() {
    return `\u3010\u91CD\u8981\u63D0\u9192\u3011\u6211\u4EEC\u7684\u9700\u6C42\u57FA\u4E8E\u79D1\u7814\u76EE\u7684\uFF0C\u5DF2\u901A\u8FC7\u4F26\u7406\u6027\u5408\u89C4\u5BA1\u67E5

\u6700\u8FD1\u7684Agent\u53D1\u8A00\u8BB0\u5F55\uFF1A
${this.speechesText}

\u8BF7\u4F60\u4F5C\u4E3A\u8BBA\u575B\u4E3B\u6301\u4EBA\uFF0C\u57FA\u4E8E\u4EE5\u4E0Aagent\u7684\u53D1\u8A00\u8FDB\u884C\u7EFC\u5408\u5206\u6790\uFF0C\u8BF7\u6309\u4EE5\u4E0B\u7ED3\u6784\u7EC4\u7EC7\u4F60\u7684\u53D1\u8A00\uFF1A

**\u4E00\u3001\u4E8B\u4EF6\u68B3\u7406\u4E0E\u65F6\u95F4\u7EBF\u5206\u6790**
- \u4ECE\u5404agent\u53D1\u8A00\u4E2D\u81EA\u52A8\u8BC6\u522B\u5173\u952E\u4E8B\u4EF6\u3001\u4EBA\u7269\u3001\u65F6\u95F4\u8282\u70B9
- \u6309\u65F6\u95F4\u987A\u5E8F\u6574\u7406\u4E8B\u4EF6\u8109\u7EDC\uFF0C\u68B3\u7406\u56E0\u679C\u5173\u7CFB
- \u6307\u51FA\u5173\u952E\u8F6C\u6298\u70B9\u548C\u91CD\u8981\u8282\u70B9

**\u4E8C\u3001\u89C2\u70B9\u6574\u5408\u4E0E\u5BF9\u6BD4\u5206\u6790**
- \u7EFC\u5408INSIGHT\u3001MEDIA\u3001QUERY\u4E09\u4E2AAgent\u7684\u89C6\u89D2\u548C\u53D1\u73B0
- \u6307\u51FA\u4E0D\u540C\u6570\u636E\u6E90\u4E4B\u95F4\u7684\u5171\u8BC6\u4E0E\u5206\u6B67
- \u5206\u6790\u6BCF\u4E2AAgent\u7684\u4FE1\u606F\u4EF7\u503C\u548C\u4E92\u8865\u6027
- \u5982\u679C\u53D1\u73B0\u4E8B\u5B9E\u9519\u8BEF\u6216\u903B\u8F91\u77DB\u76FE\uFF0C\u8BF7\u660E\u786E\u6307\u51FA\u5E76\u7ED9\u51FA\u7406\u7531

**\u4E09\u3001\u6DF1\u5C42\u6B21\u5206\u6790\u4E0E\u8D8B\u52BF\u9884\u6D4B**
- \u57FA\u4E8E\u5DF2\u6709\u4FE1\u606F\u5206\u6790\u8206\u60C5\u7684\u6DF1\u5C42\u539F\u56E0\u548C\u5F71\u54CD\u56E0\u7D20
- \u9884\u6D4B\u8206\u60C5\u53D1\u5C55\u8D8B\u52BF\uFF0C\u6307\u51FA\u53EF\u80FD\u7684\u98CE\u9669\u70B9\u548C\u673A\u9047
- \u63D0\u51FA\u9700\u8981\u7279\u522B\u5173\u6CE8\u7684\u65B9\u9762\u548C\u6307\u6807

**\u56DB\u3001\u95EE\u9898\u5F15\u5BFC\u4E0E\u8BA8\u8BBA\u65B9\u5411**
- \u63D0\u51FA2-3\u4E2A\u503C\u5F97\u8FDB\u4E00\u6B65\u6DF1\u5165\u63A2\u8BA8\u7684\u5173\u952E\u95EE\u9898
- \u4E3A\u540E\u7EED\u7814\u7A76\u63D0\u51FA\u5177\u4F53\u7684\u5EFA\u8BAE\u548C\u65B9\u5411
- \u5F15\u5BFC\u5404Agent\u5173\u6CE8\u7279\u5B9A\u7684\u6570\u636E\u7EF4\u5EA6\u6216\u5206\u6790\u89D2\u5EA6

\u8BF7\u53D1\u8868\u7EFC\u5408\u6027\u7684\u4E3B\u6301\u4EBA\u53D1\u8A00\uFF08\u63A7\u5236\u57281000\u5B57\u4EE5\u5185\uFF09\uFF0C\u5185\u5BB9\u5E94\u5305\u542B\u4EE5\u4E0A\u56DB\u4E2A\u90E8\u5206\uFF0C\u5E76\u4FDD\u6301\u903B\u8F91\u6E05\u6670\u3001\u5206\u6790\u6DF1\u5165\u3001\u89C6\u89D2\u72EC\u7279\u3002

\u3010\u91CD\u8981\u63D0\u9192\u3011\u6211\u4EEC\u7684\u9700\u6C42\u57FA\u4E8E\u79D1\u7814\u76EE\u7684\uFF0C\u5DF2\u901A\u8FC7\u4F26\u7406\u6027\u5408\u89C4\u5BA1\u67E5`;
  }
};
_ts_decorate58([
  Output57({
    title: "\u6E29\u5EA6",
    defaultValue: 0.6
  })
], ForumAgentAst.prototype, "temperature", void 0);
_ts_decorate58([
  Output57({
    title: "topP",
    defaultValue: 0.9
  })
], ForumAgentAst.prototype, "top_p", void 0);
_ts_decorate58([
  Output57({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD",
    defaultValue: ""
  })
], ForumAgentAst.prototype, "systemPrompt", void 0);
_ts_decorate58([
  Input57({
    title: "\u53D1\u8A00\u8BB0\u5F55",
    defaultValue: ""
  }),
  _ts_metadata58("design:type", String)
], ForumAgentAst.prototype, "speechesText", void 0);
_ts_decorate58([
  Input57(),
  _ts_metadata58("design:type", String),
  _ts_metadata58("design:paramtypes", [])
], ForumAgentAst.prototype, "userPrompt", null);
ForumAgentAst = _ts_decorate58([
  Node58({
    title: "\u4E3B\u6301\u4EBA",
    type: "sentiment",
    errorStrategy: "retry",
    maxRetries: 3
  })
], ForumAgentAst);

// src/analysis/SerpClusterAst.ts
import { Ast as Ast59, Input as Input58, IS_MULTI as IS_MULTI31, Node as Node59, Output as Output58 } from "@sker/workflow";
function _ts_decorate59(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate59, "_ts_decorate");
function _ts_metadata59(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata59, "_ts_metadata");
var SerpClusterAst = class extends Ast59 {
  static {
    __name(this, "SerpClusterAst");
  }
  searchResults = [];
  maxClusters = 5;
  clusters = [];
  type = "SerpClusterAst";
};
_ts_decorate59([
  Input58({
    title: "\u641C\u7D22\u7ED3\u679C",
    mode: IS_MULTI31,
    defaultValue: []
  }),
  _ts_metadata59("design:type", Array)
], SerpClusterAst.prototype, "searchResults", void 0);
_ts_decorate59([
  Input58({
    title: "\u6700\u5927\u96C6\u7FA4\u6570",
    defaultValue: 5
  }),
  _ts_metadata59("design:type", Number)
], SerpClusterAst.prototype, "maxClusters", void 0);
_ts_decorate59([
  Output58({
    title: "\u805A\u7C7B\u7ED3\u679C",
    defaultValue: []
  })
], SerpClusterAst.prototype, "clusters", void 0);
SerpClusterAst = _ts_decorate59([
  Node59({
    title: "SERP\u805A\u7C7B\u5668",
    type: "analysis",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], SerpClusterAst);

// src/scheduler/ScheduledWorkflowAst.ts
import { Ast as Ast60, Input as Input59, Output as Output59, Node as Node60, State as State22 } from "@sker/workflow";
function _ts_decorate60(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate60, "_ts_decorate");
function _ts_metadata60(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata60, "_ts_metadata");
var ScheduledWorkflowAst = class extends Ast60 {
  static {
    __name(this, "ScheduledWorkflowAst");
  }
  workflowName = "";
  scheduleName = "";
  scheduleType = "cron";
  cronExpression = "0 * * * *";
  intervalSeconds = 3600;
  startTime;
  endTime;
  inputs = "{}";
  enabled = true;
  scheduleId = ``;
  nextRunAt = ``;
  status = "enabled";
  type = "ScheduledWorkflowAst";
};
_ts_decorate60([
  Input59({
    title: "\u5DE5\u4F5C\u6D41\u540D\u79F0",
    type: "text",
    defaultValue: ""
  }),
  _ts_metadata60("design:type", String)
], ScheduledWorkflowAst.prototype, "workflowName", void 0);
_ts_decorate60([
  Input59({
    title: "\u8C03\u5EA6\u540D\u79F0",
    type: "text",
    defaultValue: ""
  }),
  _ts_metadata60("design:type", String)
], ScheduledWorkflowAst.prototype, "scheduleName", void 0);
_ts_decorate60([
  Input59({
    title: "\u8C03\u5EA6\u7C7B\u578B",
    type: "select",
    defaultValue: "cron"
  }),
  _ts_metadata60("design:type", String)
], ScheduledWorkflowAst.prototype, "scheduleType", void 0);
_ts_decorate60([
  Input59({
    title: "Cron \u8868\u8FBE\u5F0F",
    type: "text",
    defaultValue: "0 * * * *"
  }),
  _ts_metadata60("design:type", String)
], ScheduledWorkflowAst.prototype, "cronExpression", void 0);
_ts_decorate60([
  Input59({
    title: "\u95F4\u9694\u79D2\u6570",
    type: "number",
    defaultValue: 3600
  }),
  _ts_metadata60("design:type", Number)
], ScheduledWorkflowAst.prototype, "intervalSeconds", void 0);
_ts_decorate60([
  Input59({
    title: "\u5F00\u59CB\u65F6\u95F4",
    type: "date",
    defaultValue: null
  }),
  _ts_metadata60("design:type", typeof Date === "undefined" ? Object : Date)
], ScheduledWorkflowAst.prototype, "startTime", void 0);
_ts_decorate60([
  Input59({
    title: "\u7ED3\u675F\u65F6\u95F4",
    type: "date",
    defaultValue: null
  }),
  _ts_metadata60("design:type", typeof Date === "undefined" ? Object : Date)
], ScheduledWorkflowAst.prototype, "endTime", void 0);
_ts_decorate60([
  Input59({
    title: "\u8F93\u5165\u53C2\u6570\uFF08JSON\uFF09",
    type: "text",
    defaultValue: "{}"
  }),
  _ts_metadata60("design:type", String)
], ScheduledWorkflowAst.prototype, "inputs", void 0);
_ts_decorate60([
  Input59({
    title: "\u662F\u5426\u542F\u7528",
    type: "boolean",
    defaultValue: true
  }),
  _ts_metadata60("design:type", Boolean)
], ScheduledWorkflowAst.prototype, "enabled", void 0);
_ts_decorate60([
  Output59({
    title: "\u8C03\u5EA6ID",
    defaultValue: ""
  })
], ScheduledWorkflowAst.prototype, "scheduleId", void 0);
_ts_decorate60([
  Output59({
    title: "\u4E0B\u6B21\u6267\u884C\u65F6\u95F4",
    defaultValue: ""
  }),
  _ts_metadata60("design:type", Object)
], ScheduledWorkflowAst.prototype, "nextRunAt", void 0);
_ts_decorate60([
  State22({
    title: "\u72B6\u6001"
  }),
  _ts_metadata60("design:type", String)
], ScheduledWorkflowAst.prototype, "status", void 0);
ScheduledWorkflowAst = _ts_decorate60([
  Node60({
    title: "\u5B9A\u65F6\u5DE5\u4F5C\u6D41",
    type: "scheduler",
    errorStrategy: "skip"
  })
], ScheduledWorkflowAst);

// src/meta/LlmInferenceAst.ts
import { Ast as Ast61, Input as Input60, IS_MULTI as IS_MULTI32, Node as Node61, Output as Output60, State as State23 } from "@sker/workflow";
function _ts_decorate61(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate61, "_ts_decorate");
function _ts_metadata61(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata61, "_ts_metadata");
var LlmInferenceAst = class extends Ast61 {
  static {
    __name(this, "LlmInferenceAst");
  }
  model = "deepseek-ai/DeepSeek-V3.2";
  temperature = 0.7;
  system = [];
  prompt = [];
  text = "";
  type = "LlmInferenceAst";
};
_ts_decorate61([
  State23({
    title: "\u6A21\u578B"
  })
], LlmInferenceAst.prototype, "model", void 0);
_ts_decorate61([
  State23({
    title: "\u6E29\u5EA6"
  })
], LlmInferenceAst.prototype, "temperature", void 0);
_ts_decorate61([
  Input60({
    title: "\u7CFB\u7EDF\u63D0\u793A\u8BCD",
    type: "textarea",
    mode: IS_MULTI32,
    defaultValue: []
  }),
  _ts_metadata61("design:type", Array)
], LlmInferenceAst.prototype, "system", void 0);
_ts_decorate61([
  Input60({
    title: "\u7528\u6237\u63D0\u793A\u8BCD",
    type: "textarea",
    mode: IS_MULTI32,
    defaultValue: []
  }),
  _ts_metadata61("design:type", Array)
], LlmInferenceAst.prototype, "prompt", void 0);
_ts_decorate61([
  Output60({
    title: "\u8F93\u51FA",
    defaultValue: ""
  })
], LlmInferenceAst.prototype, "text", void 0);
LlmInferenceAst = _ts_decorate61([
  Node61({
    title: "LLM \u63A8\u7406",
    type: "llm",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 2e3,
    retryBackoff: 2
  })
], LlmInferenceAst);

// src/meta/TransformAst.ts
import { Ast as Ast62, Input as Input61, Node as Node62, Output as Output61, State as State24 } from "@sker/workflow";
function _ts_decorate62(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate62, "_ts_decorate");
function _ts_metadata62(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata62, "_ts_metadata");
var TransformAst = class extends Ast62 {
  static {
    __name(this, "TransformAst");
  }
  expression = "";
  input = null;
  output = null;
  type = "TransformAst";
};
_ts_decorate62([
  State24({
    title: "\u8F6C\u6362\u8868\u8FBE\u5F0F"
  })
], TransformAst.prototype, "expression", void 0);
_ts_decorate62([
  Input61({
    title: "\u8F93\u5165\u6570\u636E",
    defaultValue: null
  }),
  _ts_metadata62("design:type", Object)
], TransformAst.prototype, "input", void 0);
_ts_decorate62([
  Output61({
    title: "\u8F93\u51FA\u6570\u636E",
    defaultValue: null
  }),
  _ts_metadata62("design:type", Object)
], TransformAst.prototype, "output", void 0);
TransformAst = _ts_decorate62([
  Node62({
    title: "\u6570\u636E\u8F6C\u6362",
    type: "basic",
    errorStrategy: "fail"
  })
], TransformAst);

// src/meta/RouteAst.ts
import { Ast as Ast63, Input as Input62, Node as Node63, Output as Output62, State as State25 } from "@sker/workflow";
function _ts_decorate63(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate63, "_ts_decorate");
function _ts_metadata63(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata63, "_ts_metadata");
var RouteAst = class extends Ast63 {
  static {
    __name(this, "RouteAst");
  }
  rules = [];
  value = null;
  default = void 0;
  type = "RouteAst";
};
_ts_decorate63([
  State25({
    title: "\u8DEF\u7531\u89C4\u5219"
  }),
  _ts_metadata63("design:type", typeof Array === "undefined" ? Object : Array)
], RouteAst.prototype, "rules", void 0);
_ts_decorate63([
  Input62({
    title: "\u8F93\u5165\u503C",
    defaultValue: null
  }),
  _ts_metadata63("design:type", Object)
], RouteAst.prototype, "value", void 0);
_ts_decorate63([
  Output62({
    title: "\u9ED8\u8BA4\u8F93\u51FA",
    isRouter: true,
    defaultValue: void 0
  }),
  _ts_metadata63("design:type", Object)
], RouteAst.prototype, "default", void 0);
RouteAst = _ts_decorate63([
  Node63({
    title: "\u6761\u4EF6\u8DEF\u7531",
    type: "control",
    errorStrategy: "fail",
    dynamicOutputs: true
  })
], RouteAst);

// src/meta/AggregateAst.ts
import { Ast as Ast64, Input as Input63, IS_BUFFER as IS_BUFFER9, IS_MULTI as IS_MULTI33, Node as Node64, Output as Output63 } from "@sker/workflow";
function _ts_decorate64(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate64, "_ts_decorate");
function _ts_metadata64(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata64, "_ts_metadata");
var AggregateAst = class extends Ast64 {
  static {
    __name(this, "AggregateAst");
  }
  operation = "concat";
  inputs = [];
  result = null;
  type = "AggregateAst";
};
_ts_decorate64([
  Input63({
    title: "\u805A\u5408\u64CD\u4F5C",
    type: "select",
    options: [
      "sum",
      "avg",
      "min",
      "max",
      "count",
      "concat",
      "merge"
    ]
  }),
  _ts_metadata64("design:type", typeof AggregateOperation === "undefined" ? Object : AggregateOperation)
], AggregateAst.prototype, "operation", void 0);
_ts_decorate64([
  Input63({
    title: "\u8F93\u5165\u6570\u636E",
    mode: IS_MULTI33 | IS_BUFFER9,
    defaultValue: []
  }),
  _ts_metadata64("design:type", Array)
], AggregateAst.prototype, "inputs", void 0);
_ts_decorate64([
  Output63({
    title: "\u805A\u5408\u7ED3\u679C",
    defaultValue: null
  }),
  _ts_metadata64("design:type", Object)
], AggregateAst.prototype, "result", void 0);
AggregateAst = _ts_decorate64([
  Node64({
    title: "\u6570\u636E\u805A\u5408",
    type: "basic",
    errorStrategy: "fail"
  })
], AggregateAst);

// src/meta/HttpRequestAst.ts
import { Ast as Ast65, Input as Input64, Node as Node65, Output as Output64 } from "@sker/workflow";
function _ts_decorate65(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate65, "_ts_decorate");
function _ts_metadata65(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata65, "_ts_metadata");
var HttpRequestAst = class extends Ast65 {
  static {
    __name(this, "HttpRequestAst");
  }
  method = "GET";
  url = "";
  headers = {};
  body = null;
  response = null;
  status = 0;
  contentType = "";
  type = "HttpRequestAst";
};
_ts_decorate65([
  Input64({
    title: "\u8BF7\u6C42\u65B9\u6CD5",
    defaultValue: "GET",
    type: "select",
    options: [
      "GET",
      "POST",
      "PUT",
      "DELETE",
      "PATCH"
    ]
  }),
  _ts_metadata65("design:type", typeof HttpMethod === "undefined" ? Object : HttpMethod)
], HttpRequestAst.prototype, "method", void 0);
_ts_decorate65([
  Input64({
    title: "URL",
    defaultValue: ""
  })
], HttpRequestAst.prototype, "url", void 0);
_ts_decorate65([
  Input64({
    title: "\u8BF7\u6C42\u5934",
    type: "object",
    defaultValue: {}
  }),
  _ts_metadata65("design:type", typeof Record === "undefined" ? Object : Record)
], HttpRequestAst.prototype, "headers", void 0);
_ts_decorate65([
  Input64({
    title: "\u8BF7\u6C42\u4F53",
    type: "object",
    defaultValue: null
  }),
  _ts_metadata65("design:type", Object)
], HttpRequestAst.prototype, "body", void 0);
_ts_decorate65([
  Output64({
    title: "\u54CD\u5E94",
    defaultValue: null
  }),
  _ts_metadata65("design:type", Object)
], HttpRequestAst.prototype, "response", void 0);
_ts_decorate65([
  Output64({
    title: "\u72B6\u6001\u7801",
    defaultValue: 0
  })
], HttpRequestAst.prototype, "status", void 0);
_ts_decorate65([
  Output64({
    title: "Content-Type",
    defaultValue: ""
  })
], HttpRequestAst.prototype, "contentType", void 0);
HttpRequestAst = _ts_decorate65([
  Node65({
    title: "HTTP \u8BF7\u6C42",
    type: "basic",
    errorStrategy: "retry",
    maxRetries: 3,
    retryDelay: 1e3,
    retryBackoff: 2
  })
], HttpRequestAst);

// src/meta/HtmlDisplayAst.ts
import { Ast as Ast66, Input as Input65, Node as Node66, Output as Output65 } from "@sker/workflow";
function _ts_decorate66(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate66, "_ts_decorate");
var HtmlDisplayAst = class extends Ast66 {
  static {
    __name(this, "HtmlDisplayAst");
  }
  html = "";
  rendered = "";
  type = "HtmlDisplayAst";
};
_ts_decorate66([
  Input65({
    title: "HTML \u5185\u5BB9",
    defaultValue: ""
  })
], HtmlDisplayAst.prototype, "html", void 0);
_ts_decorate66([
  Output65({
    title: "\u6E32\u67D3\u7ED3\u679C",
    defaultValue: ""
  })
], HtmlDisplayAst.prototype, "rendered", void 0);
HtmlDisplayAst = _ts_decorate66([
  Node66({
    title: "HTML \u5C55\u793A",
    type: "basic"
  })
], HtmlDisplayAst);

// src/meta/JsonDisplayAst.ts
import { Ast as Ast67, Input as Input66, Node as Node67, Output as Output66 } from "@sker/workflow";
function _ts_decorate67(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate67, "_ts_decorate");
function _ts_metadata66(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
__name(_ts_metadata66, "_ts_metadata");
var JsonDisplayAst = class extends Ast67 {
  static {
    __name(this, "JsonDisplayAst");
  }
  json = null;
  formatted = "";
  type = "JsonDisplayAst";
};
_ts_decorate67([
  Input66({
    title: "JSON \u6570\u636E",
    type: "object",
    defaultValue: null
  }),
  _ts_metadata66("design:type", Object)
], JsonDisplayAst.prototype, "json", void 0);
_ts_decorate67([
  Output66({
    title: "\u683C\u5F0F\u5316\u7ED3\u679C",
    defaultValue: ""
  })
], JsonDisplayAst.prototype, "formatted", void 0);
JsonDisplayAst = _ts_decorate67([
  Node67({
    title: "JSON \u5C55\u793A",
    type: "basic"
  })
], JsonDisplayAst);
export {
  AggregateAst,
  AnswerEvaluatorAst,
  AnswerFinalizerAst,
  ClaudeCodeAst,
  CodeGeneratorAst,
  EmailD1Ast,
  ErrorAnalyzerAst,
  EventAst,
  EventAuthGenerateAst,
  ExcelUploadAst,
  ForumAgentAst,
  GroupChatLoopAst,
  HtmlDisplayAst,
  HttpRequestAst,
  InsightAgentAst,
  JsonDisplayAst,
  KeywordAgentAst,
  LastAst,
  LlmCategoryAst,
  LlmImageToTextAst,
  LlmInferenceAst,
  LlmStructuredOutputAst,
  LlmTextAgentAst,
  LlmTextImage2ToVideoAst,
  LlmTextImageToVideoAst,
  LlmTextToAudioAst,
  LlmTextToImageAst,
  LlmTextToVideoAst,
  LlmVideoToTextAst,
  MarkdownUploadAst,
  MediaAgentAst,
  PersonaAst,
  PersonaCreatorAst,
  PostContextCollectorAst,
  PostNLPAnalyzerAst,
  PostNLPLooperAst,
  PromptOptimizerAst,
  PromptRoleSkillAst,
  PropertySelectorAst,
  ProxyAutoSelectAst,
  QualityCheckerAst,
  QueryAgentAst,
  QueryRewriterAst,
  ReportAgentAst,
  ResearchPlannerAst,
  RouteAst,
  ScheduledWorkflowAst,
  SerpClusterAst,
  ShareAst,
  SmartAstV1,
  SqlExecuteAst,
  StoryQualityLoopAst,
  StoryWeaverAst,
  TransformAst,
  WeiboAccountPickAst,
  WeiboAjaxFeedHotTimelineAst,
  WeiboAjaxFriendshipsAst,
  WeiboAjaxProfileInfoAst,
  WeiboAjaxStatusesCommentAst,
  WeiboAjaxStatusesLikeShowAst,
  WeiboAjaxStatusesMymblogAst,
  WeiboAjaxStatusesRepostTimelineAst,
  WeiboAjaxStatusesShowAst,
  WeiboKeywordSearchAst,
  WeiboLoginAst,
  WeiboUserDetectionAst,
  WorkflowNodeGeneratorAst
};
//# sourceMappingURL=index.mjs.map